/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable camelcase */
// TODO: need to eslint max length error and the nested ternary expressions error

import * as csv from 'csv-writer';
import {
	Cell,
	Column,
	Level,
	ColumnType,
	ElementStructure,
	ElementStructureUtils,
	PricingShutter,
	AxialLoadsData,
	PricingPartList,
	ShutterTotal,
} from './ElementStructureUtils';
import * as XLSX from '@sheet/image';
import { WorkSheet } from '@sheet/image';
import { ProjectEntity } from '../Models/Entities';
import { mapReverse, safeDivide } from 'Util/CodeUtils';
import { couplerData } from './CouplerData';
import { parseInt } from 'lodash';
import ShuttersTable from '../Views/Components/PricingComponents/ShuttersTable';

/**
 * TYPES FOR CSV/EXCEL GENERATION
 */
export interface ElementsCellData {
	cellName: string;
	quote_column: string;
	element_location: string;
	element_type: string;
	shape: string;
	width: number | string;
	thickness: number;
	height: number | string;
	slabThicknessAtBase: number;
	slabThicknessAtTop: number;
	ssl?: number;
	sslTop?: number;
	cellsSpanned: number;
	load?: number | string;
	designConfig: string;
	aptusBarType?: string;
	aptusBarsWidth?: number;
	aptusBarsDepth?: number;
	aptusBarsTotal?: number;
	aptusBarLigSpacing?: number;
	aptusBarLigType?: string;
	nonAptusBarType?: string;
	nonAptusBarsWidth?: number;
	nonAptusBarsDepth?: number;
	nonAptusBarsTotal?: number;
	nonAptusBarLigType?: string;
	nonAptusBarLigSpacing?: number;
	approved: string;
	constructionZone: string;
	kFactor?: number;
	verticalReoPercentage?: string;
	ligDesign?: string;
	concrete_strength: string;
	reoRate?: number;
}

export interface ScheduleOfRatesCellData {
	element_name: string;
	element_location: string;
	element_dimensions: string;
	element_height: number;
	element_mass: number;
	element_type: string;
	concrete_volume: number;
	concrete_strength: string;
	total_aptus_cost: number;
	aptus_bars_conv_bars: string;
	horizontal_rebar: string;
	quote_column: string;
	insitu_starter_bar_qty: number | string;
	insitu_starter_bar_length: number | string;
	insitu_starter_bar_aptus_bar_type: string;
	insitu_starter_bar_rate: number | string;
	insitu_inner_coupler_type: string;
	insitu_inner_coupler_rate: number | string;
	insitu_inner_coupler_qty: number | string;
	insitu_socket_ext_qty: number | string;
	insitu_socket_ext_length: number | string;
	insitu_socket_ext_type: string;
	insitu_socket_ext_rate: number | string;
	outer_coupler_qty: number | string;
	outer_coupler_type: string;
	outer_coupler_rate: number | string;
	aptus_bar_qty: number | string;
	aptus_bar_length: number | string;
	aptus_bar_type: string;
	aptus_bar_rate: number | string;
	starter_bar_qty: number | string;
	starter_bar_length: number | string;
	starter_bar_type: string;
	starter_bar_rate: number | string;
	inner_coupler_qty: number | string;
	inner_coupler_type: string;
	inner_coupler_rate: number | string;
	socket_ext_qty: number | string;
	socket_ext_length: number | string;
	socket_ext_type: string;
	socket_ext_rate: number | string;
	threaded_anchor_qty: number | string;
	threaded_anchor_type: string;
	threaded_anchor_rate: number | string;
	aptus_bar_rebar: number;
	non_aptus_rebar: number;

}

export interface WorksCellData {
	cellName: string;
	quote_column: string;
	element_location: string;
	shape: string;
	width: number | string;
	depth: number;
	height?: number,
	cellsSpanned: number;
	tempWorksBarQty?: number;
	tempWorksBarType?: string;
	tempWorksBarsWidth?: number;
	tempWorksBarsDepth?: number;
	currentAptusDesign: string;
	tempWorksWindLoad?: number;
	tempWorksCfig?: number;
	approved: 'Yes' | 'No';
 }

export interface ShutterData {
	shutterName: string;
	shutterQuantity: number;
	shutterRate: number;
	shutterTotal: number;
	calculatedFullUsageQty: number;
	siteTemplateQuantity: number;
	siteTemplateRate: number;
	siteTemplateTotal: number;
	[key: string]: string | number;
}

export interface BarPartsSummaryData {
	partName: string;
	ave_length: number;
	qty: number;
	ave_rate: number;
	total: number;
}

export interface ItemPartsSummaryData {
	partName: string;
	item: string;
	qty: number;
	ave_rate: number;
	total: number;
}

export enum TableTitle {
	ProjectInformation = 'Project Information',
	ElementTable = 'Element Table',
	ElementList = 'Element List',
	ScheduleOfRates = 'Schedule of Rates',
	TemporaryWorks = 'Temporary Works',
	Shutters = 'Shutters',
	CostSummary = 'Cost Summary',
	Data = 'DATA',
}

interface dataExportHeader {
	id: string,
	title: string,
	columnWidth?: number,
}

export abstract class DataExportUtils {
	/**
	 * CSV Headers
	 */

	private static elementListHeaders = [
		{ id: 'cellName', title: 'Element Name', columnWidth: 12 },
		{ id: 'quote_column', title: 'Element Number', columnWidth: 12 },
		{ id: 'element_location', title: 'Element Location', columnWidth: 12 },
		{ id: 'element_type', title: 'Element Type', columnWidth: 18 },
		{ id: 'shape', title: 'Element Shape', columnWidth: 12 },
		{ id: 'width', title: 'Width (mm)', columnWidth: 9 },
		{ id: 'thickness', title: 'Depth (mm)', columnWidth: 9 },
		{ id: 'height', title: 'Height (mm)', columnWidth: 9 },
		{ id: 'slabThicknessBelow', title: 'Slab Depth at Base (mm)', columnWidth: 12 },
		{ id: 'slabThickness', title: 'Slab Depth at Top (mm)', columnWidth: 12 },
		{ id: 'ssl', title: 'SSL at Base of Element (m)', columnWidth: 13 },
		{ id: 'sslTop', title: 'SSL at Top of Element (m)', columnWidth: 13 },
		{ id: 'cellsSpanned', title: 'Levels Spanned', columnWidth: 9 },
		{ id: 'load', title: 'Loads (kN)', columnWidth: 8 },
		{ id: 'designConfig', title: 'Design Config.', columnWidth: 15 },
		{ id: 'aptusBarType', title: 'Aptus Bar Type', columnWidth: 8 },
		{ id: 'aptusBarsWidth', title: 'Aptus Bars along Width', columnWidth: 8 },
		{ id: 'aptusBarsDepth', title: 'Aptus Bars along Depth', columnWidth: 8 },
		{ id: 'aptusBarsTotal', title: 'Total\nAptus Bars', columnWidth: 8 },
		{ id: 'aptusBarLigType', title: 'Aptus Bar Lig Type', columnWidth: 8 },
		{ id: 'aptusBarLigSpacing', title: 'Aptus Bar Lig Spacing', columnWidth: 8 },
		{ id: 'nonAptusBarType', title: 'Non-Aptus Bar Type', columnWidth: 8 },
		{ id: 'nonAptusBarsWidth', title: 'Non-Aptus Bars Along Width', columnWidth: 8 },
		{ id: 'nonAptusBarsDepth', title: 'Non-Aptus Bars Along Depth', columnWidth: 8 },
		{ id: 'nonAptusBarsTotal', title: 'Total Non-Aptus Bars', columnWidth: 8 },
		{ id: 'nonAptusBarLigType', title: 'Non-Aptus Bar Lig Type', columnWidth: 8 },
		{ id: 'nonAptusBarLigSpacing', title: 'Non-Aptus Bar Lig Spacing', columnWidth: 8 },
		{ id: 'concrete_strength', title: 'Concrete Strength (MPa)', columnWidth: 15 },
		{ id: 'constructionZone', title: 'Construction Zone', columnWidth: 15 },
		{ id: 'kFactor', title: 'Effective Length Factor', columnWidth: 15 },
		{ id: 'vertReoPercentage', title: 'APTUS Vertical Reo Percentage', columnWidth: 15 },
		{ id: 'ligDesign', title: 'Horizontal Reo Type', columnWidth: 30 },
		{ id: 'approved', title: 'Design Approved', columnWidth: 10 },
	];

	private static elementListSheetHeaders = [
		[
			{ title: 'Element\nName', doubleHeight: true },
			{ title: 'Element\nNumber', doubleHeight: true },
			{ title: 'Element\nLocation', doubleHeight: true },
			{ title: 'Element\nType', doubleHeight: true },
			{ title: 'Element\nShape', doubleHeight: true },
			{ title: 'Width\n(mm)', doubleHeight: true },
			{ title: 'Depth\n(mm)', doubleHeight: true },
			{ title: 'Height\n(mm)', doubleHeight: true },
			{ title: 'Slab Depth\nat Base (mm)', doubleHeight: true },
			{ title: 'Slab Depth\nat Top (mm)', doubleHeight: true },
			{ title: 'SSL at Base of\nElement (m)', doubleHeight: true },
			{ title: 'SSL at Top of\nElement (m)', doubleHeight: true },
			{ title: 'Levels\nSpanned', doubleHeight: true },
			{ title: 'Load\n(kN)', doubleHeight: true },
			{ title: 'Design\nConfig.', doubleHeight: true },
			{ title: 'Aptus Bars', cellWidth: 4 },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Aptus Ligs', cellWidth: 2 },
			{ title: '' },
			{ title: 'Non-Aptus Bars', cellWidth: 4 },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Non-Aptus Ligs', cellWidth: 2 },
			{ title: '' },
			{ title: 'Concrete\nStrength (MPa)', doubleHeight: true },
			{ title: 'Construction\nZone', doubleHeight: true },
			{ title: 'Effective Length\n Factor', doubleHeight: true },
			{ title: 'APTUS Vertical Reo Percentage', doubleHeight: true },
			{ title: 'Horizontal Reo Type', doubleHeight: true },
			{ title: 'Design\nApproved', doubleHeight: true },
			{ title: 'Reo Rate (kg/m³)', doubleHeight: true },
		],
		[
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Type' },
			{ title: 'Width' },
			{ title: 'Depth' },
			{ title: 'Total' },
			{ title: 'Type' },
			{ title: 'Spacing' },
			{ title: 'Type' },
			{ title: 'Width' },
			{ title: 'Depth' },
			{ title: 'Total' },
			{ title: 'Type' },
			{ title: 'Spacing' },
			{ title: '' },
			{ title: '' },

		],
	];

	private static scheduleOfRatesHeaders = [
		{ id: 'element_name', title: 'Element Name', columnWidth: 10 },
		{ id: 'total_aptus_cost', title: 'Total Aptus Amount', columnWidth: 12 },
		{ id: 'quote_column', title: 'Element Number', columnWidth: 10 },
		{ id: 'element_location', title: 'Element Location', columnWidth: 12 },
		{ id: 'element_dimensions', title: 'Element Dimensions', columnWidth: 12 },
		{ id: 'element_height', title: 'Element Height (mm)', columnWidth: 12 },
		{ id: 'element_mass', title: 'Element Mass (t)', columnWidth: 9 },
		{ id: 'concrete_volume', title: 'Concrete Volume (m³)', columnWidth: 12 },
		{ id: 'concrete_strength', title: 'Concrete Strength (MPa)', columnWidth: 15 },
		{ id: 'aptus_bars_conv_bars', title: 'Aptus Bars + Conv. Bars', columnWidth: 22 },
		{ id: 'horizontal_rebar', title: 'Horizontal Rebar', columnWidth: 18 },
		{ id: 'insitu_starter_bar_qty', title: 'Insitu Starter Bar Qty', columnWidth: 8 },
		{ id: 'insitu_starter_bar_length', title: 'Insitu Starter Bar Length (mm)', columnWidth: 13 },
		{ id: 'insitu_starter_bar_aptus_bar_type', title: 'Insitu Starter Bar Aptus Bar Type', columnWidth: 18 },
		{ id: 'insitu_starter_bar_rate', title: 'Insitu Starter Bar Rate', columnWidth: 11 },
		{ id: 'insitu_inner_coupler_qty', title: 'Insitu Inner Coupler Qty', columnWidth: 8 },
		{ id: 'insitu_inner_coupler_type', title: 'Insitu Inner Coupler Type', columnWidth: 18 },
		{ id: 'insitu_inner_coupler_rate', title: 'Insitu Inner Coupler Rate', columnWidth: 11 },
		{ id: 'insitu_socket_ext_qty', title: 'Insitu Extension Bar Qty', columnWidth: 8 },
		{ id: 'insitu_socket_ext_length', title: 'Insitu Extension Bar Length', columnWidth: 8 },
		{ id: 'insitu_socket_ext_type', title: 'Insitu Extension Bar Type', columnWidth: 18 },
		{ id: 'insitu_socket_ext_rate', title: 'Insitu Extension Bar Rate', columnWidth: 11 },
		{ id: 'outer_coupler_qty', title: 'Outer Coupler Qty', columnWidth: 8 },
		{ id: 'outer_coupler_type', title: 'Outer Coupler Type', columnWidth: 18 },
		{ id: 'outer_coupler_rate', title: 'Outer Coupler Rate', columnWidth: 11 },
		{ id: 'aptus_bar_qty', title: 'Aptus Bar Qty', columnWidth: 8 },
		{ id: 'aptus_bar_length', title: 'Aptus Bar Length (mm)', columnWidth: 13 },
		{ id: 'aptus_bar_type', title: 'Aptus Bar Type', columnWidth: 18 },
		{ id: 'aptus_bar_rate', title: 'Aptus Bar Rate', columnWidth: 11 },
		{ id: 'starter_bar_qty', title: 'Starter Bar Qty', columnWidth: 8 },
		{ id: 'starter_bar_length', title: 'Starter Bar Length (mm)', columnWidth: 13 },
		{ id: 'starter_bar_type', title: 'Starter Bar Type', columnWidth: 18 },
		{ id: 'starter_bar_rate', title: 'Starter Bar Rate', columnWidth: 11 },
		{ id: 'inner_coupler_qty', title: 'Inner Coupler Qty', columnWidth: 8 },
		{ id: 'inner_coupler_type', title: 'Inner Coupler Type', columnWidth: 18 },
		{ id: 'inner_coupler_rate', title: 'Inner Coupler Rate', columnWidth: 11 },
		{ id: 'socket_ext_qty', title: 'Extension Bar Qty', columnWidth: 8 },
		{ id: 'socket_ext_length', title: 'Extension Bar Length', columnWidth: 8 },
		{ id: 'socket_ext_type', title: 'Extension Bar Type', columnWidth: 18 },
		{ id: 'socket_ext_rate', title: 'Extension Bar Rate', columnWidth: 11 },
		{ id: 'threaded_anchor_qty', title: 'Threaded Anchor Qty', columnWidth: 8 },
		{ id: 'threaded_anchor_type', title: 'Threaded Anchor Type', columnWidth: 18 },
		{ id: 'threaded_anchor_rate', title: 'Threaded Anchor Rate', columnWidth: 11 },
		{ id: 'aptus_bar_rebar', title: 'Aptus Bar Rebar Mass (kg)', columnWidth: 20 },
		{ id: 'non_aptus_rebar', title: 'Non Aptus Rebar Mass (kg)', columnWidth: 25 },
	];

	private static scheduleOfRatesSheetHeaders = [
		[
			{ title: 'Element\nName', doubleHeight: true },
			{ title: 'Element Type', doubleHeight: true },
			{ title: 'Element\nNumber', doubleHeight: true },
			{ title: 'Element\nLocation', doubleHeight: true },
			{ title: 'Element\nDimensions', doubleHeight: true },
			{ title: 'Element\nHeight (mm)', doubleHeight: true },
			{ title: 'Element\nMass (t)', doubleHeight: true },
			{ title: 'Concrete\nVolume (m³)', doubleHeight: true },
			{ title: 'Concrete\nStrength (MPa)', doubleHeight: true },
			{ title: 'Rebar Configuration', cellWidth: 2 },
			{ title: '' },
			{ title: 'In-situ Starter Bars & Inner Couplers + Extension Bars (if req\'d)', cellWidth: 10 },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Outer Couplers (at base)', cellWidth: 3 },
			{ title: '' },
			{ title: '' },
			{ title: 'Aptus Bars (within element)', cellWidth: 4 },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Aptus Starter Bars (within element)', cellWidth: 4 },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Inner Couplers (at top) + Extension Bars (if req\'d)', cellWidth: 6 },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Aptus Threaded Anchors', cellWidth: 3 },
			{ title: '' },
			{ title: '' },
			{ title: 'Total Aptus\nAmount', doubleHeight: true },
			{ title: 'Estimated Rebar Totals', cellWidth: 2 },
			{ title: '' },
		],
		[
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },

			{ title: 'Aptus Bars + Conv. Bars' },
			{ title: 'Vertical & Horizontal Rebar' },
			{ title: 'Ties/Ligs' },

			{ title: 'Qty' },
			{ title: 'Length (mm)' },
			{ title: 'Aptus Bar Type' },
			{ title: 'Rate' },
			{ title: 'Qty' },
			{ title: 'Inner Coupler' },
			{ title: 'Rate' },
			{ title: 'Qty' },
			{ title: 'Length' },
			{ title: 'Extension Bar' },
			{ title: 'Rate' },

			{ title: 'Qty' },
			{ title: 'Outer Coupler' },
			{ title: 'Rate' },

			{ title: 'Qty' },
			{ title: 'Length (mm)' },
			{ title: 'Aptus Bar' },
			{ title: 'Rate' },

			{ title: 'Qty' },
			{ title: 'Length (mm)' },
			{ title: 'Aptus Bar' },
			{ title: 'Rate' },

			{ title: 'Qty' },
			{ title: 'Inner Coupler' },
			{ title: 'Rate' },
			{ title: 'Qty' },
			{ title: 'Length' },
			{ title: 'Extension Bar' },
			{ title: 'Rate' },

			{ title: 'Qty' },
			{ title: 'Anchor Assembly' },
			{ title: 'Rate' },

			{ title: '' },
			{ title: 'Aptus Bar Mass (kg)' },
			{ title: 'Non Aptus Rebar Mass (kg)' },
		],
	];

	private static tempWorksHeaders = [
		{ id: 'cellName', title: 'Element Name', columnWidth: 10 },
		{ id: 'quote_column', title: 'Element Number', columnWidth: 10 },
		{ id: 'element_location', title: 'Element Location', columnWidth: 12 },
		{ id: 'shape', title: 'Element Shape', columnWidth: 11 },
		{ id: 'width', title: 'Width (mm)', columnWidth: 7 },
		{ id: 'depth', title: 'Depth (mm)', columnWidth: 7 },
		{ id: 'height', title: 'Height (mm)', columnWidth: 7 },
		{ id: 'cellsSpanned', title: 'Levels Spanned', columnWidth: 9 },
		{ id: 'tempWorksBarQty', title: 'Temporary Works Total Bars', columnWidth: 10 },
		{ id: 'tempWorksBarType', title: 'Temporary Works Bar Type', columnWidth: 9 },
		{ id: 'tempWorksBarsWidth', title: 'Temporary Works Bars Along Width', columnWidth: 12 },
		{ id: 'tempWorksBarsDepth', title: 'Temporary Works Bars Along Depth', columnWidth: 12 },
		{ id: 'currentAptusDesign', title: 'Current Aptus Design', columnWidth: 22 },
		{ id: 'approved', title: 'Design Approved', columnWidth: 10 },
		{ id: 'tempWorksWindLoad', title: 'Wind Load', columnWidth: 12 },
		{ id: 'tempWorkCfig', title: 'Wind Aerodynamic Shape Factor', columnWidth: 20 },

	];

	private static tempWorksSheetHeaders = [
		[
			{ title: 'Element\nName', doubleHeight: true },
			{ title: 'Element\nNumber', doubleHeight: true },
			{ title: 'Element\nLocation', doubleHeight: true },
			{ title: 'Element\nShape', doubleHeight: true },
			{ title: 'Width\n(mm)', doubleHeight: true },
			{ title: 'Depth\n(mm)', doubleHeight: true },
			{ title: 'Height\n(mm)', doubleHeight: true },
			{ title: 'Levels\nSpanned', doubleHeight: true },
			{ title: 'Minimum Temporary Works Requirements', cellWidth: 4 },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Current\nAptus Design', doubleHeight: true },
			{ title: 'Design\nApproved', doubleHeight: true },
			{ title: 'Wind\nLoad (qz)', doubleHeight: true },
			{ title: 'Wind Aerodynamic\nShape Factor (Cfig)', doubleHeight: true },
		],
		[
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: 'Total Bars' },
			{ title: 'Bar Type' },
			{ title: 'Along Width' },
			{ title: 'Along Depth' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
			{ title: '' },
		],
	];

	private static shutterHeaders: dataExportHeader[] = [
		{ id: 'shutterName', title: 'Shutter Type', columnWidth: 29 },
		{ id: 'shutterQuantity', title: 'Shutter Est.\nQty', columnWidth: 11 },
		{ id: 'shutterRate', title: 'Shutter Pair\nRate', columnWidth: 12 },
		{ id: 'shutterTotal', title: 'Shutter\nAmount', columnWidth: 10 },
		{ id: 'siteTemplateFullUsage', title: 'Site Template Required for 100% Usage', columnWidth: 15 },
		{ id: 'siteTemplateQuantity', title: 'Site Template\nEst. Qty', columnWidth: 13 },
		{ id: 'siteTemplateRate', title: 'Site Template\nRate', columnWidth: 13 },
		{ id: 'siteTemplateTotal', title: 'Site Template\nAmount', columnWidth: 13 },
	];

	private static shuttersPerLevelColumnWidth = 6;

	private static axialLoadHeaders = [
		{ id: 'levelName', title: 'Level' },
		{ id: 'columnName', title: 'Element Number' },
		{ id: 'load', title: 'N* (kN)' },
		{ id: 'majorAxisMoment', title: 'Major Axis Moment (kN.m)' },
		{ id: 'minorAxisMoment', title: 'Minor Axis Moment (kN.m)' },
	];

	private static CostSummaryHeaders: any[][] = [];

	// The headers can have newlines, and we don't want that for CSV headers
	private static getCSVHeaders(headers: dataExportHeader[]): dataExportHeader[] {
		return headers.map(header => {
			return {
				id: header.id,
				title: header.title.replace('\n', ' '),
			};
		});
	}

	static getCellHorizontalReoDesign(cell: Cell): 'Wall' | 'Column' | undefined {
		if (cell.aptusDesignConfiguration === 'aptus' && cell.ligDesign) {
			return cell.ligDesign.toLowerCase().includes('column')
				? 'Column'
				: 'Wall';
		}

		if (cell.aptusDesignConfiguration === 'custom') {
			if (cell.designOverride) {
				return cell.designOverride;
			}
			const { width, depth, nonAptusBarLigSpacing } = cell;
			return ElementStructureUtils.determineAptusCustomDefaultHorizontalReoDesign(width, depth, nonAptusBarLigSpacing);
		}
		return undefined;
	}

	/**
	 * CSV Generation
	 */

	static generateElementsListCellData(cell: Cell, columnType: ColumnType, column: Column, level: Level, elementStructure: ElementStructure): ElementsCellData {
		let cellWidth: number | string;

		if (cell.shape === 'rectangular') {
			cellWidth = cell.width !== undefined ? parseFloat(cell.width.toFixed(0)) : 0;
		} else {
			cellWidth = 'N/A';
		}

		const cellAbove = ElementStructureUtils.findCellAboveGivenCell(elementStructure, cell);

		const nonAptusBarsTotal = ElementStructureUtils.nonAptusBarQuantity(cell.shape, cell.nonAptusBarsAlongWidth, cell.nonAptusBarsAlongDepth, cell.aptusDesignConfiguration);
		const aptusBarsTotal = ElementStructureUtils.aptusBarQuantity(cell.shape, cell.aptusBarsAlongWidth, cell.aptusBarsAlongDepth);
		const couplerDataArea = couplerData.find(data => data.barSize === cell.aptusBarType)?.data.A;
		let verticalReoPercentage;
		if (aptusBarsTotal && couplerDataArea) verticalReoPercentage = ((aptusBarsTotal * couplerDataArea) / ((cell.width ?? cell.depth) * cell.depth)) * 100;

		let aptusDesignConfigString = '';
		switch (cell.aptusDesignConfiguration) {
			case 'aptus':
				aptusDesignConfigString = 'Aptus-Design';
				break;
			case 'custom':
				aptusDesignConfigString = 'Aptus-Custom';
				break;
			case 'nonaptus':
				if (cell.insituElement) aptusDesignConfigString = 'In-Situ';
				else { aptusDesignConfigString = 'Non-Aptus'; }
				break;
		}

		const horizontalReoType = DataExportUtils.getCellHorizontalReoDesign(cell) !== undefined
			? DataExportUtils.getCellHorizontalReoDesign(cell) === 'Column'
				? 'Column Ties'
				: 'Wall Reo as per 11.7.4.AS3600'
			: ' ';

		return {
			cellName: `${level.code}-${columnType.code}${column.name}`,
			quote_column: columnType.code + column.name,
			element_location: level.name,
			element_type: columnType.name,
			shape: cell.shape,
			width: cellWidth,
			thickness: parseFloat(cell.depth.toFixed(0)),
			height: cell.height ? parseFloat(cell.height.toFixed(0)) : '',
			slabThicknessAtBase: parseFloat(cell.slabThicknessAtBase.toFixed(0)),
			slabThicknessAtTop: (cellAbove ? cellAbove.slabThicknessAtBase : parseFloat((cell.slabThicknessAtTop || ElementStructureUtils.defaultSlabThickness).toFixed(0))),
			ssl: parseFloat(ElementStructureUtils.cellBottomSSL(elementStructure, cell).toFixed(3)),
			sslTop: parseFloat(ElementStructureUtils.cellTopSSL(elementStructure, cell).toFixed(3)),
			cellsSpanned: cell.levelHeight,
			load: cell.calculatedLoad ? cell.calculatedLoad.toFixed(0) : 0,
			designConfig: aptusDesignConfigString,

			// APTUS BARS
			aptusBarType: cell.aptusDesignConfiguration === 'nonaptus' ? undefined : cell.aptusBarType,
			aptusBarsWidth: cell.aptusDesignConfiguration === 'nonaptus' ? undefined : cell.aptusBarsAlongWidth,
			aptusBarsDepth: cell.aptusDesignConfiguration === 'nonaptus' ? undefined : cell.aptusBarsAlongDepth,
			aptusBarsTotal: cell.aptusDesignConfiguration === 'nonaptus' ? undefined : ElementStructureUtils.aptusBarQuantity(cell.shape, cell.aptusBarsAlongWidth, cell.aptusBarsAlongDepth),

			// APTUS LIGS
			aptusBarLigType: cell.aptusDesignConfiguration === 'nonaptus' ? undefined : cell.aptusBarLigType,
			aptusBarLigSpacing: cell.aptusDesignConfiguration === 'nonaptus' ? undefined : cell.aptusBarLigSpacing,

			// NONAPTUS BARS
			nonAptusBarType: (!ElementStructureUtils.isInsitu(cell) && !ElementStructureUtils.shouldUseReoRate(cell) && nonAptusBarsTotal) ? cell.nonAptusBarType : undefined,
			nonAptusBarsWidth: (!ElementStructureUtils.isInsitu(cell) && !ElementStructureUtils.shouldUseReoRate(cell) && nonAptusBarsTotal) ? cell.nonAptusBarsAlongWidth : undefined,
			nonAptusBarsDepth: (!ElementStructureUtils.isInsitu(cell) && !ElementStructureUtils.shouldUseReoRate(cell) && nonAptusBarsTotal) ? cell.nonAptusBarsAlongDepth : undefined,
			nonAptusBarsTotal: ElementStructureUtils.isInsitu(cell) || ElementStructureUtils.shouldUseReoRate(cell) ? undefined : nonAptusBarsTotal,

			// NON-APTUS LIGS
			nonAptusBarLigType: ElementStructureUtils.isInsitu(cell) || ElementStructureUtils.shouldUseReoRate(cell) ? undefined : cell.nonAptusBarLigSpacing ? cell.nonAptusBarLigType : undefined,
			nonAptusBarLigSpacing: ElementStructureUtils.isInsitu(cell) || ElementStructureUtils.shouldUseReoRate(cell) ? undefined : cell.nonAptusBarLigSpacing ? cell.nonAptusBarLigSpacing : undefined,

			concrete_strength: ElementStructureUtils.concreteStrengthString(cell),
			constructionZone: cell.constructionZone ?? '1',
			kFactor: cell.kFactor ? cell.kFactor : 0.85,
			verticalReoPercentage: (ElementStructureUtils.isInsitu(cell) || ElementStructureUtils.shouldUseReoRate(cell)) ? ' ' : verticalReoPercentage?.toFixed(2) ?? undefined,
			ligDesign: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : horizontalReoType,
			approved: cell.approved ? 'Yes' : 'No',
			reoRate: ElementStructureUtils.shouldUseReoRate(cell) ? cell.reoRate : undefined,
		};
	}

	static generateScheduleOfRatesCellData(cell: Cell, columnType: ColumnType, column: Column, level: Level, elementStructure: ElementStructure): ScheduleOfRatesCellData {
		let partData: PricingPartList = {};
		if (cell.parts && cell.aptusDesignConfiguration !== 'nonaptus') {
			partData = cell.parts;
		}

		return {
			element_name: `${level.code}-${columnType.code}${column.name}`,
			element_type: columnType.name,
			quote_column: columnType.code + column.name,
			element_location: level.name,
			element_dimensions: ElementStructureUtils.cellDimensionString(cell),
			element_height: parseFloat(cell.height ? cell.height.toFixed(0) : '0'),
			element_mass: parseFloat(cell.unitMass ? cell.unitMass.toFixed(2) : '0'),
			concrete_volume: parseFloat(cell.unitMass ? (cell.unitMass / 2.55).toFixed(2) : '0'),
			concrete_strength: ElementStructureUtils.concreteStrengthString(cell),
			aptus_bars_conv_bars: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : ElementStructureUtils.cellAptusDesignString(cell),
			horizontal_rebar: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : ElementStructureUtils.cellLigatureDesignString(cell),
			insitu_starter_bar_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterBars ? partData.insituStarterBars.quantity.toString() : '',
			insitu_starter_bar_length: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterBars ? (partData.insituStarterBars.length * 1000).toFixed(0) : '',
			insitu_starter_bar_aptus_bar_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterBars ? partData.insituStarterBars.partName : '',
			insitu_starter_bar_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterBars ? partData.insituStarterBars.price : '',
			insitu_inner_coupler_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterInnerCouplers ? partData.insituStarterInnerCouplers.quantity : '',
			insitu_inner_coupler_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterInnerCouplers ? partData.insituStarterInnerCouplers.partName : '',
			insitu_inner_coupler_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterInnerCouplers ? partData.insituStarterInnerCouplers.price : '',
			insitu_socket_ext_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterExtensions ? partData.insituStarterExtensions.quantity : '',
			insitu_socket_ext_length: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterExtensions && partData.insituStarterExtensions.length !== null && partData.insituStarterExtensions.length !== undefined ? partData.insituStarterExtensions.length : '',
			insitu_socket_ext_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterExtensions ? partData.insituStarterExtensions.partName : '',
			insitu_socket_ext_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !cell.disableInsituStarters && partData.insituStarterExtensions ? partData.insituStarterExtensions.price : '',
			outer_coupler_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !(partData.insituStarterBars && cell.disableInsituStarters) && partData.outerCouplers ? partData.outerCouplers.quantity : '',
			outer_coupler_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !(partData.insituStarterBars && cell.disableInsituStarters) && partData.outerCouplers ? partData.outerCouplers.partName : '',
			outer_coupler_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : !(partData.insituStarterBars && cell.disableInsituStarters) && partData.outerCouplers ? partData.outerCouplers.price : '',
			aptus_bar_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.bars ? partData.bars.quantity : '',
			aptus_bar_length: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.bars ? parseFloat((partData.bars.length * 1000).toFixed(0)) : '',
			aptus_bar_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.bars ? partData.bars.barName : '',
			aptus_bar_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.bars ? partData.bars.combinedPrice : '',
			starter_bar_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.starterBars ? partData.starterBars.quantity : '',
			starter_bar_length: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.starterBars ? parseFloat((partData.starterBars.length * 1000).toFixed(0)) : '',
			starter_bar_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.starterBars ? partData.starterBars.partName : '',
			starter_bar_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.starterBars ? partData.starterBars.price : '',
			inner_coupler_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.innerCouplers ? partData.innerCouplers.quantity : '',
			inner_coupler_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.innerCouplers ? partData.innerCouplers.partName : '',
			inner_coupler_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.innerCouplers ? partData.innerCouplers.price : '',
			socket_ext_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.extensions ? partData.extensions.quantity : '',
			socket_ext_length: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.extensions && partData.extensions.length !== null && partData.extensions.length !== undefined ? partData.extensions.length : '',
			socket_ext_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.extensions ? partData.extensions.partName : '',
			socket_ext_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.extensions ? partData.extensions.price : '',
			threaded_anchor_qty: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.anchorHeads ? partData.anchorHeads.quantity : '',
			threaded_anchor_type: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.anchorHeads ? partData.anchorHeads.partName : '',
			threaded_anchor_rate: ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : partData.anchorHeads ? partData.anchorHeads.price : '',
			total_aptus_cost: parseFloat(ElementStructureUtils.cellPrices(cell).total.toFixed(2)),
			aptus_bar_rebar: cell.aptusDesignConfiguration === 'nonaptus' && cell.insituElement
				? 0.0
				: parseFloat(ElementStructureUtils.calculateAptusRebarMass(cell).toFixed(2)),
			non_aptus_rebar: !cell.insituElement
				? ElementStructureUtils.shouldUseReoRate(cell)
					? parseFloat(ElementStructureUtils.calculateRebarMassFromReoRate(elementStructure, cell).toFixed(2))
					: parseFloat(ElementStructureUtils.calculateNonAptusRebarMass(elementStructure, cell).toFixed(2))
				: 0.0,
		};
	}

	static generateTempWorksCellData(cell: Cell, columnType: ColumnType, column: Column, level: Level): WorksCellData {
		let cellWidth: string | number;

		if (cell.shape === 'rectangular') {
			cellWidth = cell.width !== undefined ? cell.width : 0;
		} else {
			cellWidth = 'N/A';
		}

		// Calculating the temp works results here, because it's a bit too messy to do them inline below
		let tempWorks;
		if (cell.aptusDesignConfiguration !== 'nonaptus') {
			tempWorks = {
				tempWorksBarQty: ElementStructureUtils.aptusBarQuantity(cell.shape, cell.tempWorksBarsAlongWidth, cell.tempWorksBarsAlongDepth),
				tempWorksBarType: cell.tempWorksBarType,
				tempWorksBarsWidth: cell.tempWorksBarsAlongWidth,
				tempWorksBarsDepth: cell.tempWorksBarsAlongDepth,
				tempWorksWindLoad: cell.tempWorksWindLoad ? parseFloat(cell.tempWorksWindLoad.toFixed(3)) : undefined,
				tempWorksCfig: cell.tempWorksCfig ? parseFloat(cell.tempWorksCfig.toFixed(3)) : undefined,
			};
		} else {
			tempWorks = {
				tempWorksBarQty: undefined,
				tempWorksBarType: undefined,
				tempWorksBarsWidth: undefined,
				tempWorksBarsDepth: undefined,
				tempWorksWindLoad: undefined,
				tempWorksCfig: undefined,
			};
		}

		return {
			cellName: `${level.code}-${columnType.code}${column.name}`,
			quote_column: columnType.code + column.name,
			element_location: level.name,
			shape: cell.shape,
			width: cellWidth,
			depth: cell.depth,
			height: cell.height && parseFloat(cell.height.toFixed()),
			cellsSpanned: cell.levelHeight,
			tempWorksBarQty: tempWorks.tempWorksBarQty,
			tempWorksBarType: tempWorks.tempWorksBarType,
			tempWorksBarsWidth: tempWorks.tempWorksBarsWidth,
			tempWorksBarsDepth: tempWorks.tempWorksBarsDepth,
			currentAptusDesign: ElementStructureUtils.cellAptusDesignString(cell),
			approved: cell.approved ? 'Yes' : 'No',
			tempWorksWindLoad: tempWorks.tempWorksWindLoad,
			tempWorksCfig: tempWorks.tempWorksCfig,

		};
	}

	private static generateShutterData(shutter: PricingShutter, elementStructure: ElementStructure, shuttersNeededPerLevel: {}): ShutterData {
		const totals = ElementStructureUtils.getShutterPrice(shutter);
		ElementStructureUtils.getFullUsage(elementStructure);

		const data: ShutterData = {
			shutterName: ElementStructureUtils.shutterTypeString(shutter),
			shutterQuantity: shutter.quantity,
			shutterRate: parseInt(shutter.price.toFixed(0)),
			shutterTotal: parseInt(totals.shutterTotal.toFixed(0)),
			calculatedFullUsageQty: shutter.calculatedFullUsageQty ? parseInt(shutter.calculatedFullUsageQty.toFixed(0)) : 0,
			siteTemplateQuantity: shutter.siteTemplateQuantity || 0,
			siteTemplateRate: parseInt((shutter.siteTemplatePrice || 0).toFixed(0)),
			siteTemplateTotal: parseInt(totals.siteTemplateTotal.toFixed(0)),
		};

		elementStructure.levels.slice().reverse().forEach(level => {
			data[level.id] = shuttersNeededPerLevel[level.id] && shuttersNeededPerLevel[level.id][ElementStructureUtils.shutterTypeString(shutter)]
				? shuttersNeededPerLevel[level.id][ElementStructureUtils.shutterTypeString(shutter)]
				: null;
		});
		return data;
	}

	private static generateCostSummaryDataForBarParts(partName: string, summary: { totalLength: number; qty: number; totalCost: number }): BarPartsSummaryData {
		return {
			partName: partName,
			ave_length: parseFloat((summary.totalLength / summary.qty).toFixed(0)),
			qty: summary.qty,
			ave_rate: (summary.totalCost / summary.qty),
			total: (summary.totalCost),
		};
	}

	private static generateCostSummaryDataForItemParts(partName: string, summary: { qty: number; totalCost: number }): ItemPartsSummaryData {
		return {
			partName: partName,
			item: 'each',
			qty: summary.qty,
			ave_rate: parseFloat((summary.totalCost / summary.qty).toFixed(2)),
			total: parseFloat(summary.totalCost.toFixed(2)),
		};
	}

	private static generateCostSummaryDataForShutters(shutterTotals: ShutterTotal): ItemPartsSummaryData {
		return {
			partName: 'Shutter Pairs (estimate)',
			item: 'each',
			qty: shutterTotals.shutterCount,
			ave_rate: parseFloat(safeDivide(shutterTotals.shutterTotal, shutterTotals.shutterCount).toFixed(2)),
			total: parseFloat(shutterTotals.shutterTotal.toFixed(2)),
		};
	}

	private static generateCostSummaryDataForSiteTemplates(shutterTotals: ShutterTotal): ItemPartsSummaryData {
		return {
			partName: 'Site Templates (estimate)',
			item: 'each',
			qty: shutterTotals.siteTemplateCount,
			ave_rate: parseFloat(safeDivide(shutterTotals.siteTemplateTotal, shutterTotals.siteTemplateCount).toFixed(2)),
			total: parseFloat(shutterTotals.siteTemplateTotal.toFixed(2)),
		};
	}

	private static generateAxialLoadsData(cell: Cell, columnType: ColumnType, column: Column, level: Level): AxialLoadsData {
		return {
			levelName: level.name,
			columnName: columnType.code + column.name,
			load: cell.calculatedLoad || 0,
			majorAxisMoment: cell.majorAxisMoment,
			minorAxisMoment: cell.minorAxisMoment,
		};
	}

	public static elementsListCSV(elementStructure: ElementStructure): string {
		const csvWriter = csv.createObjectCsvStringifier({
			header: DataExportUtils.getCSVHeaders(DataExportUtils.elementListHeaders),
		});
		const csvCells: ElementsCellData[] = [];

		mapReverse(elementStructure.levels, (level: Level) => {
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					const cell = elementStructure.cells[column.id][level.id];
					if (!cell.merged && !cell.deleted) {
						csvCells.push(this.generateElementsListCellData(cell, columnType, column, level, elementStructure));
					}
				});
			});
		});

		return (csvWriter.getHeaderString() + csvWriter.stringifyRecords(csvCells));
	}

	public static scheduleOfRatesCSV(elementStructure: ElementStructure): string {
		const csvWriter = csv.createObjectCsvStringifier({
			header: DataExportUtils.getCSVHeaders(DataExportUtils.scheduleOfRatesHeaders),
		});
		const csvCells: ScheduleOfRatesCellData[] = [];
		mapReverse(elementStructure.levels, (level: Level) => {
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					const cell = elementStructure.cells[column.id][level.id];
					if (!cell.merged && !cell.deleted) {
						csvCells.push(this.generateScheduleOfRatesCellData(cell, columnType, column, level, elementStructure));
					}
				});
			});
		});

		return (csvWriter.getHeaderString() + csvWriter.stringifyRecords(csvCells));
	}

	public static temporaryWorksCSV(elementStructure: ElementStructure): string {
		const csvCells: WorksCellData[] = [];

		const csvWriter = csv.createObjectCsvStringifier({
			header: DataExportUtils.getCSVHeaders(DataExportUtils.tempWorksHeaders),
		});

		elementStructure.levels.forEach(level => {
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					const cell = elementStructure.cells[column.id][level.id];
					if (!cell.merged && !cell.deleted) {
						csvCells.push(this.generateTempWorksCellData(cell, columnType, column, level));
					}
				});
			});
		});

		return (csvWriter.getHeaderString() + csvWriter.stringifyRecords(csvCells));
	}

	public static shutterCSV(elementStructure: ElementStructure): string {
		const csvCells: ShutterData[] = [];

		const shutterHeaders = DataExportUtils.getCSVHeaders(DataExportUtils.shutterHeaders).slice();

		elementStructure.levels.slice().reverse().forEach(level => {
			shutterHeaders.push({ id: level.id, title: level.code, columnWidth: DataExportUtils.shuttersPerLevelColumnWidth });
		});

		const csvWriter = csv.createObjectCsvStringifier({
			header: shutterHeaders,
		});

		const shuttersNeededPerLevel = this.shuttersNeededPerLevel(elementStructure);

		if (elementStructure.shutters) {
			elementStructure.shutters.forEach(shutter => {
				csvCells.push(this.generateShutterData(shutter, elementStructure, shuttersNeededPerLevel));
			});
		}

		return (csvWriter.getHeaderString() + csvWriter.stringifyRecords(csvCells));
	}

	public static costSummaryCSV(elementStructure: ElementStructure): string {
		const csvCells: any[][] = [];

		const aptusbarParts = ElementStructureUtils.getAptusBarParts(elementStructure);
		const aptusItemParts = ElementStructureUtils.getAptusItemParts(elementStructure);
		const aptusShutters = ElementStructureUtils.getShuttersTotal(elementStructure);

		// Start with just the shutters in our totals, and add the other parts when we loop through them below
		let totalCost = aptusShutters.shutterTotal + aptusShutters.siteTemplateTotal;
		let totalQuantity = aptusShutters.shutterCount + aptusShutters.siteTemplateCount;

		// Add additional parts to total cost
		// elementStructure.additionalParts && elementStructure.additionalParts.forEach(part => {
		// totalCost += ElementStructureUtils.getPartCombinedPrice(part) * part.quantity;
		// totalQuantity += part.quantity;
		// });

		if (elementStructure.additionalParts) {
			elementStructure.additionalParts.forEach(part => {
				totalCost += ElementStructureUtils.getPartCombinedPrice(part) * part.quantity;
				totalQuantity += part.quantity;
			});
		}

		csvCells.push(Object.values([
			'Additional Extras',
			'Ave Length',
			'Qty',
			'Ave Rate',
			'Total',
		]));
		if (elementStructure.additionalParts) {
			elementStructure.additionalParts.forEach(part => {
				const combinedPrice = ElementStructureUtils.getPartCombinedPrice(part);
				csvCells.push(Object.values([
					part.partName,
					part.isBar ? part.length : 'N/A',
					part.quantity,
					combinedPrice,
					(combinedPrice * (part.quantity ? part.quantity : 0)),
				]));
			});
		}
		csvCells.push(Object.values(''));

		ElementStructureUtils.barPartsList.forEach(barType => {
			const barParts = aptusbarParts[barType.name];
			let total = 0.0;
			if (Object.entries(barParts).length) {
				csvCells.push(Object.values([
					barType.description,
					'Ave Length',
					'Qty',
					'Ave Rate',
					'Total',
				]));
				Object.entries(barParts).forEach(([partName, summary]) => {
					total += summary.totalCost;
					totalCost += summary.totalCost;
					totalQuantity += summary.qty;
					csvCells.push(Object.values(this.generateCostSummaryDataForBarParts(partName, summary)));
				});
				csvCells.push(Object.values([
					'Total:',
					'',
					'',
					'',
					total,
				]));
				csvCells.push(Object.values(''));
			}
		});

		ElementStructureUtils.itemPartsList.forEach(itemType => {
			const itemParts = aptusItemParts[itemType.name];
			let total = 0.0;
			if (Object.entries(itemParts).length) {
				csvCells.push(Object.values([
					itemType.description,
					'Unit',
					'Qty',
					'Rate',
					'Total',
				]));
				Object.entries(itemParts).forEach(([partName, summary]) => {
					total += summary.totalCost;
					totalCost += summary.totalCost;
					totalQuantity += summary.qty;
					csvCells.push(Object.values(this.generateCostSummaryDataForItemParts(partName, summary)));
				});
				csvCells.push(Object.values([
					'Total:',
					'',
					'',
					'',
					total,
				]));
				csvCells.push(Object.values(''));
			}
		});

		csvCells.push(Object.values([
			'Aptus Formwork Shutters (refer to Shutters)',
			'Unit',
			'Qty',
			'Ave Rate',
			'Total',
		]));
		csvCells.push(Object.values(this.generateCostSummaryDataForShutters(aptusShutters)));
		csvCells.push(Object.values(this.generateCostSummaryDataForSiteTemplates(aptusShutters)));
		csvCells.push(Object.values([
			'Total:',
			'',
			'',
			'',
			(aptusShutters.shutterTotal + aptusShutters.siteTemplateTotal).toFixed(2),
		]));
		csvCells.push(Object.values(''));

		csvCells.push(Object.values([
			'All Parts',
			'each',
			totalQuantity,
			safeDivide(totalCost, totalQuantity).toFixed(2),
			totalCost.toFixed(2),
		]));

		return csvCells.splice(Number('')).join('\n');
	}

	public static axialLoadsCSV(elementStructure: ElementStructure): string {
		const csvCells: AxialLoadsData[] = [];

		const csvWriter = csv.createObjectCsvStringifier({
			header: DataExportUtils.getCSVHeaders(DataExportUtils.axialLoadHeaders),
		});

		elementStructure.levels.forEach(level => {
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					const cell = elementStructure.cells[column.id][level.id];
					if (!cell.merged && !cell.deleted) {
						csvCells.push(this.generateAxialLoadsData(cell, columnType, column, level));
					}
				});
			});
		});

		return (csvWriter.getHeaderString() + csvWriter.stringifyRecords(csvCells));
	}

	// Produce a workbook, and send it to the user
	public static elementStructureWorkbook(elementStructure: ElementStructure, filename: string, project: ProjectEntity) {
		// Create a new workbook
		const workbook = XLSX.utils.book_new();

		// Add the four sheets to it
		XLSX.utils.book_append_sheet(workbook, DataExportUtils.projectInformationSheet(project), TableTitle.ProjectInformation);
		XLSX.utils.book_append_sheet(workbook, DataExportUtils.elementTableSheet(elementStructure, project), TableTitle.ElementTable);
		XLSX.utils.book_append_sheet(workbook, DataExportUtils.elementListSheet(elementStructure, project), TableTitle.ElementList);
		XLSX.utils.book_append_sheet(workbook, DataExportUtils.scheduleOfRatesSheet(elementStructure, project), TableTitle.ScheduleOfRates);
		XLSX.utils.book_append_sheet(workbook, DataExportUtils.tempWorksSheet(elementStructure, project), TableTitle.TemporaryWorks);
		XLSX.utils.book_append_sheet(workbook, DataExportUtils.shuttersSheet(elementStructure, project), TableTitle.Shutters);
		XLSX.utils.book_append_sheet(workbook, DataExportUtils.costSummarySheet(elementStructure, project), TableTitle.CostSummary);
		XLSX.utils.book_append_sheet(workbook, DataExportUtils.projectDataSheet(project), TableTitle.Data);

		// Write it to a file, and have the user download it
		XLSX.writeFile(workbook, filename, { cellStyles: true, bookImages: true });
	}

	// Sheet Array
	public static buildProjInfoSheetArray(project: ProjectEntity) {
		const sheetCells: any[][] = [];

		// const emptyColumns = Array(4).fill("");
		const emptyRow = Array(1).fill('');
		const tempWorks = project.parsedElementStructure.info.temporaryWorks;
		const { levels } = project.parsedElementStructure;
		const { columnTypes } = project.parsedElementStructure;
		const elementInformation: {abbreviation: string, type: string, number: number}[] = [];
		const levelInformation: {code: string, name: string, ssl: number, height?: number}[] = [];
		// Set the element Information
		for (const t of columnTypes) {
			let currentType = elementInformation.find(eInfo => eInfo.type === t.name);
			if (!currentType) {
				elementInformation.push({ abbreviation: t.code, type: t.name, number: 0 });
				currentType = elementInformation.find(eInfo => eInfo.type === t.name);
			}
			for (const c of t.columns) {
				for (const l of levels) {
					const currentCell = project.parsedElementStructure.cells[c.id][l.id];
					if (currentType && !(currentCell.deleted || currentCell.merged)) currentType.number += 1;
				}
			}
		}
		// Set the level information
		for (const l of levels) {
			levelInformation.push({
				code: l.code, name: l.name, ssl: l.ssl, height: l.calculatedFloorHeight,
			});
		}
		// Combine the two arrays
		const maxLength = levelInformation.length >= elementInformation.length ? levelInformation.length : elementInformation.length;
		const combinedArray: {lCode?: string, lName?: string, lSsl?: number, lHeight?: number, eAbbreviation?: string, eType?: string, eNumber?: number}[] = [];
		for (let i = 0; i < maxLength; i++) {
			const curLInfo = levelInformation[i] ?? null;
			const curEInfo = elementInformation[i] ?? null;
			combinedArray.push({
				lCode: curLInfo?.code,
				lName: curLInfo?.name,
				lSsl: curLInfo?.ssl,
				lHeight: curLInfo?.height,
				eAbbreviation: curEInfo?.abbreviation,
				eType: curEInfo?.type,
				eNumber: curEInfo?.number,
			});
		}

		for (let i = 0; i < 3; i++) {
			sheetCells.push(emptyRow);
		}
		sheetCells.push(['Project Information']);
		sheetCells.push(['Project Name:', project.name ?? '']);
		sheetCells.push(['Job Number:', project.jobNumber ?? '']);
		sheetCells.push(['Postcode:', project.postcode ?? '']);
		sheetCells.push(['Location:', project.suburb ?? '']);
		sheetCells.push(['Country:', project.country ?? '']);
		for (let i = 0; i < 2; i++) {
			sheetCells.push(emptyRow);
		}
		sheetCells.push(['Client Information', '', '', '', '', 'Temporary Works Design Information']);
		sheetCells.push(['Client Company:', project.clientCompany ?? '', '', '', '', 'TerrainCategory:', tempWorks.terrainCategory ?? '']);
		sheetCells.push(['Client First Name:', project.clientFirstName ?? '', '', '', '', 'Wind Region:', tempWorks.windRegion ?? '']);
		sheetCells.push(['Client Last Name:', project.clientLastName ?? '', '', '', '', 'Ground Level RL:', tempWorks.groundLevelRL ?? '']);
		sheetCells.push(['Client Address Line 1', project.clientAddressLine1 ?? '']);
		sheetCells.push(['Client Address Line 2:', project.clientAddressLine2 ?? '']);
		sheetCells.push(['Client Phone:', project.clientPhone ?? '']);
		sheetCells.push(['Client Email:', project.clientEmail ?? '']);
		for (let i = 0; i < 2; i++) {
			sheetCells.push(emptyRow);
		}
		sheetCells.push(['Level Information', '', '', '', '', 'Element Information']);
		sheetCells.push(['Level Code', 'Level Name', 'SSL (m)', 'Floor to floor height (mm)', '', 'Element abbreviation', 'Element Type', 'Total no. in Project']);
		combinedArray.forEach(arr => {
			sheetCells.push([arr.lCode ?? '', arr.lName ?? '', arr.lSsl ?? '', arr.lHeight ?? '', '', arr.eAbbreviation ?? '', arr.eType ?? '', arr.eNumber ?? '']);
		});

		return sheetCells;
	}

	// A sheet for detail project information
	public static projectInformationSheet(project: ProjectEntity): XLSX.WorkSheet {
		const sheetCells = this.buildProjInfoSheetArray(project);

		const sheet = XLSX.utils.aoa_to_sheet(sheetCells);
		DataExportUtils.addHeaderImage(sheet);
		if (sheet['!ref']) {
			let range = XLSX.utils.decode_range(sheet['!ref']);
			sheet['!cols'] = [{ width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, {}, { width: 20 }, { width: 20 }, { width: 20 }];

			sheet['!merges'] = [
				{ s: { r: 11, c: 5 }, e: { r: 11, c: 6 } },
				{ s: { r: 21, c: 0 }, e: { r: 21, c: 4 } },
				{ s: { r: 21, c: 5 }, e: { r: 21, c: 7 } },
			];
			// bold project info
			range.s.r = 3; range.e.r = 3;
			range.s.c = 0; range.e.c = 0;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
				alignment: { horizontal: 'center' },
			});

			// bold client info & Temporary Works Design Information
			range.s.r = 11; range.e.r = 11;
			range.s.c = 0; range.e.c = 5;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
				alignment: { horizontal: 'center' },
			});

			// bold Level info & Element Info
			range.s.r = 21; range.e.r = 21;
			range.s.c = 0; range.e.c = 5;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
				alignment: { horizontal: 'center' },
			});

			// Center Bold Wrap Row 23
			range.s.r = 22; range.e.r = 22;
			range.s.c = 0; range.e.c = 8;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
				alignment: {
					horizontal: 'center',
					vertical: 'top',
					wrapText: true,
				},
			});

			// Center Terrain Cat, Wind Region, and Ground Level RL
			range.s.r = 12; range.e.r = 14;
			range.s.c = 6; range.e.c = 6;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				alignment: { horizontal: 'center' },
			});

			range = XLSX.utils.decode_range(sheet['!ref']);
			for (let rowNum = 4; rowNum <= range.e.r; ++rowNum) {
				for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
					// If row 23 or greater and not column G
					if (rowNum >= 22 && colNum !== 6) {
						const cell_address = { c: colNum, r: rowNum };
						const cell_ref = XLSX.utils.encode_cell(cell_address);
						// We can only style cells if they exist
						if (!sheet[cell_ref]) {
							sheet[cell_ref] = {
								v: '',
							};
						}

						if (!sheet[cell_ref].s) {
							sheet[cell_ref].s = {};
						}
						sheet[cell_ref].s.alignment = {
							horizontal: 'center',
						};
					}
				}
			}
		}
		return sheet;
	}

	public static buildDataSheetArray(project: ProjectEntity) {
		const sheetCells: any[][] = [];

		const emptyRow = Array(1).fill('');
		const elementStruct = project.parsedElementStructure;
		const { levels } = elementStruct;
		const { columnTypes } = elementStruct;

		sheetCells.push(['', '', '', '', 'Project: ', project.name ?? '']);
		sheetCells.push(['', '', '', '', 'Location: ', `${project.clientAddressLine1 ?? ''} ${project.clientAddressLine2 ?? ''}`]);
		sheetCells.push(['', '', '', '', 'Client: ', project.clientCompany ?? '']);
		sheetCells.push(['BULK DATA OUTPUT', '', '', '', 'Job Number: ', project.jobNumber ?? '']);
		sheetCells.push(emptyRow);

		// Column Headers
		const row6: string[] = [];
		const row7: string[] = [];

		// Helper function for creating headers as the two row lengths must remain in sync or formatting with break
		const addToHeaders = (section: string, r6: string[], r7: string[]) => {
			if (r6.length !== r7.length) {
				console.error(`Section "${section}" of Data Sheet header generation does not contains headers of equal length. Search the quoted section label to debug.`);
			}
			row6.push(...r6);
			row7.push(...r7);
		};

		addToHeaders(
			'Element Name-Number-Location',
			['Element Name', 'Element Number', 'Element Location'],
			['', '', ''],
		);
		addToHeaders(
			'Element Construction Zone-Shape-Type',
			['Construction Zone', 'Element Type', 'Element Shape'],
			['', '', ''],
		);
		addToHeaders(
			'Element Dimensions and Volume',
			['Width (mm)', 'Depth (mm)', 'Height (mm)', 'Element Mass (t)', 'Void Volume (m3)', 'Corbel Volume (m3)', 'Net Volume (m3)', 'Gross Area (m2)'],
			['', '', '', '', '', '', '', ''],
		);
		addToHeaders(
			'Element Concrete Strength, Reo perc, Wall or Column',
			['Concrete Strength (MPA)', 'Aptus Vertical Reo Percentage', 'Horizontal Reo Detailed as Wall or Column?'],
			['', '', ''],
		);
		addToHeaders(
			'Slabs and Levels',
			['Slab Depth at Base (mm)', 'Slab Depth at Top (mm)', 'SSL at Base of Element (m)', 'SSL at Top of Element (m)', 'Levels Spanned', 'Axial Load (kN)'],
			['', '', '', '', '', ''],
		);
		addToHeaders(
			'Moments to Blockouts',
			['Major Axis Moment', 'Minor Axis Moment', 'Design Config.', 'Blockouts (Y/N)'],
			['', '', '', ''],
		);
		addToHeaders(
			'Rebar Configuration',
			['Rebar Configuration', ''],
			['Aptus Bars + Conv. Bars', 'Horizontal Rebar'],
		);
		addToHeaders(
			'Aptus Bars',
			['Aptus Bars', '', '', ''],
			['Type', 'Width', 'Depth', 'Total'],
		);
		addToHeaders(
			'Aptus Ligs',
			['Aptus Ligs', ''],
			['Type', 'Spacing'],
		);
		addToHeaders(
			'Non-Aptus Bars',
			['Non-Aptus Bars', '', '', ''],
			['Type', 'Width', 'Depth', 'Total'],
		);
		addToHeaders(
			'Non-Aptus Ligs',
			['Non-Aptus Ligs', ''],
			['Type', 'Spacing'],
		);
		addToHeaders(
			'Element Length-Factor-Approved-Total-Aptus-Amount',
			['Effective Length Factor', 'Design Approved', 'Total Aptus Amount'],
			['', '', ''],
		);
		addToHeaders(
			'In-situ Starter Bars & Inner Couplers + Extension Bars',
			['In-situ Starter Bars & Inner Couplers + Extension Bars (if req\'d)', '', '', '', '', '', '', '', '', '', ''],
			['Qty', 'Length (mm)', 'Aptus Bar Type', 'Rate', 'Qty', 'Inner Coupler', 'Rate', 'Qty', 'Length (mm)', 'Extension Bar', 'Rate'],
		);
		addToHeaders(
			'Outer Couplers (at base)',
			['Outer Couplers (at base)', '', ''],
			['Qty', 'Outer Coupler', 'Rate'],
		);
		addToHeaders(
			'Aptus Bars (within element)',
			['Aptus Bars (within element)', '', '', ''],
			['Qty', 'Length (mm)', 'Aptus Bar', 'Rate'],
		);
		addToHeaders(
			'Aptus Starter Bars (within element)',
			['Aptus Starter Bars (within element)', '', '', ''],
			['Qty', 'Length (mm)', 'Aptus Bar', 'Rate'],
		);
		addToHeaders(
			'Inner Couplers (at top) + Extension Bars',
			['Inner Couplers (at top) + Extension Bars (if req\'d)', '', '', '', '', '', ''],
			['Qty', 'Inner Coupler', 'Rate', 'Qty', 'Length (mm)', 'Extension Bar', 'Rate'],
		);
		addToHeaders(
			'Aptus Threaded Anchors',
			['Aptus Threaded Anchors', '', ''],
			['Qty', 'Anchor Assembly', 'Rate'],
		);
		addToHeaders(
			'Aptus Threaded Anchors',
			['APTUS Bar Mass (kg)', '', '', '', '', ''],
			['N20', 'N24', 'N28', 'N32', 'N36', 'N40'],
		);
		addToHeaders(
			'Vertical non-Aptus Bar Mass (kg)',
			['Vertical non-Aptus Bar Mass (kg)', '', '', '', '', '', '', '', ''],
			['N10', 'N12', 'N16', 'N20', 'N24', 'N28', 'N32', 'N36', 'N40'],
		);
		addToHeaders(
			'Horizontal non-Aptus Bar Mass (kg)',
			['Horizontal non-Aptus Bar Mass (kg)', '', '', '', '', '', '', '', ''],
			['N10', 'N12', 'N16', 'N20', 'N24', 'N28', 'N32', 'N36', 'N40'],
		);
		addToHeaders(
			'Corbel Bar Mass',
			['Corbel Bar Mass', ''],
			['Reo Rate (kg/m^3)', 'Total (kg)'],
		);
		addToHeaders(
			'Non-Aptus (based on rates)',
			['Non-Aptus (based on rates)', ''],
			['Reo Rate (kg/m^3)', 'Total (kg)'],
		);
		addToHeaders(
			'Estimated Rebar Totals (kg)',
			['Estimated Rebar Totals (kg)', '', '', '', ''],
			['Aptus Bar Mass', 'Vertical non-Aptus Bar Mass', 'Horizontal non-Aptus Bar Mass', 'Total non-Aptus Bar Mass', 'Total All Reo'],
		);
		addToHeaders(
			'Minimum Temporary Works Requirements',
			['Minimum Temporary Works Requirements', '', '', ''],
			['Total Bars', 'Bar Type', 'Along Width', 'Along Depth'],
		);
		addToHeaders(
			'Element Wind',
			['Wind Load (qz)', 'Wind Aerodynamic Shape Factor (Cfig)'],
			['', ''],
		);

		sheetCells.push(row6);
		sheetCells.push(row7);

		// Gather Element Data
		for (const level of levels.reverse()) {
			for (const columnType of columnTypes) {
				for (const column of columnType.columns) {
					const cell = elementStruct.cells[column.id][level.id];

					// do not add merged or deleted cells to the Data sheet list of elements
					if (cell.deleted || cell.merged) continue;

					// Existing Common
					const elementName = `${level.code}-${columnType.code}${column.name}`;
					const elementNumber = columnType.code + column.name;
					const elementLocation = level.name;

					// From Element List
					const elemListData = this.generateElementsListCellData(cell, columnType, column, level, elementStruct);
					const usingBlockouts = cell.slabThicknessAtBase <= 515 ? cell.extensionUnderDepth === 'blockouts' : cell.extensionOverDepth === 'blockouts';
					const schRatesData = this.generateScheduleOfRatesCellData(cell, columnType, column, level, elementStruct);
					const tempWorkData = this.generateTempWorksCellData(cell, columnType, column, level);

					const verticalReo = ElementStructureUtils.calculateVerticalReoPercentage(
						cell.shape,
						cell.aptusBarsAlongDepth,
						cell.depth,
						cell.width,
						cell.aptusBarType,
						cell.aptusBarsAlongWidth,
					);

					const horizontalReoDesignedAs = DataExportUtils.getCellHorizontalReoDesign(cell) !== undefined
						? DataExportUtils.getCellHorizontalReoDesign(cell) === 'Column'
							? 'Column'
							: 'Wall'
						: ' ';

					// Cell Volume
					// calculateCellVolumes returns an array [cell, corbel, void]
					const cellVolume = ElementStructureUtils.calculateCellVolumes(project.parsedElementStructure, cell);
					const corbelVolume = cellVolume[1];
					const voidVolume = cellVolume[2];
					const elementVolume = cellVolume[0];

					// Net Volume
					const netVolume = cellVolume[0] ? cellVolume[0] + (corbelVolume ?? 0) - (voidVolume ?? 0) : undefined;

					const elementDataArray = [
						elementName,
						elementNumber,
						elementLocation,
						elemListData.constructionZone,
						elemListData.element_type,
						elemListData.shape,
						elemListData.width,
						cell.depth,
						elemListData.height,
						cell.unitMass ?? ' ',
						voidVolume ?? ' ',
						corbelVolume ?? ' ',
						netVolume ?? ' ',
						ElementStructureUtils.calculateGrossArea(cell), // Gross Area
						cell.concreteStrength ?? ' ',
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : verticalReo,
						horizontalReoDesignedAs, // Horizontal Reo detailed as Wall or Column
						elemListData.slabThicknessAtBase,
						elemListData.slabThicknessAtTop ?? ' ',
						elemListData.ssl ?? ' ',
						elemListData.sslTop ?? ' ',
						elemListData.cellsSpanned,
						elemListData.load !== undefined ? parseFloat(elemListData.load.toString()) : ' ',
						cell.workingMajorAxisMoment,
						cell.workingMinorAxisMoment,
						elemListData.designConfig,
						usingBlockouts ? 'Y' : 'N', // Blockouts Y/N

						// Rebar Configuration
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : schRatesData.aptus_bars_conv_bars,
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : schRatesData.horizontal_rebar,

						// Aptus Bars
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : elemListData.aptusBarType ?? ' ',
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : elemListData.aptusBarsWidth ?? ' ',
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : elemListData.aptusBarsDepth ?? ' ',
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : elemListData.aptusBarsTotal ?? ' ',

						// Aptus Ligs
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : elemListData.aptusBarLigType ?? ' ',
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : elemListData.aptusBarLigSpacing ?? ' ',

						// Non-Aptus Bars
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : elemListData.nonAptusBarType ?? ' ',
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : elemListData.nonAptusBarsWidth ?? ' ',
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : elemListData.nonAptusBarsDepth ?? ' ',
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : elemListData.nonAptusBarsTotal ?? ' ',

						// Non-Aptus ligs
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : elemListData.nonAptusBarLigType ?? ' ',
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : elemListData.nonAptusBarLigSpacing ?? ' ',

						elemListData.kFactor ?? ' ', // Effective Length Factor
						elemListData.approved, // Design Approved
						schRatesData.total_aptus_cost, // Total Aptus Amount

						// In-situ Starter Bars & Inner Couplers + Extension Bars
						schRatesData.insitu_starter_bar_qty,
						schRatesData.insitu_starter_bar_length,
						schRatesData.insitu_starter_bar_aptus_bar_type,
						schRatesData.insitu_starter_bar_rate,
						schRatesData.insitu_inner_coupler_qty,
						schRatesData.insitu_inner_coupler_type,
						schRatesData.insitu_inner_coupler_rate,
						schRatesData.insitu_socket_ext_qty,
						schRatesData.insitu_socket_ext_length,
						schRatesData.insitu_socket_ext_type,
						schRatesData.insitu_socket_ext_rate,

						// Outer Couplers (at base)
						schRatesData.outer_coupler_qty,
						schRatesData.outer_coupler_type,
						schRatesData.outer_coupler_rate,

						// Aptus Bars (within element)
						schRatesData.aptus_bar_qty,
						schRatesData.aptus_bar_length,
						schRatesData.aptus_bar_type,
						schRatesData.aptus_bar_rate,

						// Aptus Starter Bars (within element)
						schRatesData.starter_bar_qty,
						schRatesData.starter_bar_length,
						schRatesData.starter_bar_type,

						// Inner Couplers (at top) + Extension Bars (if req'd)
						schRatesData.starter_bar_rate,
						schRatesData.inner_coupler_qty,
						schRatesData.inner_coupler_type,
						schRatesData.inner_coupler_rate,
						schRatesData.socket_ext_qty,
						schRatesData.socket_ext_length,
						schRatesData.socket_ext_type,
						schRatesData.socket_ext_rate,

						// Aptus Threaded Anchors
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : schRatesData.threaded_anchor_qty,
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : schRatesData.threaded_anchor_type,
						ElementStructureUtils.shouldUseReoRate(cell) ? ' ' : schRatesData.threaded_anchor_rate,

						// APTUS Bar Mass (kg)
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : cell.aptusBarMassDict?.N20 ?? ' ', // N20 Aptus
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : cell.aptusBarMassDict?.N24 ?? ' ', // N24 Aptus
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : cell.aptusBarMassDict?.N28 ?? ' ', // N28 Aptus
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : cell.aptusBarMassDict?.N32 ?? ' ', // N32 Aptus
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : cell.aptusBarMassDict?.N36 ?? ' ', // N36 Aptus
						cell.aptusDesignConfiguration === 'nonaptus' ? ' ' : cell.aptusBarMassDict?.N40 ?? ' ', // N40 Aptus

						// Vertical non-Aptus Bar Mass (kg)
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N10 ?? ' ', // VN10 Vertical Non-Aptus
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N12 ?? ' ', // VN12 Vertical Non-Aptus
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N16 ?? ' ', // VN16 Vertical Non-Aptus
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N20 ?? ' ', // VN20 Vertical Non-Aptus
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N24 ?? ' ', // VN24 Vertical Non-Aptus
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N28 ?? ' ', // VN28 Vertical Non-Aptus
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N32 ?? ' ', // VN32 Vertical Non-Aptus
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N36 ?? ' ', // VN36 Vertical Non-Aptus
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : cell.nonAptusBarMassDict?.N40 ?? ' ', // VN40 Vertical Non-Aptus

						// Horizontal non-Aptus Bar Mass (kg)
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N10', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN10 Horizontal
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N12', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN12 Horizontal
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N16', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN16 Horizontal
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N20', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN20 Horizontal
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N24', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN24 Horizontal
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N28', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN28 Horizontal
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N32', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN32 Horizontal
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N36', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN36 Horizontal
						(ElementStructureUtils.shouldUseReoRate(cell) || ElementStructureUtils.isInsitu(cell)) ? ' ' : ElementStructureUtils.calculateHorizontalRebarMass('N40', cell.aptusLigMassDict, cell.nonAptusLigMassDict) || ' ', // HN40 Horizontal

						// Corbel Bar Mass
						cell.corbel?.reoRate ?? ' ', // Reo Rate
						ElementStructureUtils.calculateCorbelReoMass(elementStruct, cell) ?? ' ', // Total kg

						// Non-Aptus (based on rates)
						ElementStructureUtils.shouldUseReoRate(cell)
							? cell.reoRate ?? ' '
							: ' ', // Reo Rate
						ElementStructureUtils.shouldUseReoRate(cell)
							? cell.reoRate
								? (elementVolume - voidVolume) * cell.reoRate
								: ' '
							: ' ', // Total kg

						'', // Aptus Bar Mass. This value is overwritten by an Excel Formula defined in projectDataSheet()
						'', // Vertical Non-aptus bar mass. This value is overwritten by Excel Formula defined in projectDataSheet()
						'', // Horizontal Non-aptus bar mass. This value is overwritten by Excel Formula defined in projectDataSheet()
						'', // Total non-Aptus Bar Mass. This value is overwritten by Excel Formula defined in projectDataSheet()
						'', // Total All Reo This value is overwritten by Excel Formula defined in projectDataSheet()

						tempWorkData.tempWorksBarQty ?? ' ',
						tempWorkData.tempWorksBarType ?? ' ',
						tempWorkData.tempWorksBarsWidth ?? ' ',
						tempWorkData.tempWorksBarsDepth ?? ' ',
						tempWorkData.tempWorksWindLoad ?? ' ',
						tempWorkData.tempWorksCfig ?? ' ',
					];

					if (elementDataArray.length !== row6.length) console.error(`Data sheet generation error - Element ${ElementStructureUtils.getCellName(elementStruct, cell)} does not have same number of values as headers in sheet`);

					sheetCells.push(elementDataArray);
				}
			}
		}

		return sheetCells;
	}

	// Project Data Tab Sheet Formatting
	public static projectDataSheet(project: ProjectEntity): XLSX.WorkSheet {
		const sheetCells = this.buildDataSheetArray(project);

		const sheet = XLSX.utils.aoa_to_sheet(sheetCells);
		DataExportUtils.addHeaderImage(sheet);
		if (sheet['!ref']) {
			sheet['!rows'] = [{}, {}, {}, {}, {}, { hpt: 50 }, { hpt: 50 }];
			// Set the Sheet Width for every column until specified.
			const sheetWidth = 12;

			const sheetWidthArray: { width:number }[] = new Array(114).fill({ width: sheetWidth });
			sheetWidthArray[2] = { width: sheetWidth * 1.5 };
			sheetWidthArray[4] = { width: sheetWidth * 1.5 };
			sheetWidthArray[27] = { width: sheetWidth * 2 };
			sheetWidthArray[28] = { width: sheetWidth * 2 };
			sheetWidthArray[46] = { width: sheetWidth * 2 };
			sheetWidthArray[49] = { width: sheetWidth * 2 };
			sheetWidthArray[60] = { width: sheetWidth * 2 };
			sheetWidthArray[64] = { width: sheetWidth * 2 };
			sheetWidthArray[67] = { width: sheetWidth * 2 };
			sheetWidthArray[71] = { width: sheetWidth * 2 };
			sheetWidthArray[74] = { width: sheetWidth * 2 };
			sheetWidthArray[114] = { width: sheetWidth * 2 };

			sheet['!cols'] = sheetWidthArray;
			sheet['!freeze'] = 'G8'; // set up floating columns/rows

			const range = XLSX.utils.decode_range(sheet['!ref']);
			// Styles that apply to all headers
			range.s.r = 5; range.e.r = 6;
			range.s.c = 0; range.e.c = 114;
			const borderStyle: XLSX.Border = {
				style: 'thin',
				color: { rgb: '000000' },
			};
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
				alignment: { wrapText: true, horizontal: 'center', vertical: 'center' },
				top: borderStyle,
				inrow: borderStyle,
				bottom: borderStyle,
				left: borderStyle,
				incol: borderStyle,
				right: borderStyle,
			});

			range.s.r = 7; range.e.r = sheetCells.length;
			range.s.c = 0; range.e.c = 114;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				alignment: { horizontal: 'right' },
			});

			// Merging Headers
			sheet['!merges'] = [
				{ s: { r: 0, c: 0 }, e: { r: 2, c: 2 } }, // Aptus Logo
				// ROWS
				{ s: { r: 5, c: 27 }, e: { r: 5, c: 28 } }, // Rebar Config
				{ s: { r: 5, c: 29 }, e: { r: 5, c: 32 } }, // Aptus Bars
				{ s: { r: 5, c: 33 }, e: { r: 5, c: 34 } }, // Aptus Ligs
				{ s: { r: 5, c: 35 }, e: { r: 5, c: 38 } }, // Non Aptus Bars
				{ s: { r: 5, c: 39 }, e: { r: 5, c: 40 } }, // Non Aptus Ligs
				{ s: { r: 5, c: 44 }, e: { r: 5, c: 54 } }, // Insitu Starter & Inner Couplers + Extension Bars
				{ s: { r: 5, c: 55 }, e: { r: 5, c: 57 } }, // Outer Couplers at base
				{ s: { r: 5, c: 58 }, e: { r: 5, c: 61 } }, // Aptus Bars Within El
				{ s: { r: 5, c: 62 }, e: { r: 5, c: 65 } }, // Aptus Starter Bars
				{ s: { r: 5, c: 66 }, e: { r: 5, c: 72 } }, // Inner Couplers (at top) + Extension Bars
				{ s: { r: 5, c: 73 }, e: { r: 5, c: 75 } }, // Aptus Threaded Anchors
				{ s: { r: 5, c: 76 }, e: { r: 5, c: 81 } }, // APTUS Bar Mass (kg)
				{ s: { r: 5, c: 82 }, e: { r: 5, c: 90 } }, // Vertical Non-Aptus Bar Mass
				{ s: { r: 5, c: 91 }, e: { r: 5, c: 99 } }, // Horizontal Non-Aptus Bar Mass
				{ s: { r: 5, c: 100 }, e: { r: 5, c: 101 } }, // Corbel Bar Mass
				{ s: { r: 5, c: 102 }, e: { r: 5, c: 103 } }, // Non-Aptus (based on rates)
				{ s: { r: 5, c: 104 }, e: { r: 5, c: 108 } }, // Estimated Rebar Totals (kg)
				{ s: { r: 5, c: 109 }, e: { r: 5, c: 112 } }, // Minimum Temporary Works Requirements
				// COLUMNS
				{ s: { r: 5, c: 0 }, e: { r: 6, c: 0 } }, // Element Name
				{ s: { r: 5, c: 1 }, e: { r: 6, c: 1 } }, // Element Number
				{ s: { r: 5, c: 2 }, e: { r: 6, c: 2 } }, // Element Location
				{ s: { r: 5, c: 3 }, e: { r: 6, c: 3 } }, // Construction Zone
				{ s: { r: 5, c: 4 }, e: { r: 6, c: 4 } }, // Element Type
				{ s: { r: 5, c: 5 }, e: { r: 6, c: 5 } }, // Element Shape
				{ s: { r: 5, c: 6 }, e: { r: 6, c: 6 } }, // Width (mm)
				{ s: { r: 5, c: 7 }, e: { r: 6, c: 7 } }, // Depth (mm)
				{ s: { r: 5, c: 8 }, e: { r: 6, c: 8 } }, // Height (mm)
				{ s: { r: 5, c: 9 }, e: { r: 6, c: 9 } }, // Element Mass (t)
				{ s: { r: 5, c: 10 }, e: { r: 6, c: 10 } }, // Void Volume (m3)
				{ s: { r: 5, c: 11 }, e: { r: 6, c: 11 } }, // Corbel Volume (m3)
				{ s: { r: 5, c: 12 }, e: { r: 6, c: 12 } }, // Net Volume (m3)
				{ s: { r: 5, c: 13 }, e: { r: 6, c: 13 } }, // Gross Area (m2)
				{ s: { r: 5, c: 14 }, e: { r: 6, c: 14 } }, // Concrete Strength (MPA)
				{ s: { r: 5, c: 15 }, e: { r: 6, c: 15 } }, // Aptus Vertical Reo Percentage
				{ s: { r: 5, c: 16 }, e: { r: 6, c: 16 } }, // Horizontal Reo Detailed as Wall or Column?
				{ s: { r: 5, c: 17 }, e: { r: 6, c: 17 } }, // Slab Depth at Base (mm)
				{ s: { r: 5, c: 18 }, e: { r: 6, c: 18 } }, // Slab Depth at Top (mm)
				{ s: { r: 5, c: 19 }, e: { r: 6, c: 19 } }, // SSL at Base of Element (m)
				{ s: { r: 5, c: 20 }, e: { r: 6, c: 20 } }, // SSL at Top of Element (m)
				{ s: { r: 5, c: 21 }, e: { r: 6, c: 21 } }, // Levels Spanned
				{ s: { r: 5, c: 22 }, e: { r: 6, c: 22 } }, // Axial Load (kN)
				{ s: { r: 5, c: 23 }, e: { r: 6, c: 23 } }, // Major Axis Moment
				{ s: { r: 5, c: 24 }, e: { r: 6, c: 24 } }, // Minor Axis Moment
				{ s: { r: 5, c: 25 }, e: { r: 6, c: 25 } }, // Design Config.
				{ s: { r: 5, c: 26 }, e: { r: 6, c: 26 } }, // Blockouts (Y/N)
				{ s: { r: 5, c: 41 }, e: { r: 6, c: 41 } }, // Effective Length Factor
				{ s: { r: 5, c: 42 }, e: { r: 6, c: 42 } }, // Design Approved
				{ s: { r: 5, c: 43 }, e: { r: 6, c: 43 } }, // Total Aptus Amount
				{ s: { r: 5, c: 113 }, e: { r: 6, c: 113 } }, // Wind Load (qz)
				{ s: { r: 5, c: 114 }, e: { r: 6, c: 114 } }, // Wind Aerodynamic Shape Factor (Cfig)
			];
			// Get the total of the Bar Masses for the row
			for (let i = 7; i < sheetCells.length; i++) {
				// XLSX counts from 0 but excel counts from 1. The strings containing the formula have 'i+1' to
				// rectify this inconsistency.
				XLSX.utils.sheet_set_array_formula(sheet, { s: { r: i, c: 104 }, e: { r: i, c: 104 } }, `=ROUND(SUM(BY${i + 1}:CD${i + 1}),2)`); // Aptus Bar Mass Total
				XLSX.utils.sheet_set_array_formula(sheet, { s: { r: i, c: 105 }, e: { r: i, c: 105 } }, `=ROUND(SUM(CE${i + 1}:CM${i + 1}),2)`); // Vertical Non-Aptus Bar Mass Total
				XLSX.utils.sheet_set_array_formula(sheet, { s: { r: i, c: 106 }, e: { r: i, c: 106 } }, `=ROUND(SUM(CN${i + 1}:CV${i + 1}),2)`); // Horizontal Non-Aptus Bar Mass Total
				XLSX.utils.sheet_set_array_formula(sheet, { s: { r: i, c: 107 }, e: { r: i, c: 107 } }, `=ROUND(SUM(DB${i + 1}:DC${i + 1},CX${i + 1},CZ${i + 1}),2)`); // Total Non-Aptus Bar Mass Total
				XLSX.utils.sheet_set_array_formula(sheet, { s: { r: i, c: 108 }, e: { r: i, c: 108 } }, `=ROUND(SUM(DA${i + 1}, DD${i + 1}),2)`); // Total All Reo

				// Apply formats to all extra rows
				XLSX.utils.sheet_set_range_style(sheet, { s: { r: i, c: 0 }, e: { r: i, c: 114 } }, {
					top: borderStyle,
					inrow: borderStyle,
					bottom: borderStyle,
					left: borderStyle,
					incol: borderStyle,
					right: borderStyle,
					alignment: {
						horizontal: 'center',
						wrapText: true,
					},
				});
			}
			this.formatColumn(sheet, 9, '0.00'); // Format Element Mass to round 2 Decimals
			this.formatColumn(sheet, 10, '0.00'); // Format voidVolume to round 2 Decimals
			this.formatColumn(sheet, 11, '0.00'); // Format corbelVolume to round 2 Decimals
			this.formatColumn(sheet, 12, '0.00'); // Format netVolume to round 2 Decimals
			this.formatColumn(sheet, 15, '0.00'); // Format Vertical Reo to round 2 Decimals

			this.formatColumn(sheet, 22, '0'); // Format Axial Load to Whole Numbers
			this.formatColumn(sheet, 23, '0'); // Format Major Axis Moment to Whole Numbers
			this.formatColumn(sheet, 24, '0'); // Format Minor Axis Moment to Whole Numbers

			for (let i = 76; i <= 108; i++) {
				this.formatColumn(sheet, i, '0'); // All reo bar masses please round up to 0 dp (i.e. whole number)
			}
		}
		return sheet;
	}

	public static formatColumn(sheet: XLSX.WorkSheet, col: number, fmt: string) {
		const range = XLSX.utils.decode_range(sheet['!ref'] as string);
		// note: range.s.r + 1 skips the header row
		for (let row = range.s.r + 1; row <= range.e.r; ++row) {
			const ref = XLSX.utils.encode_cell({ r: row, c: col });
			if (sheet[ref] && sheet[ref].t === 'n') {
				sheet[ref].z = fmt;
			}
		}
	}

	public static formatRow(sheet: XLSX.WorkSheet, row: number, fmt: string) {
		const range = XLSX.utils.decode_range(sheet['!ref'] as string);
		// note: range.s.r + 1 skips the header row
		for (let col = range.s.c + 1; col <= range.e.c; ++col) {
			const ref = XLSX.utils.encode_cell({ r: row, c: col });
			if (sheet[ref] && sheet[ref].t === 'n') {
				sheet[ref].z = fmt;
			}
		}
	}

	// This table is a bit more unusual, and requires more work to set up
	public static elementTableSheet(elementStructure: ElementStructure, project: ProjectEntity): XLSX.WorkSheet {
		// the array of arrays which will hold all our data
		const sheetCells = DataExportUtils.addHeaderRows(elementStructure, project, TableTitle.ElementTable.toUpperCase(), 1);

		// Set up the top headers, which contains the project name (in the corner) then all the column names
		const headerCells: string[] = [];
		headerCells.push('');
		elementStructure.columnTypes.forEach(columnType => {
			columnType.columns.forEach(column => {
				headerCells.push(columnType.code + column.name);
			});
		});
		sheetCells.push(headerCells);

		elementStructure.levels.forEach(level => {
			const levelCells: string[] = [];
			const transitionBase: string[] = [];
			levelCells.push(`${level.name}\n${level.ssl.toFixed(3)}`);
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					const cell = elementStructure.cells[column.id][level.id];
					if (cell.deleted || ElementStructureUtils.cellDimensionsEmpty(cell.width, cell.shape, cell.depth)) {
						levelCells.push('');
						transitionBase.push('');
					} else if (cell.merged) {
						levelCells.push('merge over this cell');
						transitionBase.push('merge over this cell');
					} else {
						const cvLabel = ElementStructureUtils.cellCVString(cell)
							? `[${ElementStructureUtils.cellCVString(cell)}] `
							: '';
						let cellContent = `${cvLabel}${ElementStructureUtils.cellDimensionString(cell)}
						${ElementStructureUtils.cellLoadString(cell)}
						${
	ElementStructureUtils.shouldUseReoRate(cell)
		? ElementStructureUtils.cellReoRateString(cell)
		: `${ElementStructureUtils.cellAptusDesignString(cell)}
									${ElementStructureUtils.cellLigatureDesignString(cell)}`
}
						${ElementStructureUtils.cellConcreteStrengthString(cell)}
						${ElementStructureUtils.cellUnitMassString(cell)}`;

						if (cell.aptusDesignConfiguration === 'nonaptus') { // export non-aptus colour if the cel is nonaptus
							cellContent += `|NONAPTUSCOLOUR|${ElementStructureUtils.cellNonAptusColour(cell)}`;
							cellContent += `|LEVELHEIGHT|${cell.levelHeight}`;
						}
						levelCells.push(cellContent);

						transitionBase.push(`${ElementStructureUtils.cellTransitionDescription(cell)}|TRANSITION|${ElementStructureUtils.cellTransitionColour(cell)}`);
					}
				});
			});
			sheetCells.push(levelCells);

			const transitionCells: string[] = [];
			transitionCells.push('');
			for (let i = 0; i < transitionBase.length; i++) {
				transitionCells.push(`${transitionBase[i]}`);
			}
			sheetCells.push(transitionCells);
		});
		const sheet = XLSX.utils.aoa_to_sheet(sheetCells);
		DataExportUtils.mergeColumnsPerRow(sheet, 4, 0, 1, 2);
		DataExportUtils.addHeaderImage(sheet);
		return this.formatElementsTable(sheet);
	}

	public static addHeaderRows(elementStructure: ElementStructure, project: ProjectEntity, sheetTitle: string, startingColumn = 2): any[][] {
		const sheetCells: any[][] = [];

		const emptyColumns = Array(startingColumn).fill('');
		sheetCells.push(emptyColumns.concat([` Project: ${project.name}`]));
		sheetCells.push(emptyColumns.concat([` Location: ${project.suburb} (${project.postcode}), ${project.country}`]));
		sheetCells.push(emptyColumns.concat([` Client: ${project.clientCompany}`]));

		// First cell should have sheet title, which will appear under logo
		const columnTitle = [` ${sheetTitle}`];
		const fewerEmptyColumns = Array(startingColumn >= 1 ? startingColumn - 1 : startingColumn).fill('');
		sheetCells.push(columnTitle.concat(fewerEmptyColumns).concat([` Job Number: ${project.jobNumber}`]));

		if (sheetTitle === TableTitle.TemporaryWorks.toUpperCase()) {
			// Hacky method of displaying additional information in a seperate column
			sheetCells[1][7] = ' Terrain Category:';
			sheetCells[1][9] = project.parsedElementStructure.info.temporaryWorks.terrainCategory;
			sheetCells[2][7] = ' Wind Region:';
			sheetCells[2][9] = project.parsedElementStructure.info.temporaryWorks.windRegion;
			sheetCells[3][7] = ' Ground Level RL:';
			sheetCells[3][9] = String(project.parsedElementStructure.info.temporaryWorks.groundLevelRL);
		}

		return sheetCells;
	}

	public static addHeaderImage(worksheet: WorkSheet) {
		// Putting data uris directly in code is bad kids. Don't do it.
		// But I was in a rush, with an impending deadline, and couldn't get the imports to work properly
		const imdata = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABbAAAAHfCAYAAACBNf4nAAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4nOzd+3Jb15Xv+zVT/p9sWRffJMJViXPxhZDt3EhbAKtOnTpn7/QWZCf2n4KeQPATiHoCUU8g8k87xzaVdCfnnDhNgBSZxE4i0kl3eiepMinavS2RUsQnWLsmOWCBWACIy1pr3r6farZigBJBXNf6zTHHUHEcRwAAAAAAAAAA2OZrPCIAAAAAAAAAABsRYAMAAAAAAAAArESADQAAAAAAAACwEgE2AAAAAAAAAMBKBNgAAAAAAAAAACsRYAMAAAAAAAAArESADQAAAAAAAACwEgE2AAAAAAAAAMBKBNgAAAAAAAAAACsRYAMAAAAAAAAArESADQAAAAAAAACwEgE2AAAAAAAAAMBKBNgAAAAAAAAAACsRYAMAAAAAAAAArESADQAAAAAAAACwEgE2AAAAAAAAAMBKBNgAAAAAAAAAACsRYAMAAAAAAAAArESADQAAAAAAAACwEgE2AAAAAAAAAMBKBNgAAAAAAAAAACsRYAMAAAAAAAAArESADQAAAAAAAACwEgE2AAAAAAAAAMBKBNgAAAAAAAAAACsRYAMAAAAAAAAArESADQAAAAAAAACwEgE2AAAAAAAAAMBKj/GwAO758vVSueVGF6MoGo8iFcWH/rud0pdNJi7+itL/YyOKoodRFG3KV/3JlX+rJ74VAAAAAAAAyIGK45j7GbDEl6+fG28JoItyq5phdSGK1ET3W/pVgN2F6nxxy9/v4WYUqcUnV3493/1bAAAAAAAAgHQRYAMGfHnu9XJLSN0MrEtR3DNEPiJkzjTAbl6/F0XRnP56cuXXDxPfAgAAAAAAAKSIABvI0JfnXiu0hNTFKFL6z+5V1PYH2E17EmLPJr4NAAAAAAAASAkBNpCSu+emC/GjkLosofXY4X/9iJDYnQC7SffMrj658uv1xDUAAAAAAADAiAiwgSHdPTfdDKqbYfXEwaupY9Arel3nZIDddIn+2AAAAAAAAEgbATbQp7vnpiSwVs3Qeqz9bwYcYOvrrz+58lEtcTEAAAAAAAAwJAJsoIu756YKLRXWlUeBdfcgN/AAW/+/hSdXPqomrgIAAAAAAACGQIANtLh77oe6yroqVdaTne+b7kEuAfY+QmwAAAAAAACkggAbwbt77ocVqbDuq8q613UE2AfiKHrnqZWP5hLfAgAAAAAAAAyAABtBunvuB5UoUm2hdateYW336wiwD8jtmHlq5aN64tsAAAAAAACAPhFgIxgHoXVrpXWvQJYAO2ngAHsviqLCUysfPUx8KwAAAAAAANCHx7iT4LO7536ge1rXuldaI0P6/p6X+x4AAAAAAAAYGBXY8M7dc98vHISmSgfXE91/v14VxVRgJw1cgd1EKxEAAAAAAAAMhQpseOPeue/rSt9qFEXneVStMhtFUTn0OwEAAAAAAACDowIbTrt3UG1dla/9autHz+jRqpm7634dFdgHOtwOqrABAAAAAAAwMCqw4aR7575XPgit1UUeQSfodi4E2AAAAAAAABgIFdhwyr3S96r7YWgcTR7c7mRVMBXY3fT6u33cttEqsPX1zz618qvNxMUAAAAAAABAF1Rgw3r3St8blwreau+hjLCc7lE+x4MEAAAAAACAfhFgw1r3St8tHATXSgfXYzxSzisTYAMAAAAAAGAQBNiwjgTXs1EU0d/aL+dDvwMAAAAAAAAwGHpgwxrdg+sOvZfj7tfRA7ubXn+3j9s2eg9s/f/OPrXyq/XEVQAAAAAAAEAHVGDDuHulVwtRpDoE1/CQXqQgwAYAAAAAAEBfCLBhzEFw3aniGh4rRlG0yAMMAAAAAACAfhBgI3f3Sq+OyzA/gmsAAAAAAAAAXRFgIzcSXNfka4x7Pkjl0O8AAAAAAAAA9I8AG7m4V3qlGkVqjuAaAAAAAAAAGI1SqiCtWptf4x3+wXoURZv6zziONxPXOoIAG5m6V3pFV9zOR1E0wT0NAAAAAAAADEcppUPqqnxN9vGPlJr/Qym1JRndvGth9tcSlwApuFd6pXCv9Ipe5VkivEaLOncGAAAAAABA/3RwrZTS4fM/oii61md43U7nc1eiKPpM/1tSwe0EAmykaqf0yvhO6RXdKuSz1lUeAAAAAAAAAINRStWkDcjFFO+6ixJkzyausRAtRJCandLL9LnGUdaPuB4AAAAAACB40i5kcYAC0Ubbfxf7yOiuKKUqURRVbG4rQoCNke2UXi5IDx0qrnEUZwcGAAAAAAAA5EEpVZTwuldb3pvyPV0HNEqbkLJ8davg1u1I1pVS5TiOrSw8VHEcJy4E+rVTenlW+uc0n1L7/7/zs0olLhn6urj7dY9+dvK6zG7PoZ/d/fre1+l/4Ijre/591eV+7/Nnp3h959uh9p5a+VWnibgAAAAAAAB4FF7Xe1RPL0RRNNsttO5GKrpr8tXp397TQbeNITYBNoayU3q5LFXXbStBBNi9ru99nfcB9s2nVn5VSVwMAAAAAACAZsi82SVg3oiiqDpqwCxV2boF8PnElZaG2AxxxEB2SmfHd0ov6yf5UjK8Bnqq97oSAAAAAAAgcN0qrxfiOC6mESzryu04jnWB4TuJKw9+9qIE6dagBzb6tlM626XqGujLPHcTAAAAAABAklJqVvpRt7sUx/G8hMrFxLVdxHHcs5AwjuM5pdTDKIputF01IRmONbvoaSGCI+mqa91bJ4qiywff26uVBC1Eel3f+zqvW4jcfGrlI9qHAAAAAAAAtJG+17cTV0TR9TiOdc9q/T1l6YgwiC0Jo+fiOH7Y6e8ppaodQmxt5qgQPC+0EEFPUnW9/ii8BoYyx90GAAAAAADQUafc5GYzvB6Brqa+ovtqS1CdoKu7dVCeuMKinfQE2Ohqp3R2ll7XSEHjqZWP6H8NAAAAAADQRiqrS20X62GKHQPnIene1jfkZ3UyK9XarSa6hd55I8BGwk6pWNwpnV2XFRpgVLPcgwAAAAAAAB11Colnu7X8GFHHim75WZ1uR6fLckcPbByyUypWD7YtqE4TT0WvXsj0wO51fe/rvOyBff2plY86vjkCgM+kh11zyMq4tOPSB4XrGR2IwiEtlS/dKmBC07pT62Ea0/VDwvMJR3Dy80cpVYiiqPXrYfN34T3CPy2D6VoH1O1/NtjSfxdHa3ndtmo+rq3aH9PNOI43Q72L5fn/j7aL9+I4br/fevXA3mgLpvX9fi3xXT3+7Zafsd5hkOSzph+jxxKXIEg7peK49LY5zzMAKdmi+hpASGR7XeWoz1KllD7AXNSfuyEfrIdETkwqUsHSvj0Ubbv+lNpfFN+TsGpTvuqEGAfk+VSVr/YTTKAr2z9/ZPG3+VnatY2lUmqv5ffgfcFRfbyX7X82yGfCTf2YS59eGCQBajOobi6cDnpsk9jtL4+z1pA/681jgABe550WoDv1w+7lYdv9VFdKPewymLFHwepXP7v971VMzzajAhv7LUPkAKDlIKFXtS0V2N1QgX1AbsfZp1Y+ojoCgPfkQH6+18l2D9cz3B4ICyilZqUi5qiTBfRnQ05qdaC9GNp9xvMJKbLm80eqNueHXODTYVeNqmx3SHBd6xRi9mFLHu/g3v9NkEWlslTzFrssNORlQxa2m8cA3hSBKKV0MHy57eKznd7XelRgN+I4TgThSqmOMVEcdw+fulSE62GSlcQ354gAO3CPWoa0HwR3fS4TYPe4jgD7QBxFl55a+YjVcQBek4M7/Rl6ccTfU5+MVTodpMJdEsgsUiGbqWYV5qLvYQbPJ2RkTz5/jFU3yu6lDuejA7saxzG7Py0ngeh8Cu9luiK7SgFAulp2jJXlT5sXS7ckzF6UQNvZ54JSqt62gLcVx3F7K5bm96YRYPdsIdLlNh35d7LGEMdA7ZQmx3dKxXnZFkAFB9J0nfAagO/kAL+eQngdSeX2bVsmfGN0coLeqX8g0jUmr8EP9TZZpdS83Pde4fmEDOnX0JKpzx/9mk3xfPSK/HuwlLyX1VN6LzsvLRKMBmo+0Pehfg9QSi1K1e0N+Wy1PSeaaB4D6Nutb7/8Hi4+J9p3n6RS1NLjPbGfRf/2hU3jzwcqsAO0U5qUCg7V44OjV7UtFdjdUIEdLTy58hEBDACvtYTXPT5Hh3aJ/o5uazlBp0DAnIb0xnX+tcTzCTnK9fNHgpU0FoHbLcRxzPmIZTJ8L9NtJcpUYg9OKnmrGb0OTXKuR36HKumuO0p6VGBvye6GpkqXcxV9/xSPasGilKp1GAI5Y3THDgF2WHZKk2V5MY/1DiQJsLvrfl3gATbhNYAgdNhSl7aOPe9gP1ncWB+yHzrStyU9fp0MsuX5tEl4jRzlEk5IxXenwWJp6Rr+IH85LMR1bJ2ApJbBmbVAjlX0Asec7ccBKQXY/diTBZ8jzzO6/ByjATYtRAKyU5qsyhOQg2Ck7RLhNYAQSDVCluF11Oe2PthpjvDaKvqxuKGU2nS0Rc8ix+3I2XzW2++ln3uW4XUk7UQINO0xn/F7WUmOz9CFtAmZlUXRawEdq0y2HAfMBt5yZiGKooLLRTIE2IHYKU/O53CggPDoyqaZJ1d+zXZ3AN6Tg96O1RApm5CTDDhEwhLftuH6ohlkr7sSaimlKjkslgHtJqQyM0t5nTfMJS5B7iRY7tTGIG2hh5MdtQXXVwJeFJ2Q338z4GPsi1J97ywCbM/tlifHd8qTaQ2ZAlpd172Tnlz5tRN9pQAgBbUcD/ypJHIPj5n9JmVgXeZVpilgEQum1LJ6fUgribwWZiZlIQhm5fVeNsbn8GEE1x2NyQ4NV3dm9bInM0AaPb7n2gABfqcFf6O95gmwPbZbfqnZa4rqDaRJbz159smVX9eeXPk1wzIAhCTPA90xDw+svSVhz/nQ7weHXJQqLCvDLQn58qhYBDoZk+FfWcg7YORz1CA5jskzOCXAlh08OqAluO6puTOrLp+5pu21/fxO4fFR1nUveOkHf7ZHkH1FWjkdJbGQabr9CAG2p1rCaw5+kYYtqbjWwXX1yZVf95xYCwC+kZOwvPsFcuLtDqr83KNP6j9USi1aWI3N8wmmZfUczLuFDwuLZuX9XjZmSRhphA4lZdD4h8zj6Jsu9rytlJozfCzQHgyP9DzWQbME2RuJKw/008qp/f16K/EdOSPA9tBu+aVqxlN+4bfm1hNdaf2OXr17cuXfClJxTXANIFQmwuRSnxUSMC/YE2YP6IBr3bLQg+FzMC3156B8nuUeqjHM0SgT932QC4DSa3yd3fdDuyzHAqbeL9rbsqa1GNPt/KXU63eV9+v2YljjrWMfS1wCp0l4zbDGsGy09CJqfVPZlK9DnlxZomc1AAxADuJMnRDU2BLrBAJst01IBdalOI5tGEzNwhVM0+HJeBzHabYLNPW85vVkjomCuqAeb6kaXiS4TsWEzMm4Hsdx3sfedWn50qrWI4Dui67EVkotdJmJN9tjkanTzyXARnp2yy/NycoR/NIMqJtvGPt/PrHSIIgGgHyYDJCrBNhAbnQ/TN0/stOJW57Y+g0bFFMOLAiwA9KrujNjwTzeMsdhnp33qbssz99qXj2f4zjWvbj32h7LSkoLiXNdAuySHPN0ep/vdBy0mLgkZwTYntgtvzTf5UkJd2zJtp/m1+YTK8tGm+QDAPZ1OojLy/4wR0uqQoEQXJRdF5WUq0+B0BEkAynRPZspXsyUbp+hQ+Vajsfg822P6ZhUSY9UyCJV2I0uVfqJKmxpR9O+kL5gwzERAbYHCK+dtCcVDevNP59YXuEkCQAsY2CCfifVPoetAEhHSU5cy4TYAABb0DIkV2OyM6uYU0uRTosSuhp8PoVKcB1ULyUubavClgX82cR3WXIeQoDtsN3yi+MHT3JFeG2/LQmq97+eWF5J9KYGAFjJdCuBSA4ui3ltYwSwb9JgiN2+jRgwgfMVwCIy1G+xQ3UssnVZ7vtMd2bFcbzZpV/1/KjHItKipFsVdq2lXVSnljSNLm1GckeA7SgJr+sdJoPCDs0K68WDwPoWB4AA4BjDwxvbjTzIBcDATIXY61TXwTQdpvAgAHaQnsyLHcJF5COvnVn6eL/S9jhPSrCsL48kTFaJv3mEOI579qXXld5djj2smcVDgO0gwmtrbcjjMv/E8i2q5ADAfTYNT0xrkAuAwZgIsQmwYVqDRwCwg7Szu8HDYZw+HtiU44FM8h59nCE9qNsf7/MSMNeyOBaRf7tTZ4erNu0A/VriEliN8No6OrR+J4qiZ08trxafWF6tEV4DgDdsqngea1ZeAMhdM8Qez+kHW7FVF0FbDP0OAGxAeG2dMTkeKGZ1w2Ro5ELiioOAuS47RFOhj2uUUotdwmvdOqRTP2xjCLAdQnhtjUOh9anl1blTy6tssQMAj1gyvLGdTRXhQGgm8wr14jhelPkpgCkE2IBhhNfWyiPErkru1E4fi6zLc2MkSqmK7Pg63+Hf2bCxcIYA2xGE18bpk4irhNYAEAwb+01PZnmwDOBIJdlmmwcrJv4jSAv0vwbMIry2XuYhdhRF5S4htv7ZN5RSm8ME2Tq4VkrpbPHDLgNB9c80McD6SPTAdsBu+YXxKFKE1/nbk+qD+VPLa2zlBIBAWDa8sR3DHAGzLuoTP9nimxm9bVdOTDudXAJZ0ec/Vm0ZB0JDeO2MsZYZGam3kZV+2GVZ0O5UJT0hQfac5FY6s1pvvy0SshckEK8ccVxhbXgdEWA7Y47wOldbcuC2eGp5jWFZABAem1t1MMwRMG+/8imO46wLHHSIsZS4FMjOLNXXgDmE185phtiFLI7N5d/Ux/46n7qS+IYDY9LDer+PtVIq8Q19uh7HsdXtCmkhYrnd8gvdpoEifbpR/syp5d8UTi2vzRNeA0CwbK5wZpgjYIfFrIc6SkB+KXEFkA3dOmSO+xYwQ6ptCa/dM5b1oGcZpnhWD1ZMXDk6XcA5Y3t4HRFg243wOhd6m9z1g97Wv6meWv4NrUIAIGCWDm9sxzBHwLyxPAbdSasSQmxkbUGGhgEwQNo8MDzVXZNZz67QrUHiOC7LMUGn3tiD0sH1pTiOCznsKEsFAbaldssvzBFeZ0q/WN/RvYBOLf+mdmr5N2yVAwBEjvSXZpgjYIeSbOvNVEuIvcfjjgxcJbwGzJHK3UUHCijQ2/m8jgniOC5KRfZ1ybb6tdXsPCDBtVMDo+mBbaHd8gv6AOJy6PdDRvb7W59a/i2T3QEAh1g+vLEdwxwBO1xRSi1mMcCplT7J1MMjpcLLlfcp2E2fF1VdqbwDPLZ4xGA9uEMfE+hK6Tx2aK3L+UBNFkGKMqixE/0+v+n6jAMCbMtIeE3fo/QRXAMAjuJSaw6GOQL2mJcTx0zJiWdZ+qTq96vzPAcwBL31fM61yjvAR1Kx68uipM5c9OeUDlabx6e9Fsj05+a4fOn/XfAkyNcLzsU8w2I5H6gfcX87jwDbIrvlF4qE16kjuAYA9MuliubmMEc+38J21ZPfvtDy5eLJq27rMytDljInFbPNgVHllhDAt9ZCRUNb6rMYkmXSZstX3fUKPMAXshh5xeFf56aE1fozaX2IooqOYavcL83PNhcXasfk+LxbNTSGRIBtid3y88UoUh1fwBiK7hFYI7gGAPTDkeGN7WoE2GHLKzDNU0soW5ZFGlcCbb1teN5AxdWir4O/pGVK7pWJMiQLADLT0vfaJXvNz5wsW2Q0F2mb/62UqsjxQMWhY/VSngvboWCIowV2y8+PywkoTftHtyfVSAXCawDAAFxqH9LEMEd4R4ey+sQ4juOaHjCkBw3JwCEXcOwJAOiHS/mP3pVyIY5j3bqumkd/51ZyTKB/7rgMNHZll8wVjtPTRYBtB726NBn6nZCChYPg+nezp5Z/R09QAEBf5ODS1c9hF4N3oG+6EkufuEZR9KwDQXZJtj4DANCRVBS70BpDf+Y+q3el5B1ad6N798sumbOOLG7PJS7B0AiwDdstPz9PeD0yvQJ39uTy76onCa4BAINzOQSuyDZUwGu6NUdLkG1z9RVV2ACAjuSYzfZQsxlcV23tmR/H8bojxwR6YZtik5QQYBu0W35eP5EvBnsHjE4PaLx0cvl35ZPLv1t3/ZcBAORPTiQqDt/1Y47ffmAgEmTr6qt3pHWcbSakpz4AAO1mLZ7tsKHbdtkcXLdrOSaYkXzIRrMUm6SDANuQ3fLz+kV2LchfPh3X9VTak8u/o8oFADAKlwbCdENlB4ITx/GcDHrcsPB3Z2gTAOAQpZSe63DZ0nvlahzHRRmg6By53UXJiWwzRiuRdBBgG7Bbfr7g67TwHGwctAv5uHZy+WPahQAARuVD+MswRwRJbyGWENu27cNUYQMA2tlYfLefr8Rx7PzCqwyBrkk1tm07tC7KAgZGQICds93y8+MSXrte7ZU3/Qb0zsnGx8WTjY9pFwIAGJnjwxvbUYWNIMkJa9nCYU5UYQMA9smA35Jl94b+3CzLYrA3pBq7YOEOLaqwR0SAnb85hjYOrLHfLqTxMS94AECafAp9GeaIoMkwJ5tCbF2FTX96AEBk4aLmJel17eWudlncLlp2XHBeFjIwJALsHO2Wv8PQxsE0q67LJxsfOzFEAADgBg+GN7ZjmCOCZ2GIzc4IAAicZdXXOmO5EMdxELPE5LjgauIKc9idNQIC7JzcL3+nyNDGgejtHuWTjU+ougYAZMGH4Y3tCMsQPDlZtWXbcImelwAQPFuOz/akZUhQ89ikv/elxBVmcFwwAgLsHNwvf2ecoY0DuX6y8UnxZOMTel0DALLiY9jLMEfggK5227LkvmBhCQACJWHleQt++z0f+133SyrObQmxqcIeEgF2PvSLZSKEX3RE+k115mTjEw70AQCZ8Wx4Yzs+QxE86elpS0sdWvsAQLhsOC4LOrxukhDbhjZjF6nCHg4BdsbuH/S9tmHFzXZ6UGPhZOOTeuh3BAAgcz6HvAxzBA5OVPWJ+jsW3BcMcwSAcFUt+M1roYfXTRbNyrDheeEcAuwM0fe6b1dPNj7R/a69nIALALCHh8Mb2zHMERBxHM9JkYRpvCYBIDCyeGl63so7oQxsHEDNglkZBNhDIMDOiPS95o2iN2kZ8nt6AAEA8uLj8MZ2fK4Cj1TlmNMkAmwACI/pkPKmLOSihbQZM31swO6sIRBgZ2fW4/6aadArXsWTjd/TMgQAkKcQekTrg+Jy4lIgQHEcb0ZRZPoEfozXJACEQ3b8mWwlu0WVb3fSUsV0wQePz4AIsDNwv/xtvZJy2btfLD2651D5ZOP3m778QgAA+3k+vLEdB8WAiON4Vk7mTaLSCgDCYXrRsiqVxujCgjZj55lbMxgC7JTdL3+b1iG9XT3Z+H31ZOP3vJkCAPIWQvV100UOioFDTFdaUYENAOEwuWi5EMcxO937Y7rgg8XtARBgp28+gN6aw7pEv2sAgAkBDG/shCpsQMgQK5NV2JMsKgFAMEwdc+4FVrAxEmkzdtXgTSDAHgABdoqkdYjJPke20m+iZ082fk9lOgDAlBCGN7bjBAY4jCpsAECmpGWdqWPOOVqHDGzO4EBH2ogM4DFnbqnlaB3Sla50qZxs/GG92zcgf//1+v9RVl/91Ljt57f/dxQ9ufJvbEEC4LoQdwDtD3NkGylwQFdhK6XmDAYLOtRYTFwKAPCJqcXKPQuGFjtHB/5KKV30ccPQba+QJfaHADs9tA5J2jgY1vgHVgBz8F+v/Z/6pGhcTo70n4Uoigvyk4uR0s/PZDjdj//1+kzrd+1FUdxckNBbbjZVtL/Kqy/bfGKlwXBOAFbRIa4OcwN9VHQbEQJs4JF5g8PWqcAGAP8VDf2GVF8PSRa4Zw2dL5QJsPtDgJ0CWod0RHidgf967f+SgDouHgTUUfPPDm+0w4XVSYl/Ry/UlOR/l9qv/PJ1fVG8IeH2ugQnm0+sLBNsAzAl5F7QephjjRMa4CtzBgNsU6EGACA/phYrCUFHo++/KwZ+LscGfSLAHhGtQzpqSNsQTpZH8MVr/3czrNYfgEV18MbWIai20qR8nW9+CHx57vUtCbT3Q+0nlleoCASQOekrdzHwe7rKllLggB7YpJTakOOUvI0ppQoyNAoA4CcT5+w3+WwZ2ZyhANvE8YiTCLBHR+uQwxZONP4QcqXb0L547b+NH6zW7gfW5XzeyBLV1VmakK/9UPvLc69FstixeBBo36JPOoAsmP5M2pID4muJa/JTI8AGDlk0eMJYkF1qAADPSNs6EyiqHJH0wl6g8MVeBNgjuF/+dpnWIYcQXg/oi9f+W0XC6pwCa+uUmm1Ivjw3vacOTij3A+1Ty6tU8ANIQ83wvTgvXyYDbIY5AoctGqqyiuSYj9ciAPipYOi34nMlHfME2PYiwB7S/fK3xqNIscr1yMKJxh8Jr4/wxWv/fVymzDaDa6r3HxmTD4v9D4y756Zuygnm4qnlNcJsAAOzZHjjvCUVHQxzBEQcx+tKqT1Dx2HjiUsAAL4wEWA3mHWSDl3soZTaCnj4u9W+FvodMIIaT+qvEF738MVrPxr/4rUfVb947b/rMPYfURTdkMr9DidNubb0sN15ua/+cffc1Pzdcz+shH6HABiY6c+m1n6Ephe9L0o/cAAHTC3oMKwJAPxl4j2eAoV0Leb88/YSl6AjAuwh3C9/q2Bw26FtCK+7+GL6R5UvXvtRe2jtHZXPL6SrFj+8e+6Hm3fP/XDu7rkfmtqaBcARlgxv/Cq0lvYdW4nvyBef18AjpmZvsJAEAP4y8R5PgJ2uvItOePz6RIA9HFqHHNggvD7s8+l/Lnw+/c9zX0z/SG/h+ZAe6anTux4uR1H02d1zP1i8e+4HVGUD6Mb48MY4jtsrOEwPUjTdDxywiakTxhBnngBAKEwE2KYWZL2k24zlXBVNgN0nAuwB3S9/q9IcOhe4DenhjIPguvL59D/rN57PJGDt0B4EvQxRyX3+oCr7B5t3z/2gevfc96loAtDKhuGN/VyWpwmD0/EB22zyiAAAUobuhNEAACAASURBVJb3IuUe/a8zkecxe94tS5xFgD2Ag8GNxqunbLAfXp9o/DHoN8rPp//H+OfT/1z9fPqfN6Xa2t6FjZz6fBgyIS1aNu+e+/7sPYJsIHi2DG9sv0BOMBYS35kvdk4BB69HYwE2/egBACmh+jobeeV+CyaPR1xDgD0YBjcebKUIOrw+CK7/x6xU7twY/jkR0MBGlcvvOia96Tfv7QfZ3+PkEAiXTcMb2yWC7ZwxzBF4xFRfegY5AgBgKTmOv57xrdPZ2mziUnRFgN0nBjfuCzq8bguur3RvExJQMG2nliD7e7P3SgTZQEhsG97YjmGOgFW6LTQBAOACKrCzM5vxMftsj4IXdECA3T9WRqKocqJxO7g3yM+nz49/Pn2+j+C6F59CbWd+l0dBdkkH2d8lyAbCYOPwxnYMcwQAAMCo6H+dEWn9V8looKNuHUJ74gERYPfhfvlbZQuquUy7dKJxO7jpqJ9Pn6+OFlznZbBQ2e+W2AktQfZ3qToE/Gfj8MZhvidLDHMEAAAAeojjWBdwllMOsXV4TS4xBALs/oRefX39ROO26ZPtXH0+fb78+fT5delxbXFwjZ4OJ/X6cbxxr/Td9Xul7xLcAB6ydXhjO4Y5AtZg6zUAAOiqJcROo53IdcLr4RFgH+H+zLf0k6vU+7u8dvNE43YwW40/n64UPp+u6K3fS1EUTSa+AT7Qj+vSvdKr8/dKr9JWBPCLzcMb2zHMETCPrdcAAKAnCbH1AOarQ1ZjN6IomonjmDZ+IyDAPlrI1dcbIVVofT5dqUklzvnElcMIrE+Hgy4etBV5lQ8RwAO2D29sxzBHAAAAjKjAHZgPvYMyjuNZuc/fkbysly3ZcamD67Ic+2MEj3HndXd/5pvVKFKmtyKboleVqicat72vTPl8ulKU0IGK6/DotiLX7pVerUZRXD3Z+ANbiQF3uTC8sZ0e3nItcWl+ahYMlARMoqUYAMBlBNg5k1aA+vh5TgpodJ7U/HOz+TXArkz0iQrsLu7PfHM88JM6HV57H+Z9Pl3RK2i3D4fXgw1EhBf043/7XumV0PvdAy5zYXhjGn8nTQxzBAAAAIYgVdl1XcSiq7PjOJ6X/ya8zgABdne1gIf36aGNg1aROWV7+kLh8+kLOqC/4vPvObi8wntrFwmu3Cu9sr5TeqWYuAaAtZRSFReGN7ZjmCMAAABGwHkrgkGA3YFUX4faF3fjRGPd6999e/pCVXpd0zIEnexXY++UXqY3NuAOl4Y3tmOYI2AOz30AQJoaOd+bYxzHIRQE2J2FWn2t+15XEpd6Ynv6wvj29AUdFNwI8/GlNcqAru2UXq7vlF7mgACwmFKqkNrw3eENHUIzzBEwylQxA1uLAQBpoQobQWCIY5vAq6+rJxrrXh5Qb09fYFAjhlHSJ5k7pZerJxp/9Lqtjo22p348LgO2ynJgVki2iVCRTIDWrRjq8cHuivqZtZ96P4AWX3FxeGM7hjkCOZPFLyPojQkA3tqUc8g86XOlOk8p+I4AOynU6uvrJxrrXgZ029NvVCS8DrWnOUajnzcf7pTO6t7wtBXJmITWVfnqd8Gp+X1fHSzemfrJzSiKFs+s/dR0ewZkz3SAncZzbN5wgK2HOVZSCOIBlxgLsAEA3jKxQEkFNoJAC5EWAVdf6+rF2cSlHtiefkP/Xh8SXiMFl3dKZ9d3SmdpKZKB7ak3C9tTb+oQ7x8S5I26W0K3lLhxZ+onD+9M/WT2ztRPeNw85OrwxnYMcwSMKBv6uRuJSwAAvjARYJv6PANyRYB9WKjV17p1iFfb7ben3xjfnn5DhwpXElciZWn01namP/fkQUuRsxwkpGR7+s3C9vR+cP2ZHiaXwY8Yk/eBTYJsL7k8vLGd6d0C5022VAAMMFWxRosrAPCXiQB7TIo6AK8RYB8WYvX11RON9fXEpQ7T4bX0gMoiDLMAwxi7UV0uT/nf0IHo0k6pSLXiiLan39Tvues5vVabQfb6nam3OMDzgCXDG1PrG80wRyB3pgJs+l8DgKfkeM4Ezm/gPQJscX/mm9UAq683TjTWvWodsj39RlHCa6+GNaYRzCJ1N3ZKRforD2F7+s3x7ek3F6VVSN7vu7rdxId3pt6avzP1FtXYbrNheGPaJymmBykSYCMIsgBmqv0QATYA+M1EQcJFpRTnNvAaQxwf8bIH9BG8OlHdnn6zGV7T77q7Rts1vcIXfX+2fgjmPU3ZBRd3SkV9ElzxrQ1PVnR4bckik676Lupq7DNr7xEmuMn0Z1gWYTPDHIF8mKxU82rnIwAgYd3QImkt0FwLgSDAflR9bXoIVN68ah1CeP2VhlT2bMoHpw5V159a+VVq4er/er1ckMn9za+i/OlV1fsAdLBf3ylNVk40NghCe7DwdTopLUXKZ9beI1BwiC/DG9vpYY5KqQXDLbD0MREBNnxncgGMYwUA8FvdUJu7mlJqToaDA94hwD4Q2pbZjRONDW9W5gINr/fkd16XPzefuvX/53JC9ORKfbPbydeXr5fKEmgXZRpyKAtD+0HoTmmyfKKxQRDagVRez1v4OtW3p06I7RzTn9sLGZ4czBsOsPeHOaY4nBKwirQPMbboHscxnzUA4Ldeu5yzNEYVNnwWfIB9f+a5chSp0FojeBPYBxReb8nvuf/11K3/z8pg4YmVRr31A/vL188VJMguy3bdPh8nJwdV7gehO+XJ8ok6IXYHNvem14/d4p2pt4pn1t6jYsFylgxvzKz/ve6rrZTaMrwAWOXkBx4z2T6kvZUbAMAzeqFSKbVnKKO4opSapxABPgo+wA6w+vq6LxWi+YbXRgLVhmzjrj916/918jF7YmV5U4Ke/bDny3OvN4NsG7b/Z2E/xN4tv1Q7Xv+UAY9ie/rNOQdazEzI662cuAa28XF4YzsdHt9IXJofAmz4rGbwd2OBGwDCYKqNSCTn3pzTwDtfC/khvT/zXMHwNt28bflyQro9ZW/ltUpcMpCbURRdiqLon56+9cvy07d+Ofe0o+F1J08sr9SfWF6pPbF8S7/2zuoFFWmH4hP9nLyxW34ptMWxjran39CLFZc7XWeh0p2ptwjt7Ofj8MZ2i4bfGyekzzjgFQv65xNgA0AYTM4TKele2IlLAccFHWAHWH1dO9HYcH57/PbUj31rG6IXFt6JoujZp2/9svL0rV/OP33rl963MXhi+db6E8u3dJiteyNfkPDeJ8GH2NvTb4znFPal6YpuJeLYbQ6Gr8Mb20l/bdODFFmEg49MVl9HBvuiAgDyZfo47rJSimM5eCX0ANv0QWyeGicaG6bfREeWbnhtvM/yQhRFM0/f+kXh6Vu/mHv61i+C7VP1xPLq4qnlVR1MPdu5KtvJntgRIfb+e6yLrWKoWLCXz8Mb25l+Hp6XfuOAF5RSeju1ybk3W/QkBYAwyPGi6QKtG4TY8EmwAfaDmeeqAQz+a+X8G9f21I/HPai81sHs1YMWIb+oPn3rF1TitDi1vLp5anlVh54FqUrfSnyTe27sll8M7sBBqq9dXSTUrUToG2cZ34c3ttMDgKIo2khckS9OeuAT04tCHPMBQFhsKCAkxIY3Qq7ADulFfPVEfcPpio9EeD1io2kDtiS4Ljx9619nn771r963CBnFqeW1h6eW1+ZOLa8VpCe45UH2kRXiIYbYNccXm+iFbZ8Qhje2Mx24ccIDL8jJu+lhws7vhAQADMT0TJMmHWKH1H0AngoywH5wMLzR5BbCPO15sh1+0YITj2HsV1w/fetfCa6HdGp5bf7U8m8sC7KHamkyt1t+MaTeyq4fJJXohW2dEIY3tmOYIzAipZQV8xjiOCbABoCAWDLTpOmaUmpRPhMBJ4VagR3S6lPtRN3twY3bUz+ed3DBYe9RxfW/UMmZglPLv9HPg+LB/RrbsJI9KF2NXA8hxN6efsOXFk1UKlhCqie9H97YjmGOQCrmLfhM8m1QNQCgPzYVE+pWfJsUJ8BVoQbYoZyMbR2vb+R+wp2m7akf68fq4uF/0paBfl1vhz5JKerg+ulb/0LFdYpOLf/m4anl38xKj+wFB38FCbFf8H0wmi8HRZU7U29RpWCHkIY3tmOYIzAkOUk33Ts/on0IAIRJZpo0LPrl9fnoh0qpulKK3aZwSnAB9oOZ5yoBDW90unpwe+rHeojajcQV9tLtLWaeXv2XytOr/8KU+QydWv7tw1PLv9WB1owFQ84Gpd9/FnfLL3gZjMrwRhvCgjSMeRTGO0vCU9O7cIwtBjPMERiOvHfYUMixR4ANAEGzcUe2Pra+rZSap1ABrgixAjuUk7DG8fqnzh4sb0/9pODYwf7VZ1Z/Xnhm9edMmM/RqeXf1k8t/7YYRfE72faJ7VptP6xJj09my4lL3EYbEfNMPwYmhje2Y5gjMADp8bloSdHKosEdHAAAw+Q40qYq7FZ6t/tnEmRTkQ2rBRVgP5h5zqfKwKO43nfZlpOOo+iquLPPrP6cPtcGnVr+3Zz0x7b1wKCT0m75Badb/HThW4A9yTBH40Ic3tiOYY7AYOYsGv7t42c9AGAwtucFF6Uiu84xH2wVWgV2SNXXzlYCb0/9JOWTjmT1rEpcMpTrOqx7ZvXn6+ndVgzr1PLvNk8u/06Hp++MPuQx+Zzpy+BPrIu75Rd8e1/yMeylCtsQGd5oejHTePjEMEegf7qKLDk/xZgNC3ZwAAAMk88CFwb6lqRHth72WJMdTYAVCLD95Gw18PbUT/Rq3+XEFXbR4eiFZ1Z/Xntm9edsCbXMyYNq7LJDvbFv7Jaf9yn09THApgrBnJCHN7ZjmCNwBH2ybVF4HVmygwMAYIea4R11g5iIouhaFEX/UEotUpUNGwQTYD+Y+UbBoq2EWXK2+vrOQd9r27dZ6lC0+MzqzxjGY7GTyx+vn1z+uChV8h0qqo/679wt7paf92V128chuWN3pt6i+jRnoQ9vbMcwR6A3pdScnGzbYi+OY9qHAAD2xXG86ejC5nmpyn6oP2vplQ1TQqrADmXFyOVezPOjhV+Zh5ALBy1DfraZuAZWOtn4WK9yX3BgpXvC46GOvqDqIH8Mb0ximCPQgbQNsW0HH9XXAIBD4jiedWincLsx+ay9LS1GCLORq5AC7BBOulyuvp61oNKul6vPrP6s+szqz2gZ4piTjY8Xpa2F7QcKpd3y8/Rattf5O1Nv0z4hXwxvTGKYI9BC9+bUA6csaxsSyeuUABsA0IkP2dQEYTbyFkSAHVD7ECerr+9M/US/0V1JXGGPS8+s/szlyvbgnWx8sil9sReyvi9GHBB6bbf8HT747UVwlxOGN3bGMEfgEaWU/lxft7QAYs6i/vkAAItIW7h3PHpMOoXZnDchdaFUYIfw4tlwtfra4r7Xunrm7DOrN+lf6IGTjU8enmx8ooOXq3b9NonWN4v3y99h2rOdCO7yw/DG7hjmiKBJ1bV+HSzJSbNtqL4GAPQUx7H+nLjZ63sc1Qyzmz2z9QDIqv7s5hmBUYUSYIcQOjh5oCytQ2ysjt876Hd9cz1xDZx2svGJfs5dsvh3mHC8l70rk7WHMUkbkewxvLE3hjkiZEop3Wpr08J+161qVF8DAPpQdbgfdj/GZADkjSiK/qGUWldKzdJqBMPyPsAOpH3I1vH6p85VCVvcOoTw2nMnG7/Xr5ezFoetl++Xv1NOXOoG3183bIfLHsMbj8YwRwRDL2rJCa8Oha9Z0F6ol404jtm5BwA4kix2VjwvAGo1KfnPbanOnpfqbAqE0JcQKrBDCBtc3aZo4e2OCa8DcbLx+3Xpi23rAcO8o61EfH/tENxlj+GNR7NhmCOvBWRGQuua3nocRdFncsJrc3DdxDBmAEDf4jjetPycNCtjMoBZV2d/JtXZDIJET4/1utITrlYx9mvP5q3O3dyZeqtm4dAdwuvA6BD7XulV/R5Rt/DEuNlKxLWT4brlW7tHtd9G5Mzau5tu/xp2Ynhjf3TFjgR7Fw3ejKqLxx++kUGGLivIl6YXbYvy5UJY3W7Bgd0bAADL6PZwMvRwKeDHZlK+Liul9qRYQ3/VacuFJq8D7Acz3xiXnjs+Wzxe/9SpF/SdqbfGj+7xmxhslzXC60AdhNivFOUD0rZ2Q5fvl789/3j9Ly49L0M4ea8woCszDG/s35zhALukq2SlcgjmhHyya5M9qq8BAMPSC6BKqUtSkRy6ZnX2/nGuUupmM9AmzA6b7y1EfK++jhwNUeYsrKypPLO6SHgdqJONPzS3bm1lfw8MvDjjVIXj6dUPHno6UbsVrRMywPDGwVgyzJHADjhQ5aQaADAKmaFwIcB2IkdpHQS5KH2zXWy1iRH5HmD73v9643j9T06Frnem3ioarhjr5NIzq4ts+QzcycYfbB2iMXm//G3XQqLFxCV+2W8j4vnvaALDGwfHMEfAvOtxHPv+uQcAyIF8noTYE7tfhNkBowLbba5WX9vk6jOri/TwxL6TjT/YOthx9n752y59MJseMJeHEAYE5810GHpEaysrmX6tjTHMEYHbcPS9AwBgKdlll9PuYKclwuzQ7xDfeRtgP5j5RlGGoPlqz7UqxztTb1UsG9y48MzqIicdOOSEnSH2mEsnyNJGxPeFIQLsFFkwvNG5z9RIhjlacLs5WUCo9mgdAgDIgoTYOtNqcAf3ZT/MVkrpQefzSqmiA7cZA/K5Atv36uvF4/U/uXbAbFP19Qa9O9HNicYf102FMipxyVf0QEeX2lb4PuSwdGfqbbarpcf0+7HLQ2FMv9ZK0r8cCE1NAgYAAFKnj03jONa51nXu3b41B0DeVkqtK6VqtBjxBwG2u5wKh+5MvVW1qCJ+T4Y2UjGDrk40/qirGi91u94QZ173p1c/2AygYoAq7BRIhcSk4Zvh7IILwxwBI67LsC0AADIVx3GN4Y5D0ecX16TFCFXZHiDAdtOWa8MbLWt/UH1m9cPNxKVAmxONP+qT04XEFQOJ07xbz98vf8ul9zbfT+59XyjNi+nwc8ODKkqGOQL5aUiYAABALmS4Y4GWIkNrVmXX6ZXtLi8DbOl/bbKXZtZc631tU/X19dOrHzIpHn070fhj1YLqRrEfhrvUC3ve80oBKrBHJFv6TN+Pzre7kUpQhjkC2dvgvR8AYEJLS5FLVGMPrSS9sjdpL+IeXyuwaR9iF1sCt43Tqx9SMYNh2DTUseRYFbbPC0Zjd6beZivaaCoMb0yN6R0PBNjw3ZY+HmBoIwDAJClcKIy+UzhoE9JeRAfZswTZbiDAds/G8fqfnGl/YVH19R4VMxjWicbth5Y9f5ypwg5gmCNtREbD8Mb0MMwRyM7+cSThNQDABlKNrbOWs7QVGYkupLlCkO0GAmz3uNZT1pagbfY0fa8xghON2/Uoiq4e/S+k2vO6G2eqsE+vfrAuVWu+YmFsSAxvTFccxzYMTmWXE3y0J5XXrvfKBwB4Rn82SVuRGc/PubLWGmRzPGsp7wLsBzPfKND/2g53pt4qW1J93Ti9+qHvVaDIwYnG7Vl7+mE7FRT5PMyxlLgE/WJ4Y/poIwKki/AaAGC9OI7rcRwXpD82QfbwdJZ4TXpks9PWMj5WYPv8JNtyqX2IJdXXe5xQI2UVS/phn78/801Xtuv7HGBHd6be5uBmQAxvzAbDHIFUEV4DAJyijwUlyL5Aa5GR6ELMJaVUnRZ59vAxwPZ5oJZD1ddvFwatTFSJS1JB6xCk6kTj9qYVizMHLxgnemGfXn1/06LK9SwQYA+O4Y3ZoQobGJ3+zCoQXgMAXBTH8WJLa5GbPIhD05nWOm1F7ECA7RaXTrZtCNY2Tq9+QOsQpO5EY33OkhXtyv2Zb7oyaMLnKmwC7MExvDE7DHMERtOQymsGNgIAnCatRXThyLNRFF23ZCexa5ptRajGNszHANvXfqR7x+t/qicutdCdqbdt2BoeMUwKGcvh+XXkQMgxh6odfa12jeiDPRiGN2aLYY7ASK7rijXCawCAT/TxYRzH+vis2Sfb592xWWlWY1O8ZIhXAfaDma9TfW2HbLeG99drZOH06gdOBP5w04nGut5WfLWPkDlrTgRFvrcRoQ/2QBjemD3aiACD0RVpl+TkHgAAL+kFWumTrbOzs1RlD2xMemM70crTN75VYPscYLsUxtYsCPV4Q0Ee5iz4wJ+4P/NNV8JTnxeVCLD7wPDGfDDMERiIXlwtyusGAIAg6IIOvXAbx/G4DH2kV3b/riil5uXcBjkhwHaHK+1DChZsDb96evUDBjcicyca6w8tqYB2JSjyORzw+fMnTQxvzA9V2MDRruoqNGm9AwBAkGTooz5O/ydpMUKYfbSLOqcjxM4PAbYbto7X/+TKgXXGYd6Rld17IVTXwR4nGhvzFrTGuOjCMMfTq+/rtg1biSv8QAV2fxjemB+GOQLd6T7xZ+M4ZsceAACipcUIYXZ/Jgmx80OA7QaXtt0b3xp+evUDBu8gbzZUYdswOLUfvrYRGZMdKOiC4Y35Ypgj0FGz13U5gF74AAAMjTC7b4TYOfEmwH4w8/WC4W3JWXKlfYgOJyYSV+SH6msYcaKxUU8nKBqpd7wrQZHP7RtoI9IbwxvzRxsR4MDeweDlqECvawAABtMlzF5gAORXCLFz4FMFts+Vb65ULJo+UZ2n+hoGmd6GPHl/5jkX3gd9HuRIgN0FwxvNYJgjcCi4ng2ohRAAAJloCbOrMgByJoqi6xa01TSNEDtjPgXYvvYf3Tpe/7Mr/a8JJxCs9KqwR2J9G5HTq+8/9Pjghj7Y3TG80RyqsBEigmsAAHIQx3E9juOaHoocRdGzLa1GQqzOnvS8YMsonwJsX1c5nNjubEH7kIXTqx8wQR6mGazC3m8/4kpQ5GuQSAV2dwxvNIdhjghJQ3pcjxNcAwCQLz2DpdlqpKU6+2pg1dmTSinalWXgMY9+FwY4mkX1NYJ3or5R3y2/tGVwMWfywcxzhWNLf7V9MUe/r11JXOq+/UGOZ9beZTGthVKqbMHwxnW5HaEy+b4UyQIGAx2RlQ3ZabAow0sBAIAFdHW2nPvNtrQULFuwOzNrF5VS63Eck1OlyKcA29fqHlcGTpkMsDdOr77PJHnYQldh3zB4Wyq2L+icXn2/vj39ZuJyT+jFVAKUw2zYGXAtcQnyVCXARor25GS4TmgNAIAbZFfUfLO9nRSXVOTLZKFFVq4ppeoBDpHPjE8tRHx8wkfH63+2vgL7ztTb44NX18WJS0bAqhZssmi435crVaam+4VnhTYiLaTS4mLiCoSGYY4Y1p58XlyXnppnpT2I3po8R3gNAICbWnpnF6R39jsethpZZKhjeryowH4w83VfAwNXXrym24eEOpgLFjpe//Thbvklvap82dCtO5+4xE56ca7kyG0dBAH2YYSWaKpZMFDSR1c9+502m7tYZNsxAADwnCxI68LEOZmdUpHzCNNtCEc1ITu02YmYAl9aiPi6ouFKVYnJis+F06vvM6AHtpnrL8BOdSfCVx7MPFc5tvRX2xd2fN1KxbC6wzhYQ5MeaFNkG2W69KBCn34fAAAQti5hds3hrguXlVKLLMyPzpcWIr5WvLlykmcywKb6GtY5Xv900/AOChfaiPj6Ae56lUBqpK+dl+29MDQWNAAAANAXHWZLyzAdZJ+VlmIm23UOa55WIqPzJcD29YngQv/rgsGAYu/06vsE2LCVyd7s1gfYsnNiK3GFB+5MvU0bkQO0D0G7CgfvAAAAGJTexSc9s8dlLoZLM5UmKOQYHRXYdnOhhQjV10BnGT8/e7YfmXww8w0XWlnQRsRTDG9EF2MWzM0AAACAw+I4no/juCzDH12pyq5JSxQMiQpsix2v/9mFANvk4gEBNqylhzlGUXTT4O1zoY2IrwE2FdhUX6M7qk8AAAAwMmkxUpMCoquW7/Adk4GOGBIBtr1M9s8dRAZBTc/K0q/QPgQOMPkcdSFE9bUPNivrhJTobn+YY9drAQAAgAHEcfxQD7aWXtmXLA6yL1KFPTxfAmwfh2Y9TFxip5KhW2WyshXoV1uA3d/iTEqowDYn6IMShjeiDyxwAAAAIHXSXqRZkW1jaxGqsIfkS4DtIxcGOJoMyHyt3IRHpI2IqeES1i/seTzIMfRVddqH4CgMcwQAAEBmdEW2nJctWHYvX+Q4eDjOB9gPZr7ONlRzTIY0BNhwhbE2Ig9mvuFCFbYLvf4HFWz1McMb0SeGOQIAACBT0lpEF9fMWFY4xW7EIfhQge3ryoULAa2pxYO906vv+9p6AP7J7bWsEpc40UbEy8WoO1Nvh1qFTfU1+sWBOwAAADIXx3Fd8itTu6Pbcc40BFqIYBSmAmzCazjjeP1P6/2u9nYIoEflwg4VHyuwo4DbiBBKol8McwQAAEAupBq7bElLkQmlFLsRB0QFtqWO1/9MBXZ3tA+Ba0w9ZwmwzQkuwGZ4I4bAggcAAAByIy1FbAixCbAH5EOATfWOAXem3h6XHpYmEGDDNaaesy6Eib7uqAixAputcBgUwxwBAACQK0tCbALsAdFCxE57DtxGkwsHtBCBa1J4zsaJS/ph+yDH06vvP0xcCOcwvBFDYpgjAAAAcichtsme2GO0ERkMAbadXAhoTVVMbRF4wTXSB9vUwpQLlcC2DNNIkwsDNNNE9TWGRRsRAAAAmFAxXEBKgD0AAmwMy1QFtq/9cuE/UwtToQ4TRL4IITEshjkCAAAgd3qwo+FCnNCKnkbiQ4Dt4wPuQoWxqQps+l/DVaaeuy68R/r4ug5m4YDhjUgBCyAAAADIXRzHi1EU3TR0z08opSg46xMV2HZyoYWIqWop2ofAVVRghyWkQJfwEaNimCMAAABMMXk+QxV2nwiw4RoGOMJVpp67LgSpvK4dJRUD50O/HzAyhjkCAADAiDiOdavaBUM/ngC7TwTYGFYpzXtOJS7pih7YcNLx+p+MPXcfzHzd9v6yXu6suDP1dggVpQxvRFqo5AcAAIAps4Z+LrNg+kSADaeccTCALgAAIABJREFUXnufABsua6Ry249c8YnbL7A9SPW1NVAIByME2EgLwxwBAABghFRhp3O+PphJHvH+EGADQH4GWIBJhNCjsDoUOr36Pi1EHKSUqjC8ESmjChsAAACmzJv4uTIUH0cgwLZT3eYbd2fqbVMvLhOrYUCaTO0gYDgaskD1NdLGMEcAAACYsmjo5xYSlyCBABsZSLVyFPAJATa8wPBGZIRhjgAAADAijuOHhgonCbD7QIANAPkxFWC70FfWxx0WPm8Fo/oaWaGNCAAAAEwx0RGBOTB9IMCGQ2KrW6sAfWAIKXxBgI2sMMwRAAAAppjIndgx3YfHrL+FAOCJ4/U/b+6WXzDxy7AlCamxZHgjMxGyVTD8GNdYJAEA7zzkIQXggHUDN5Hz9T4QYGMYVEYBqcu0d7zpsBF+MR0sNuI4ZlJ3hmSR4kODN2F/mKP0IQQA+MFEKBRR2QhgEPr4Uym1J7NZ8sL5eh9oIYJhcBAADG+L+64jgioHWDK8cT5xCVIVx/Gi4feqMSqwAQApofjKDFOZAecUSIOpBTf0QIANAPmiD3ZnHCS4wXSouBfHMQF2PkzfzwxzBADAXaYWDjinQBpyXwjRuw8TF+IQAmwAcF6m7UeAVqYDbMLr/Ji+ryeUUrSKAQCMit6yAAZlYiGE3SJHIMC2E09cAKl6MPN1giCMxJLhjXOJS5CJOI71bpGbhu9d2ogAgD9M7UKkt6wZnHsASBVDHO3E1gEAcJ9vi5E2DG+kBU++5g33PL+olKoxzBEA3Kc/w5VSRn4PpVQxjmNaS+TLVKZh9eMsu8sKbTsD9G3e5DkK9EaAjWGM+MZKuwMAQfBmMZLhjWHSwxyVUluGq9eqVN4DAEZUpDdy7iYN/VzrFr0ltNbHMxUZVN2RHHPpQdpzFG0AST60EKEqJ3/c5wAQFoY3hothjgCAtDQM3ZO06MyR4RkW1mQVuvJfKVWPomhJ7yrrFV4LXTBwOYqiz5RScwz1Aw7zIcBmJTUcDOCAR9iJAKcwvDFcDHMEALiOz5F8GVswsKUNh1JqNoqi21EUlRJX9kcH2ZscAwGPMMTRTgS1nXG/AHCJF7tVGN4YNoY5AgBSVDd0Z05SzZorU6HrVuISA5RSevH/Sgo/WVdsLymlOA5C8CICbGsR1AKA+3zZIWS6hcNN+gAaZ7oK+yLBAwB4weTiPpWs+TF1Xxs/XpTw+mLiitHckIISIGgE2BiGqQ8GTl6BfbQfQT5keOOwWx/TQvsQw/QwRwuqmqg+AgD3mVzcJwDMge773Eev56yYqvDfJyFz2uF107wclyMfJtrgULBzBHpg28nqoPbM2rumXlimJhkDQKhMV19vSXgK8xjmCAAYSRzHJgNGAux8mFxwNhYAyk6xLI+VxijqyFXumRw7To/mQ4DtRY/RNgEHtVSWAhmxfbGP6fB2Yngjmkz3IWeYIwD4wdSOnjHaMOTC5H1s8nynlkPleYljodyY3oGKDmghgmEZOfDYnn6TN2y4zkhQe2zp77Yv9tEiyDIyMMbUFtAmAmxLxHGs30MWDN8a2ogAgPuowvaU6cHfcRybDrDzMGvwdwyCoVYtVgwgtZ0PAbaXZfa75Rds729EH2xgOKYDQaBfpsNChjfah2GOAIBRmQwZ+RzJlskFgkbikpxIcJ/XOV6JXtiZM1E0yTlPH5wPsI8t/d3XB9r2NyVT1Zy0GQCAjDG8EZ1I71KGOQIARmF00B4zFbIhx45ZDTDsR0iV/VRhZ8tEgO1ja+TU0ULEXravDJtaOSfAhrN2yy9k9mGoEpccwpYkDIrhjejGdC9sggcAcJi0edgz+BvUqMLOhOnPZ5MBdt7Fh+wkyJaJANv2eVVW8CXA3khc4j7bg1pTK0Rsl4GXjgigR7A/GNWFnSo+DsowXWE0CoY3ohvTjw3DHAHAfSaPkcZYDE2XhKlGjx1ll5gpJs5jeA5nQClVNNTHnQC7D74E2D6W21OB3dlkx0sBNxC6wHoMb0QvDHMEAKTA9C4rqrDTNWf42PFm4hL/XaEXdiZMHWPSA7sPBNj2sr0C29gLbHv6TUJAuMrUQQYruhgEwxtxFIY5AgBGYTrAHqOPcDos6H0dOb7rcRQ8h9Nn5DxIWivhCL4E2D4+2Favpp1Ze9dkuEAfbLhqyNd1nLhkQFYv8m1Pv8lr2hIMb0Q/GOYIABiF7OYx3Qb0srQLwGhsOG4zvSBi6pjoIm3V0mNwF2ojcQk6YoijvUz03RmUqRcaBxpwlalg0PZqVl8rKV1cXGV4I/rFMEcAwChsCD5ZNB+BUqpiQeHDhgU790z+fNPHYz4xVdFO9XWffAmwvdwyslt+gTYinbHKCOfsll8wuauCANuAM2vvutjeiuGN6BfDHAEAo7BhwXpSKUUbhiFIKy8WIQ6YfC7zHE6BVF+bKiINtQXOwKjAtpvtoY6pUGxie/pNBhbANSYXpGxf1WVXhQUY3ohBMMwRADAKqZq1YfjeFVqJDGXeguPGyJKFENMBJM/h0ZlcBCDA7pMXAfaxpb/7+oDbXllk8n6n6gquMfacPbb0dx8H3drOdH/gYTC8EYNimCMAYBS2tA1b5POkf0op3cbrvAU3xYpjRxnAZ7qnO8/hIUkFu6nq64YUhaAPVGDbzfYqY5NVnQTYcI2pVXEXhkL4+Hp2KohleCOGwTBHAMAo4jjWn/17FtyJExyH9Efad12z5ObY9JiZ7kXNc3gIUrl+xeBNYPbPAHwKsH2c3Gn1NhDp7zryiatKXNKXyqg/F8gZAxxhM4Y3YlgMcwQAjMKWIXTnlVIMxOtBwj5bjtesOna0ZDGG5/DgTIf+nP8MwKcA28ey+8nEJfYx1UZkbHv6Tfo8wQm75RfTW3A5csUnbr/AhQDbx9eya9OkTVexcrDtLoY5AgBGYVPV6GWZCYI2LUMbbeh7HVl67GjDbeI53CcJ+01mbhu0TxyMTwG2a2FBX3bLL9ge7Jjsg80bM1wxYLiSCKFH4cKMAFsOhNPkzKIqwxsxCoY5AgBGIQGO6c+RVjcIAA+T8LpuUYHdnqXHjnOWtMThOXwEuX8u9/6uzHH+MyCfAmxfVy5sD7DzWzhIVp7SRgSuMFkdaPXi3vb0m75WTrr0mWT6AHeB4SXOY5gjAGAUs5bdewSAwsLwWpuz8dhRbpMtoSTP4S6kFY4N1fIE2AMiwLaf7X2w1w+vMqZaOXqUCdqIwHa75RcLBg/4to4t/d32YNDX0MmJzyQ5gGN4I0YiwxxNT9+nFzYAOEqqsG2baRV8AGhpeL1nees5W6qwI57DSXLuU7dg9ykFPEOghYj9XAhoaSMCdGdyp4AL7UN8XYRy5YDEhuGNLjxPcTTTJ5McDwCA22x8Hw82ALQ0vI5srb5uksUYmwJ2QmxhUXgdUcAzHG8CbKkytGWlK02mK+P6kcPk1K6V3bQRge1MHjC4sLDnZYAtu1OsJicmpt9DGd7oj0XDx2F6mCPHBADgKAt7YTfpANC2FieZkqBv08Lw2vbq6yabqrAjeQ4HHZhaFl5vUMAzHJ8qsCMGORpj8sU3sT39BiessJLh9iGRIxXYhcQl7nNlMbXC8EakRaqhcljQ7okKIwBwm61B8RWl1GII8xakWteWoK+d1dXXTXIbbXsu63kh9RBnhlgWXkcU8AyPANsNVg85O7P27qbh3pcE2LBVn8/NrjsMRrF3bOlvLrwn2lbZkQZXPotMtw+h95t/TB+Qn1dK+bgoBgBBkCrsq5b+rud1CCZhmJeUUvpz/Ial4bVuO+dMJXwcx/q+3EpcYZbe3b+plPJ1iH6C7M6zKbzWz2MKeIZEgO0G+mD3RoANW5kMCK2vvvZ4CKv1Axzl5Mv04gEHb56J43jdgmGOVGEDgNtsDP6a9LHTbaWUV4OD9XGhUkp/hl9OXGkPF+9zG49JdJC7FEJbHPkdP7RsQSaodkRp8y3Atj40GJILK2Qmg4ix7ek3gllFhBt2yy/qgHDC4I01vZW/HwTY5jC8EVlhmCMAYGiyO8v2sPKatGNwftePhHy3Ld8VeTOOYxfObQ6RY92biSvsoNvirPu4o0C3SdGvT/07Jq40a4Pq69F4FWAfW/q7ryfDE9JL11oysMxk31dvt3LBWTkdeHdtP+LC+6Gvr1urdwMxvBEZY5gjAGAkElbaGvw16XYMn+kA2MW+wvqzUim1aWHI127P0errpqrF83GaOwrmfOmNLceAm/L6tI1XOzdM8K0CO7Jg62pWXAh6TK6KBjeMAPbaLb+kn48XDd7AjWNLf3OhCtjXANv2vs4Mb0RmGOYIAEhJzZHB2Fekr7ATQbbufyzVqR8a3i3ar1npje4kOS6y/bjksjyHnQ1Y9W6Ilue1jT3cb7L7dHQ+BtgMcjTHwAlr1+pTwCTTH/6ufDjauDI+sjNr79p+/zO8EVljmCMAYCQSWroSqI3ZHmQrpaoS8C05dAzekGGITpMdBQuW/w5j0hpHP4edKQSQdiG6Dc5nFj+vXd9FYA0fA2xf+2Bbvx32zNq7fWwbJnBGEEx/6Ftf3erxAEdbhw7tY3gj8sAwRwBAGqRfrO2tRFo1g+x/KKXmTbe0kqrUWWkVcsOx4pE9FzKQAdRsP08Quir/hgTZ1u4qaD63Jf+zvQ2O07sIbOJjgE0fbLNMbRvmDQFW2C2/VDW8HW/r2NLfXNiJ4uvgVdvfixjeiLwwzBEAkIaqI8FfO91O8EOl1MNmmJ1HGKiLFSR4XJeq1CuOtAppV/Vpx578Li4F8hM2LcY0SQuc+Zbnto3tQlp5sYvAFt4F2MeW/ubzibELgY+pF6evrWPgntmjb3GmOxFcmdDta4Bt7WcQwxuRM4Y5AgBG5mDw126sGWZLGFiXoXlV2Rk3NKlCLUtgvajDcj2UT4I90zvuRnFd2m54RXaoXXLwd2ouxmzKczfX16MsyszJToIlw7OmBrFHQUW6HvPpl2mx4fgbdjdl27den1l7b/3O1FtbOa/ybp1e/YAAG8ZZUH0dOdSewdcWIjZXYJse3rhH+5Bw6MBBn0wbPsmoOrSoBwDoQgd/SqlL0gbDdaXWVh5KqUiOkZrns5s9jiebBSDjnuYdkVSsetsvWLfF0YsODoWwrSZk4ONled42pHhHf62nVTEv909Rnu9lB6qsu6nROiRdvgbY656+obuy8qwr7K4lLs0OJ6ewRR/V15lyon3I9vSbBUe3MvbD5vvf9MnAIsMbgzNn+ARtf5gjJw8A4D7Hg7+jjLWE2l4OOe/Tlmd9rzuK47hqyVyaUTUXY/Z7UCulmgsxrYswvXanFmUxZlz+t0/niAvSwx8p8jnA9vKDbbf8YvF4/U+2B1TzOQbYe2xJhw3yq77u2X6E9iGGnVl718r3Z0sOknmvDoxUzJneFVe1YHERAJACj4I/JO0PbQyo2KEs4a5Pz+Wx9h0GDgxYzMKGBYVDXvJxiGN0xCqP66xfkTyz9p7+0LmeuCIbc6dXP6CyCkbtlifHLQlIXAkIfQ2wNxKX2MP0QdSG9P1DeBjmCABIU9nyYy4MpxrSsaIE9VXD80KQvtAWYnLlZYDtwhb6EbiypWZ28DfjnpWlnWxR0QdL1CzY7tQ4tvRXVxZzfN0aaGv1NcMbYYxsn2SYIwAgFQR/Xrrk49DGo0hgX+a57JUyreuy42sFdiQN5X00uVt+sWD77yVV2FmfMNZOr37AyhaM2ilPFo6ubh14cWYYTvTY2p5+s+jwII6j2Lp4asPwRmYVhM30+xNV2ADgEYI/r7wTcq9gnsteucSO02z5HGDTRsSwM2vv6cfgUka34tLp1fcJRGCDOQsC2b1jS3915cDP2/7XFgfYRyywZI7hjTBdgb8/zDFxKQDAWQR/XtCD7oLfpcdz2QuXGNqYPQJsNzkTAJ1Ze29eQuw034x1eM2bA4zbKU3q1+J5C26KSwd+3m7lP7P2rnWfOzKtn+GNMEq2UpreGUcVNgB4piX4g3t0eM1nsyDEdtoC4XU+fA6wfS7dP79bfnE8camlJMQup3Dyqt/MLxBewwY7pf3BjVY8F5U77UPG26ZS+8TWtlWmTwwY3ogm2ogAAFInxxkzBH9OIbzugBDbSTyXc+RtgH1s6W8PPZ9O7FQV45m199bPrL1XloOLrcQ39KbfwK9GUVSgbQgsktrgRpW4ZCALDG+0gnUhrQxvvJi4Il9UX2MfwxwBAFmJ47hO8OcMAr8eWkJsn7MsX/BczpnPFdiR521EnHyhnFn7af3M2k91H8oL+gXfI8zWBx83pf1I4fTa+7OnV9+nhyqssFMq6kGEVyy5OS4FhD5v8bTx88Z0WMfwRrSjChsAkAmqV51wicDvaITYTiC8NuAxz38/HShcTlzqh9Ju+cXC8fqfXKm8POTM2k8Xm8HG9tRPdJVgseX69dNr/w9hNay0Uyr20TokTlySkcbjS391qT0DFdj5Mn1/M7wR7eYMH5fpYY7jPC8BwE86+JP5H4tp7ZREahhyNwB9rCLP5TkLdlTiMJ7LhngdYB9b+tvig5lvJC73SMWH7dmn13760PNqefhlNt+heD3D8NnEJZbann5Tv1+NuXJ7B7R1Zu1dGxcTTVe80z4Eh+hhjkqphuFe+EWOOQDAXxJiN9/rTQ+yxkFFfEXavGAAsuBeVUrpQplr3HdWILw2yPcWIpHFg7XSwJYFIEc7pWLFol0djceX/qdLB4I+V1/b+jiYXDBgeCO6MX3Q73MrIwDAo+CvLC0rYY5ugVEmvB5NHMdzDCo1Tt/3ZwmvzQohwPb5zXJyt/xiMXEpgNTtlIoFC4KXVs5UXwsC7BzJlkOTqL5GRxYMcwQABECH2NKj9h0ebyNuSnhNQUMKZBGg4HmBpq02eC7bIYQA2/cBUlRhA/lY7F7R2rPNRxacqr7enn6z2v2+8wJVJYcxvBFHoXoFAJALqleNuBrHcYWZE+mSRRldpHLVp9/LcguE1/bwPsA+tvS3dc8/rAiwgYztlM7OW9ZDj+pre9ja/9rkCQPDG3EUKvQBALlpqV69yb2eqS1ps+DauYpT5P49K5XByM47ehcH5zX2CKECO/K8Emxst/wSITaQkZ3S2aplk59vulV9/cZ4FEXnE1f4w8rHwnCVACct6EkPc2QLLAAgT1K9WpGWIlRjp09XqhapVM2Hvp/jOC5SjZ2JDVmIoeDCMqEE2L5v7ybABjKwUzqrDwpuWHbf1hKX2M339yebP19MVGU0JJwEjmKqjUhWr1kTJ+wsAsB3vK6QOgmlijzWqdFV1xeoVDWjpRqb53M6dPsbFmIsRQW2H0q75ZcKnv+OQK4kvLYrnFTR9ceX/qdr4aDvAbbNny8mDrzobYy+GBzmmNXrwsTrjZMr+I7XFTKhF9ull/AlqrFHcl2qrpl9YpBUY/N8Hs0G7W/sF0SAfWzpbw8D6A/kWlUmYK2d0svjvYc2ZqnrQMg911ozbE+/UbSsd3jaNs6svWtzpUneJxN7EkoC/cp7a+bNDKvDTJy8ExjAdyae43yOBUSOWwoSxKJ/DQn7alRd26Pl+XyVILtve9LrmqprB4RSgR0FcDBS3S2/NJ64FMBAJLzWldcT3f9e15A5S7XHl/7TtQNE3xfWrA6PpBpmK3FFdjjpx6Dyfs5k9pqVE/g8h4NtyVAywFvyulrI+XVFgBEY6Y2tj1mfZcjjkZrtQsq8Vuwkz+dZaZOT5/uni/TCVYFe1+4IKcD2/SBfV4pWEpcC6FtLeG1b1XDj8fp/OhUOyvBG39+TXKh+zLNqn4M/DET6ped1crWRww6BPF8DbHFFKPJ8rrOjNWDSVkQfu87QTzhBB9eX4jgu0C7EDfJ8rsrCDEH2Yfr+eJYdBO4JJsA+tvS39Zwr0UzgZAYYUu/w2kjFdSsXT6gqZlqw5GbvzNq71leeSGCXx2ffVYY3Yki1nLa5Zv4+KhXReZwk5hHGA1aQz5Y82jvcJJhDJO/l0k94huDvUHDN546D2oLs0FuLNIPrKuctbgqpAjsKoFfgxG75JaqwgQHtlF7pEV4bd/Xx+n+6uEXP9wU1lz5Psv5c2KD6GsOSypesh71ez7HdRi3jRaO9AIbjAu1mM55ntMXrCu0kyG4Gf9cDC/50K5UZgmt/SJA9Kz2yLwUwI65pT4J7gmsPhBZgh/Dmy9Y3YACWh9dbLgaD29NvlHv3EPeCMwG29Ci8lLgiHfthGtvvMAqpesyqwvKm9DbNhbwWKhkGHTX6jiI08roqZ/S60v9mhc8xdCPBX60l+PO1vchWS9BXYc6Cn6RH9rweWqgHcUpVso+LMw3ZPTCug3uCaz+oODa+NT5XD2ae22wGK49+c9XjJqge3QOO+Htt4i6X9/o7Q143c7z+KR84wBHulV4ZV1+F160v9PYXfY//Vvr/elx/5H/Hba/gQ3935vH6X5x7LW9Pv6Fvc+nRJYn3qKR4gO89pMe919WgPyN5286svTvsP2KMUkpXEd1I8edvyUk/YRpSoZTSlUFXUrw3FyTwzT2YUkoVZXE0zVZKl6iEQ8jkdTWfYtGBDm0YRoeBKaUKslhZtbQIpl9bUpQxz+sgbEqpijynXW4DuSGfEYsE1n4KrQI7CqCNSEQvbOBo90qv6JOgdYsPOq87Gl4XDofXXnJyQr0EXzMpVVno+6DIyQ7SJFtbL6T0HL0qW0WNVFXKa6OY0hbdLdnKTXiNoMnrqpxSBax+bRb4HMMwpCp7TqpYn5XK7JuOVLI2pNL6rLQIYWcP9nfDyXHTuJwvXHegzcievO4uyc6BorwuCa89FWIFtv6QuR35XYGtnT1e/5QPIqCDe6VXy1G0v2V97ODVM2QFtWr+0eX6vv67YwW2DiuKj9f/4tx21u3pN3TAcvHwpR3fow5zqwL70pm1d50NkpRS49JuqjZEhcWWVLQy6AqZkefoXPK9pC+66tqqraJSWT7M6y2SE8hZ2hsAh8muotkhWpbpwGNOFsyA1MlOgbIsYppuq7cnBTu6KKZOWxAMSo7Jyi3PaZOFSlttz2fyrsAEF2BHLW1EPA+wF47XP2UYCdDmXulVaaPQ+oq0LsA++3j9L859IEv19WeJKzq/Rx3mVoD9T2fW3nU+TJID0qpsFex1MLolB4rznPggT7JFuybP0V4BQHMLtLVVN/J6a2437/V6i6TiqbmlmyoioAcJsvVr63z379rX3Fo+z4IQ8qaUKksP7YIEgVHKQaB+fj+UcO+hHLdt8hmCLMgiTUECbf01Ln+m1Xqkucum3vK8Xue9G6EG2Lqq57LnAbb27PH6p3xoAQfBdUtFX/urv1fA3OO/swmwrz5e/4uTVUGdq6+jXu9Rj7gTYN88s/ZuJXGVB+Tkqh0nP7CChNmFlpOkzeaXi8/Rltdb88SvGTpwggYMqeV11fxzf9GVxVfYTBY4i203sfmZ19QM8Vo9pAIVthnh+cw5B44UaoC9XyUYQIDdOF7/tFMgAQTlXunVtqE/1gbYjcfr/+Hka3Z7+g19sPKPxBX7ur5HPeJOgO10+xAAAAAAAFwT4hDH6NjSXzcdaEifhtJueZIAG0G7V/puVSpwbJ8QvidbYF1Vc/i2D4LezwAAAAAA5CjIAFuEUkHHgBIE6V7pu+P3St9dPOh3nVo/roRha3k7qDxe/w8nt41L9XUIAfaCD72vAQAAAABwCQG2/0o7VGEjMPdK361Ib9SjBvoY0LHJxdXH6//hcn/GuSwXCSxC9TUAAAAAADkLsgd20/2Z5xYPAq5eNZRO98BudufdOFHfaG+kD3jnXul74weLU3FbcN29B/WoPbAH//uJ624er/+Hs61Dtqff2J8pkLjikF7vUcL+Hth7Z9beG09cCgAAAAAAMhVyBXYUUBX25E55spq4FPDIvdL3avZWXXele/G7/toMpU0RgxsBAAAAADAg6Ars6KAKezOK1ETiiq94UYEd7Q+Ii6PCicYG/VvhlXvnvl+Oong+UlHL6zhR5dz1vw1WYOuhjeXj9X9fd/Xx6K/6OjriPUrYX4F99szae84+VgAAAAAAuCr0CuwooKq6sUCGrCEQd899v3jv3Pd13+ilKIp6LEJZy+nwWoTy/rlBeA0AAAAAgBkE2GFtC7+yU5osJC4FHHL33A8Kd899X79ub+shpY4+dpdcD6+3p98oO3z/D2rOrZsLAAAAAIA/gg+wH1/6q+6ZezNxhb/o4wonHQTXP5iXlhUX3fkdEk0t3jle/3cfXoehvJfoVi+LiUsBAAAAAEAugg+wRUjVdaWd0mQlcSlgqbvnfli+e+4HdfeC644Wjtf/3fn3m+3pCzVH27YMY/HM2nvMDgAAAAAAwJDghzg23Z/55mbnQMabIY6tv4euKGSgI6x199wPx6Mo0gstswevy85DEVXrf6vk9f38d/ZDHL/63wvH63+uuv6s256+oB8bPfx2LHFlV73eo4S9QxwZ3ggAAAAAgEFUYD8SUhX2mASDgFX+d3v32hzHcd97vCeV50CKF9myKEKPXHbqhKCvsgDsLk8sxxfZXL0CLl+BoFdA8BUIfAUEnkpKCOZyTnLiU9ylROTINy0cJ3YeCSiTFEFaFeIVzKnG/ocY7Fy65377fqpYtnYWu7Nz6en+TU/3Ye+NwWHvja1ZQKpuh99UaqRWhNdiU8qQLmDyRgAAAAAAKkYPbPHFla9Kr8L5YKaVPbC9ZVfOTabjwJ8AJTrsrSwr5Y6kx/XF8IM1/L8b0gO7NeH1H1fe1hM33pv9V1y5M6+xPbCvv7r7PvMGAAAAAABQIQJsny+ufFX3LHzn9KutDrAPlFLL5yZThhJBqQ57KzqsHpyE1nEBcPh/B2LLegbY22fH/96Wntc6wNa9kS/N/iuu3JnXyAD76NXd9xcDrwIAAAAAgFL9OZv7lJAAu9UuylAi6x36zajAk97qQALrgVJuP2lEWZRi1qO14fXGSXjdCV0aVgoAAAAAgNqiB/acL658VT8ufu3k1Vb3wPb+D0OJIDdPemvQe37kAAAgAElEQVQ6qF7Svftn/9z+6c+e7z2tQg7OcnpgO4blxv8O7YF9/P/bFl7r/fnZ6VeDezFaI3tgv/bq7vv7gVcBAAAAAECp6IEdNBdgd8LWs/4yQ4nAypO1/kDetygBtfzvcWh9saBuzU3SqvBadG0c6G3CawAAAAAA6oEAe86Ze/81/uLKVydKqX5gYXtdlMfl2xa6IcTna3+9NBt72h1ICO071o/7r+4ppZ7PXj/dn9Wx7N/aYdfPjv+9VWHvH1feXu9YeahkaCUAAAAAAFADDCES4osrX9XB3r3Zkk4MIeJ5+9xkuhP4CLSCBNcbJ08YBA6IkNdsAuy515z4zwgd/iMg+DfGz6hsCJHj/3+kx5I/O/5t28JrfczoiRsXAguD5UeMRg0hMnl19/1B4FUAAAAAAFCJP2OzB+le2DrECCxoPz2UyFIHf3frfb72/Q0Zw7hrw+OUQYfXg7aF12IrPLxuNXpfAwAAAABQIwwhEm2zg4/N66BqR8YzRgs8Xvv+ojMLIa+yPwuxJ+F168aP/+PK2xsdLAN172smtAUAAAAAoEbogR3hzL3/0kHuQfjSVrv0rL+82cHf3VY7hNeF2W5xeK1vYt0ILGg/el8DAAAAAFAzBNjxuhpmvPOsf3kYeBWN8njt+1vJetCmGQ+/iDH0GzEu//Vzk73RufFe68LrhytvL8rQIV1zQO9rAAAAAADqhwA7xpl7/7XV0V7YajYe9mWGEmmox2vfX2e860Lo8uDyuclemwNe/QTGpcCr7UfvawAAAAAAaogA22xU9xUsyIKE2Iut/HUt9njtTT0R53unf2EjejXX3V09Pvy5yXTa1h/4cGU46uiND937uou9zgEAAAAAqD0CbIMz9/6gHymfxL+rtS51dCiBpqMnab6OZkOGTIfnJtPWDRniebgyXJbe113EOQMAAAAAQE0RYNvpcrhx9Vn/MuFOQzxePe593bIetJX2Hp8o5epe162+kfNwZeiNe70QWNh+e/S+BgAAAACgvgiwLZwZd7oXtnbjWf9yV4dSaRom38yH7nX97rnJp4Nzk+l+G36QQVfHvdbWA68AAAAAAIDaIMC21/WQY5NJHRuBADs7Gev6004Mp9Hhca+1yau7748DrwIAAAAAgNogwLZ0ZvwHPXHbdiNWthh6aIHxs/7lpTb+uBYp7CaDE3ilKoUNKXKglHr73OQ3w3OTT7vQ69ob9/p2YEF3MDwSAAAAAAA1R4CdzIYMLdBVOsTeedb/xmKHt0Hd1X4M4/oE4afcnPW6/s1OYElLybjXXe59TO9rAAAAAAAagAA7gTPjP+zLWLFddmnWE5sQu24er745qGs6XKxMPbLvKuW+dm7ym41zk988DyxtKV943cVJGz2M6w8AAAAAQAMQYCe32fFe2EpC7K3Aq4BT2PAeedOTsl45N/n18NzkN50YLmROlydt1LZf3X2/i/sdAAAAAIDGIcBO6Mz4D8+Z0PHY1Wf9bxBi18jLH/8rwyEcmw/RT/33gVLulfOTXw/OT37dye31cGW40eFJG5XcgKQMBwAAAACgIQiwUzgz/sOW9ODsumuE2GgIPUHj9fOTXy11NbhWs/BaD5txI7CgWzZf3X2/M8PFAAAAAADQdATY6dGDb4YQu15yvLHSmOFA4kxOgutfdfo4fbgyHCilbgcWdMvBq7sfbHR8GwAAAAAA0CgE2CmdGf9hqpS61ciVzx8hdn3s+NekM3M6Bn/o8RjX5ye/HHQ9uFbH4fXV5fljo6O48QgABXMcZyD/ltnWAIA60dcm33VqMe9VcxxniesfUAwC7Gw2mNDxBULseuhySKnPxW2l1Guz4PqXjAl+El7rbbEQWNgtk1d3PyDEB4CCSCigh2i6J/8+dRxnXERAAABAEvpapK9J+trku07t5xU2O46z6TiOniT+M7n+PXccZ4drIJAfx3VbMUxAZb4YfG0U/lh+sEuoG/F63N/ksezFHg7s6vi/ixa7bPvc5NejwMsozeO1N7eUcq+d3ouBnR/yWvx/OzZ/45i/x0n4vVH/7fttB8pRm0qprfOTXzC2sc/Dlau6wqSfFrkYf976BfdQuCT9+y3e++JLkz43cPr9Mev+2qu7H+wHXgUAZKZ7nMn1Juxm6cR13UHgVQAASiLhdT/k23QnqGXXdVO3ExzH2YqZJH9PKTVwXZd2KpARPbAzOjP+PRM6nnbtWf+b9MSuVhfG+PV6W18+f/8XS+cnv9gkvD5NwuvxLLzuvJuE1wBQqPWI8Frr8zg1AKAqcg0KC6+VXLtSDzPoOM4oJrzWLulJ5AOvAkiMADsfI4YSOeXaU0Lsyrz80b/qoO5mS3/eXaXU2y/d/2Tx/P1PRufvfzINvAP+8PoSW0MdUGkEgMKZAmoeoQYAVMV0Dcpyk3UYeCXI5j0ADAiwc3Bm/Pt9ApIAQuwKvfzRzzfinwyIGWghV5m/x+tpfV0p9Rcv3f9/w5fuf8I4xjEIrwNGr+5+QO98AAAAAHmzGSJrgSeRgOz+nG2YjzPj3298MfjakNDoFB1i6zBtdH7yawKk8g0bGmTuyXrvvHT/35iIMQHC64C7r+5+wDEEAAAAoAjPY4bQ8iMPATIiwM7XSGa1xYmrOlB72v/mgBC7XC9/9HO9vZc/X/t+3KQSdbAnEz/poHH80v1/Y6ziFAivA46kTAYAAACAIowt2toHWSaJBDBDgJ2jM+PfT78YfE2PPXyjNT8qH5dmIfa3hucnv6LgLtmXP/r56PO1v943TLBUliNfWD2dBda73NjIiPA61DpDhwAAAAAokE1nMYbABHLguG5ZY+F2xxeDr02VcgJB0mxLOzHboZhlL/ZwYFfH/10087LAV82W6fBycH7yKybeq8Dna3+9pJTamA0t4oYE2fN77fR/h+/Zuf92Xvy3njhvXyl3Ovvf47B6+qX7HxMo5uzhys8WlXIswuu48/b0+8LP3+D77Fm898WXJvnc4PvlYyav7n5gMx4dACAHjnN8HerHfNIV13UZ0gkAUDrHcXS74F7M905c103ddnAcRz/1eTuwYGbbdV2eCgVyQA/sYoykN2RISNhpC9ITe/385FdM8FiyL3/0f/e9IRU+X/ufQ5lt2X+hjmp4er2m5/kbot7/3//S/Y/oZV+Shys/W5a7/obwulMYOgQAAABAKVzX3XIcx2tr6/a193Tsjl7GXgDyQQ/sgnwx+LoeruE9/6fTA/vU3717fvKrzcBbAFiR8FpulMWdk6HnX4zG98B+99XdDyhbAKBE9MAGANRV0T2wAZTjz9jOxTgz/k8doEza+Nty8t7T/re2nva/tdiKXwOU6OHKzwY85RFqQngNAAAAAEC7EGAXayiPsyPcNRlSZCl0KYCAhys/G0kPAsLr046kzAUAAAAAAC1CgF2gM+P/fE6gYqTH7p0+7X+bR3YAg4crP9uMmSCk60YXdj9gklAAAAAAAFqGALtgZ8b/qR/zv9XqH5md7kl672n/2+tN/yFAER6u/Gzx4crP9AQg77CBQ929sPvBTtgCAAAAAADQbEziWJIvBl+fuse9jeMmKOvUJI5Ry+7qnpTnJ7+kJyUwC6/1EDs78rRChLhzy9PaSRwPlFLL9L4uhuM4+vjz//ObKqX0dp+6rlvL7e9bfz3fwrK8/FzWXZW57o7jLMrs9IuyDnpm+v3AGyPIBETe75mnb5Y/d113GlhSQ779omS2fjW3X/aTbJukZF8MZR12km63kOMq8f5Mud7etlqW71a+87DQ/S/bbOA7j+bpY/ti4NUT23q/Bl6dGRc9waPjON428x97+946McFkuXzHsn9/lHIspyXngHf8+89B79gptNya5zjO0Lc+icox3/kQ9gTsvvyW0s6JkOvjVpJrs8X1sdR9k0WbyqqI87yw3yLfF3ZMe+twLfDqCd2e2Aq8OjOV65TxmJT6wUD24bjsssx3/PjLq0qOH9kWwy6c1yHtJa9O25i6eVMQYJfki8HXl9zjg9iJGbc2LrjpTICt5AIyPD/5JSc7Ok0ma9wxj3cdd24leY9qYoB95cLuBwQPOfEFe0OpgBuOvRcOpDKpG9GV9Yb3VZb1v37gDeEKX3dpUIRNvHrddd3QBtPcvrgaeEO4IykzKt0P83z7ZZDguDqSbTbOMxx2HEeHJJtz66An3R5GNawSnBe3XNfN7WkyCai874wLh/0mvm2WSz1K1mMr5nfnYU//zqh9kGKdlyUQG8TfAD5lzzvm6nT+tEHKY9nbH1tVBAApr4eFlFsh6zUOOa63XdcdBf7g5O+Gvt9jey5P5NzfKepmr4RU83XdIymTQ+t3vsA7ybW+rtfH1pRVKX9L5jpYzDmRJ338jOLWUeoX80M93pW/K+r8WfaVUbbnwp6Eq0XWe8PqWkdynQ8tz+tah48iZdfIokw98l3LqFtkRIBdoj8Nvj5UyrkT/Y1xwU2nAmzPu+cnv9wMvAp0wMOVn64r5bxn90tDz58U71FNC7BvXtj9cCPwKhKTSuNGwoZtlCOptG6W2Lt5JJVI2wpvFK+Bu5FjYLooPV+itutr/u+S92/msC8OpLJc2TkilfuNHPaLkkbgZlSgkWB97gUWzExc1x3Mvd87L+J6bc27mWWb53wuHsixHHqTJMH6fBZYUIzAPki4rvrcWbfoDW7DK8e2mtJzs27k2PH2Rx7H8lYZ1xVfKJHkvI+SudwKWb+tmHUL3BR1HGdd9kOWcyL3a6M6OUamEceH/s4l//5OWSaHyVw2ZuEL4LPuFyXbyTs3Si+rCih3E/8Wx3HGOdUzTPT6LYetm9wgisp5cr25rU7qvRs5XutyK1vbfl7LTYPNlMecXsd1guz0CLBL9qfBX+qT80b4t8YFN50MsNXszr8zPD/5BcMDoBMervx0USpvV2POizmdDLAnF3Y/ZPLXjKThsVHQ+OpHUiEuLECVoGErhwp8mFtSEc50/TE0apQ/8HQcZ0MagmGV/rQOpPdPmY+NZqncm0yk8h/agyeOIfjRLuvP9TXII+prsQ5c1w173DVWjg24MKkbdY7jbJY8/8LlFEO6ePsr73PHc7PMG3JNl/H8MTmSYzn3Di5yDm4meOIliYmUw4HgK8V6xlXTXtwEKuj6mOt1XcL1uM4a73r7Wq6PeR9Te3I9KeX6WEJZlUu9xZbsv40qy12pb3waWFCc0JvUFiH6X+SxX6ROuVlAvTe3c9v2vC7wWrEn5W3uT+5Y/DZbhfbMbzMmcSzZ2fF/bEglBnb0hWD/af87Q7YX2u7hyk+X5Y51EY2nNjmSnh7IQCrB+wWGU7pBc8NxnKk0MHKjK70SrN0rKLxWsl32ZTtlYfrtyzo4kcbPjQIagnr73JPtVTgJGT41NOSy0J/7qXxPUqZgeVGO1WmGBlXi41F+y2cFhddK1um2PsYkpEsi13PXwmKSN8v5OS3o3PHcyKksaD0JTbOcPyZ6H7+X8liOJKFEkfUvXW59lrLcesE3pnCU43K3wOujd10fS/iUlekzjstkXY8o6Ji6JNfHwp9Umjs3iiqr8qq3xJI6y1SCvCLL3anFMZ/HcZhE1PqY6jyZrqVS792RDhFF1Hu9c3s/hzq71Xktw2oUdV6nrSdGkk4QeYTXSq4147zbR11AgF2NofSGgR1doN552v/O1tP+d8q+SAGleLjyUy/0KSqMa5PRhd0PeaQ7A6nU3Sl4TFvPJamk5XLTwVfpLaNX6PH1p+Dw1wtMi3789R25mVDIdVQaV0UGV/PyDFE8oxzK4aPAKxEq2GZ9CQSShBu1LWvlvCyqMT+vjLKg0SQELvKmol+aYznAFwoVGcT5FVFunSJlStHXx74EpUWHL4MSxjZWsl+2Crw+Fn3D3a/Qssp307DofaJ8N+Dr1GmlivH4l+VaXEYHp4sS/ha5zUs9rwOvpmDxBF8a+vfvFHk9aCMC7AqcHf/HcwmxrRs5OKYLjenT/nei7nwCjfNw5adLD1d+WtQd6Da6dWH3Q8YNy0AqYWUfbwvSAzRThdgXXpfRcPJ7J69KcIiLJQUnynczIdfKsq/Xctn7pZ/z78mjcWJVPvkapGVvMy/csB2Ps8wxYg9sHuX3Bf9lDm3i0WUBDc45OfdMs+Udy6muK76J38p+6s0rt3LrQT6nrDJloYQehP0Sr4/X8r4+SllV1g33ee/kfbNEzrWyOj/43Y6qg8k1o8xMpeyJAkcRk4AXLXKb56DU8zpr5w3p9FPkE3K0axMgwK7I2fF/TGXMHyRzfCf2ae87m0979MZGsz1c+emwpJ6XbbF3YfdDys0MCupBkETqENsXXpddifdcK7AyX6ZcQ2zffqnq6ZFCQvmU9mzqdjU4lpUMw2A8niUc2A4syN+RdO6I5Qsdyw7+/a7W6JirXBOvKzU4ji5JD/KmPz5eRohdpkt5hUm+Y6zKOn5uN3nlHLsdWFCeuDrYoKQQe7vk+US8bU69N5tLaW/GS9lWdKeffoJOBZ3HJI4VOz2pY9zkZZ2dxDF82ewLDpRy1s/f/4S7VmiUhytvLSrlbJl7/YQc+6E6MYnj8azVF3Y/ZLKLlDKGDGFzNyxmaPxfTzKhXA6B3/z6Z1l33YCxDktynnjqQHrt6htfz2VM56WUDeS7rutmfvxe1qcO+0WHx4O4CXEsJllK4sj3KLH+zrHNxHIFHMtKhqFJ+3nvWq73QIZYieo1alqHPdlOYaYyeVTscCU5hI5h67CU4ebLnuu6nR6/MuN15SBkiJosx/IV2x78BRxHacsVY7nlJ+fhvcCCdLwybF/+Lcr2T7MPjutoSSckK+j66B0DWa6Pia7z8wo6xjJdH7OUVRnD66OQYTeylLuh9Ud5omE9Zqxp0/YLW0+PPq624soXw+SqyrZ88n1elnM97Ldk2eZ1qPdWcl6nqDf662hJtnmqMrSLCLBr4E+Dv5TKX2RwExfqdDnA9pYdz+J6/v4nnPCovUcrb43c49mjHYvGQcixH6oTAfaVC7sfltbroW1SVCaPpBfSjuu6kTcJpZHmBVuGGzKBzx/YzBCeMiQ9kFnax3HfIWM5ev+SfP4t13WtekvkUJE/kp4jWxa/ZT1hRTt0Nn0bKRvoB3JcmX7LQPbJKOF+iW2c5BBgW+2LKBmOZZtttiTn4nqKkOPtuPPchsW2TdR4DyNjFScd7mE7QTk2TBHGxh5zbSY9xpIOG7Itx/M4qqHuO5ZHhmNqnj4/ly1uhCQ9jrzzfifuGJabUyM5jpIERdbhYk4Bts05sSxlSZLzYeK6bqJhHnO6Pm5K+Ri53yWATXo8hQalNrKUVYZzo/SyKuUxN5FzZhy1X+S3ePWvpNsq8fXE4nckPn7nPj+3ADvlje49XzkVt83THj/W50Nbzmu5Fn0WWBCk13c97HPluNuwXMfUZU6XEGDXwJ8GfymNQCemwREZ6hBgz+iCY+P8/U+YXAe19GjlrSWpWPRnh2/IcR1AgC3evbD7Ied2SikaH7d0eRrVgIoiFb3NBA0Rq8ZCwtDxQNY9UQVQKvUbCceptAr9Mlbkj2/QJtkXsr83E4SYl+OC0SgJe15GVu4tvmdd9o1tQy6ykZgxwE51XmT4/izbLEmDSdkGf3GKDrBTnEc3pVd3mnIs6XiXnWt0SsDyaWBBtG05fxIdYymO5dgnSxKG7l6IkuY4Gsnf2pZbVjdFMwbYe3I9sS7vU1zXE90UzXh9TFwmy/bbsrzBkKpcTHFjJ0udq9CyKsVN14kcY0m3WdLj7Mh13UTDojQlwE7ROWBP6gpJA/00x49VfbGC83oo57XNcWp9Xlv+DqunaCzrzKk7lXQJY2DXgEzqOJCGN9LRBdZ7T3vfHR/2vtvpxzlRP49W39pgrOvUtgmv05OKsG1j5UAqp+tpQjpdGZTg4LrlWIR90yRW0hC0PW9uSaU0cZCkf6+EB5cTXIu3Ch4DVzc0h0n3hTRiBgnGLU4TkCbpvXNXHotMFfDJ8BZLEUNnhMm7N+yRNDxTnRceaQjZHsvbGbfZWBri71qeiwslT9aYSMIxKPekHEt1s0HKsVHCsmCzS+Nhy2+17bHvnT+JQy0VPJZtXI3aF3Ic2QaLe3I9SXscbUm5dTewMNw7ErAVRfe+XU56s9J3Xbfd/usFTk7pOZIbyInLZLk+Lsv+NUlcLqY4xrLWubyyyub3KCmrkuyfJKGgrrMMUp7n3nH2tu01S+ohbbSRILy+Ked14pvDvuPnSoLxw4usJ2Q5r3ekvLU9r23blaYy+ch2CCjZ1qbrAaMJWCDArgkJsYclz6LbRrpx+Olh77tbh73XQyuwQFkerb41eLT61r40vKucrKuprCZEQ6x1y55GXmM9cU/cedJwt51QJ7IB4usVbeN61oBRzdZ9mrBxW1RPiUw9OiWQH1mG2JdSTKxpW/l/N00IP09+j20oH3lMpeA1TrIOfbGUoCy7LmFf5oaMhP+252I/7QSrJbA93rZthyYy8ZUFNgFkkgZxGyS5rizlMemZHMu2QUtUGWB9HEkolPqJBHVSbg2LvJloKfMwN7L9rwcWBBV5XVS+Mjn1kEeyX5Yt90s/4Y2FqsqqQYKyymr/yO+26RHt7ZPMx6/sV9trVus6rEldweZJQC/szXyuJbypc0luxuctl/M6wXlw1fK8NnU6SHqD01QPZF43CwTYNXJ2/LupxZ0e2NE9w/YPe68TfqF0j1bfWnq0+tZYHlVLO2FG1x1XZpi0MT0JgG3KwESTSNnwNahMjZC4gMB22IhcH9/3VYJtKvPvFNDbLLffY9njQyUJHKTxYlOuXbeZHDCJBKF8HqzHabdQybGsTgexNoFA7R5dlVDdpuf6dl7BvydhAHmthJ6nlav4ujK2bCcFvlPCCuvjKPBqBgnKrYsF3ETK7fdI2WTTE7vIcyHRECgG65bXedvAt0lllc15ZHMtyvM6eSxB/bGNkmzz3MJOuVlnW+9dj3rKJYNhTjdznstTeLmd1waJ9oFs56gbgdez3jTtCgLsmpEQO+rARjLHw4oc9l7XQXZUbwwgN49Wf7L4aPUnmzLhA8OFpEd4nY91i9DsIO+QwSOV0biG85FvVvFTpHIc97eed4sYezZhiJ1n6LddwO8ZWQyFcDHB47g2+6WI33FMwpi4/ZJXo249jwaVBDk2w60Uciyr041TUyBQRICWlc35NSl4IsVcg66Gs7muWD9WnZSck3HtpKjrSqXHUYIQO89j6CDvp9jkpmSuN0UTuJlzaGf79HNfhgYxsdnWhZZVFtdHT+w6yHXA5kZ1ruG1xxdixwk7zxtL6go2bcdc6ibzEpwPCzmXKzfzeErHU8B5HSnlcDm6nveazNMxkf99jckb7RFg19DZ8e+2DJUzJKMvwHcOe6+PD3uv08MduZPgekN6kyaZBA7h1i/sfph75ayDbCqYufYCmieNzVuBBTNxQ36MLEKSSd49fP18PTlMhjn1RjkqYsicBL/D+B7LRu1ewWGiimmc5DXs0N0cGxM263O3yGNZ2d1Q8tTmyTXpJWg63o5ihozIRYIGcRd6YdscH5mHDYoj52ZUGBy4rkhIYQqGCj+OZNvleTPRpKjr+8jiXMh7Wx4UMbmZBFA2x3Tse6SsMo1bXMYxpnIqq2w7EBRWVzfcrLqVZ+hZEzbH960ig045H3KpL1raK/C8tvncTL/DcA5FkvHHN2TM+MSTG3cdAXZNSYh9s+vbIWe68nrvsPf6zmHv9dY/5olyPFr9yUiCa8a5zsfNC7sfchc6I2kAm47H7TIaADI54hUJHCbSIPkLQyW8zAp0JGlAma7FCzk1SgPBS15kP5smQYyc/MzH5nfGNvTzIJX9JV8PlrsyHuRyTtswz99g2maF3LgIIzeUTMfBpRqFsFaBe5FhqSdBg7i1T/zV7LoykmvJXTmm343pxVaL4yjJTdHAK8kVth/kd5huuOU9yV6RvZa3LG4smH5La8oqy57Ae0XfdFUn+8Zff7zlTXwZeHPzhe4Pn6MynvKReoLpKYuLWXsvi8L2oxyfWc9rk7rOG9JqBNg1dnb8u42YHgZIT09I8dlh73tbh73vEWQjFR1cP1r9ia4k3ia4zs32hd0Pu/AIdhlsKmWlbWvdkJYxH48n+olrxEnjydST6VaJPRY2S+htdhQRvOTJZn+bnlIyTehUSnilTsb89HqwDHN8tHw7r2NLGnimHsSbJfe+KbxXUo5M59VBmY/dWjaI29ygrdt1ZUvOfV0GxJ1HtTmOLG8m5hH8Fh0u2lwX83rq9aCE64rpuF0wBHZtKqts9ltpAfJc/bGQ4TOqJj34TW3JUm6AeN8VeCUo6vixtVeD89oUxJvK6nXD36MABNg1d3b8uzInLOqaawTZSOLR6o8X54JrJmjMz+TC7t9yJzs/pgZIbiFdBeuuSmicvyANBlPDM2tDvfCGrTQUTA3ayIp4jpM+1V2es8DbBFGlbjPLAK3y4dakUWhq0Fdxw9NU9lwqYIKrumjcdUVuiJrqamUfRza9lyPLYgt7RYd8cl00lZV5lSNl9fRNFci3sKyyCePbNnxH1UKPLZ+jnOsmsaQcN/XCrn2913Kbxf0OUzmqz/uxnty8C5M41wUBdgMQYhfOH2RzFw0Bs+D6x94Y1wTX+dtr82PXFTEdo6VVhFMwlcN7FYQkpor2QsbKa1n7I0vgELdMtaRRe5TnJGEW2+xuRYGf6XiuwyTENo3jKsoxm+9sXV1Sgq4mXlds9kWp6y1lTJG9l+tyPTE9SZXX9+TFdP2KOpaiXq/iN/jZBIRhx5np9zDMX/7C9oPfTom9rz1Fn9+FnxOyzUxBfFzd3eZYX5BhRD9zHGdHzxUTcWMIOflzNmQznB3/++hPg/+hLGeyRzp621477H1vopSz8dL9Xe4ud9yj1R8vSa8Jm3EfkY7uETq4sPu3ZVfMWsump2zOIV3eTI2n0tdd92ZzHOfIUA4syU2uNJ9f1vVmbJhoNq4iH7dMWTT+myDv32DaZsuO46yVw3AAAB47SURBVFSx3YyNK92rsOJHtU3b7rhHmuM4gQU1MGjJ+eBnDOlqel0xrfekgmBIyfERNyRTlhuiZV5PYuVQjhyUeJMv7T6Jet1T57JqOaROZbpRRfs4f3WsX+1Ip61IGc7vMs/rqeG8jrxGSN1/kuCm/lX5d9txnD3ZhjttHPamSgTYDUKIXRqZ7PENXfBsvnR/lzvNHfNo9cdDGf+rDr3Q2ux4RvYLDwivS7ZX8/Wra1A6NZQJaUOrMveHqcEQ13A17Zc2VNDz/g1x29NbXtcneqruQRTZqBQLhvOxSm18lNh0PNT1umJa76rKrdShiuVnF04H/47jHBjKsKzlSJlPqJi2W9R5beo00JiyymboGoYPKUTcOaSqKKcKPr/LPK/H0kM6iuk36Dzg08CrZpfk3w3ZjjsVzHnSSgwh0jA6xGY4kdLoQuf2Ye+N54e9NzYOe29EVVzQAo9Wf7T0aPVHG49Wf6wvLHcIrwt3dNzz+sHfclc6f6bGVN1vGMRVllWF61/UsVra7ym4F0gbzmUaFicqHwe7wdpYXzQFW3W9rtR1vQsLAUvuUV50mVnmdcW03do4fOB8WWUK80zzaKAAFfbgNZ3faW+01ekmSOxQKLLtrwcWJHNRnn7Uw4yMLeeUQQQC7AYixC7di7GNDntv7Bz2Vhirt0Uerf5o+Gj1R/qu6GeynxnfuhyE19Vp9HavsCLf9ScFujBHRG5hDDPTo2Oa2iuT3qT11pYbvG3BTd6cNbyuUPuxnvN4YkAmec0aYnuOn/SXIJvOkSkwhEhDMZxIZY7HNjrsrRzIwP5bL91/wMW8YR6t/khXFkbyL25MWxTjOuF1pboexCIdyspkmMQHAADEqXNdwTR0XmfoENtxnH0ZCiSP+rDernqM7XUJyGGJALvBCLErdVF669447K1MJMzeeen+A4Khmnq0+sNlpZyRTMhIL+vq6PCaC3W16BmKNPZymHW+S5p+c5ub8+l1cds1tScZPeDQZbRbq1fnDj20F3x0b27pNb0u/7IG2Qsy4aMixLZHgN1wsxD7rxQhdqX68u/2k97KXaWc4xlnv3T/YyoFFXu8+sNld9bLmtC6Hgivy2EKTxrdM1SPHVfRJEJdr8hzTUtAT9SjGyUNdUBjKpM2bjvT+U+A3YzvBfw2E24NeuPmTCZLjP1Qx3EWSx7b3lbnnqaV/bDhOM6mPMm9nkPGsOk4zpRhjOwwBnYLnB3/ljGx60MPMXJbKfXfT3qrO096q6MnvVUeIy7J49UfLj5e/eHo8eoPtx6v/vC5zBr8DuF1LRBel6eoSVfKsmf4nroGDl3vscqkNO1wIDd9q9bEGyZ6cuLrFd1gK5qpYV3XQNa0L+p6PeGGYXM08dofVVYZAzQdpgZeRNGqqrc3dfLewukg23XdTdd1dVl+WSl1y6L9EmUhxc2kzqIHdkvoEPtPg7/al2EtUA9XvUD7SW91b9Yjxxl/6f5H3F3L0ePVvxnMghNnyOPttUV4XS5TY2pBTxpT4zv9pgrxoOwejtJgM5UvbQ+wTWMhEmAHTQzbbFKjSeT0eTcNCTSqMpU6VJSjmjX49PqOa9pLLg+m33VRP1qtnzwILKn3eldVbpluEtFWaA7TMd+YssqmN7CcMzuBV5GFaYi2Qdl1BZlc0jRERtc7bhyT9pTuia1kiJGBlPFxdZh5fcdxhq7rcm4ZEGC3yNnxbzckxL7d9W1RQ/qi9J5erSe9tSO58OsLkQ60KfwTOAmsj//FBQOoB8LrksnQBUeGiuegxg3kseHcriJwsOmR2vbAwfT7+jV+zLUqptBfB34bgVehLI43Xb5t1TAwbSXdQLcItoY17EVmOo4uln1DVwKOuLBKEWA3ytjQgaxpZZXpxuuQADt3U0OZoLd52XUFU733iOtvkGwT3e7dks4vQxlqJO6c8ow4t8wYQqRlzo5/q0+Y613fDjW3IGOW6xsNnz3pre0/6a1tPemtjZ6s9bo+xuopj1d/sPR49Qejx6s/2Hy8+jfjx6t/4yql7klFkfC6/q5fePB3hNfVMPXUWA+80px114FD2UMcjAKvnLbXgeDWJlCpw9ATdWITntFzPZxNbzPTeYl8TQyfVrvriuUTBWWvt81xS4DdHDb7qs51rnmm3zNkGJHcmcqpS3Ljq0ymcqqNQ2XlSoYZ0TevBpLPHRk+P0mP7c4iwG4hCbEvW5wkqIeLvkD70ydrvedP1nrjJ2u9jSdrveGTtV4nJnp5vPqDZQmrNx6v/mD8ePUHOgz6TLbLOwTWjUN4XS2bELjU8Ef3crMJ6+oWOMg6m8qf1lfkpYfiQWDBaaX3Jtb7p4KGnS2bnjT0wA4hN4SMgSlBSqlMx3PpNxf1uW9xXbkbeOW00gI5+R7T9WuPno3NIWWV6RgbNaisMtVnFsoO5PW2a/nNXps6ZGl1BWkfmOaPIsBOQCbGNu5DGboFMQiwW+rs+LdTecyaELt5FiQs0b2M7xz30l7rubNQu7/5ZK2//mStP3iy1m9csP147c3Fx6tvDh6vvjl6vPrmxuPVN3cer745fbz6pisTLt729a6OG/4A9aXLnLcJrytnFZyV0aCS4HpfzvF7juPoMRa3DN9tmpi4X2IAb/NIfFeOd5sAq5RGluM4Orx8Lk/lfKZncK+gZ34sy2CjX7f1rhHTebXADYBS2VxXNg1ley7kujKWjg76uqKHzor6btN6lzmB1rpF/Zb6U/PU6RjLRMbgNeUH62XcOJbgWp/n/z1Xf2xV5y65YWWaAPBaGSG+lKE211WGukhIT/pocW6FXcPgwxjYLaZD7D8NLi3JHbK4cZXQDP35XoBP1o7/c282SY0zdWUSJm/Smi9/NC717ujna98/vrC6s8LXu4MoF1uHHtTtpy/KgwsP/o5HXysm42DfNTyOdlEaVIUFwVIRHs812L1hlJZjZjjfkffE0WHFuMieahLGmq6fBzWeEDNvm/JETJwbjuPsFLlN5ObFe3Mv6/10x3Gct2s2Cc6W4TxUMlbiUhnD0Mg5OfIN97Ij47PWcQicHTnm4gK/d6QcKGWfy7E3lEamPsY3u9JbVq4rpvFxL0r4UVgPzYjrykUpm5ZD5kmwOY6uSblV2HEkPevixkr2EAw1Ty2OMb+5skqXURsJyqotw7V+Qd5TdKA6n2F49ceBjF3fpqHbNi3mMdsq4XdvWvS+vtuF655cazZ97ZEDOY+y3GQ0zY0CAwLsljs73nv+bHBpYNmAQjN5F/ZAYfj5mr9e4cw/irt/evZg0+Q8x8uX5+4MLp58v3FyH7Qb4XX9bFqU+9ck/Mm9x1dEyOB3KWryLN3AcxznwFCJ1p+r3zcoojIvvWJtwobO9AC1DLCU7JdCGlkSAsU18jbqFAAlOJbHRR3LHt856Q8E+vJ4e6HfnYZeH93bzhCkKGnUD8LKkjzJuvhvrPUlQK/bTZMibVqc/3qbTIu4roi460p//roix5HNTdHCjiPpMWrTqWSb4UOaR46xTYs6Q5Vl1bUEZZXNzWp9rumbn4V0gpDfENWB4KKE8216WsHmJshF+c2FPLUlNz1M5aRqytMEWUTUl/T2vy0dDnj6qyIE2B1wbrynGyTDZ/1LNhcjtNd8g4O7f8iLfgpgRHhdL3osacuwUVfGVAFhw2ZM48MziJkwaMMQVCr5/NyDPwlJbbbHQYEhTV1tyLAdcS4WuF+Mkx0FXqleZceyJ6Ix5v/uQp/GyGBD1iuuUe+/ARBVnmQSEgj5bXXlsV+5IVPZdcUQanmWQ64rGxL6lH4cybm3Y/hu/3qimTYthoipvKyyedpHblZvx3yO55qc57leO/QQYRbf3bZhRGxvglwt4saBhNemeoo2sZyrpulGMdeaLE8aRj15CkuMgd0h5yZ76zIDKgDkZY+e17Vm+xj37bzGLpYxC6eWvTgijxsJPkyTuClf8JdLgCSV+E8NjVBPqRMZ1YE0XExjlCvffsmlsu4Lr037xTTRZOlSHMu5NnBk3Mz9mMaYsjxfSydBi01vLy8YyrVnmm8M1rjts9DyCcbm2V4rbksQlZnsB5te1MobRs9PejUnOY5y2Z9yLk8N557nFr2vmytFWZV3AGlVViUI0NYt59K6JqF5LuSz5ocICxM4z5tOevXa1GGOh6PJsd67bhleqw7Ve03XgMR1NTnnTXXY1h3XeSPA7phzkz19UbjM5I4AcnBXwmsutjUlvQNuWq6d7lEwzjI5jjT6bRvrBxa9OEaW1yv9fftZwitfQGJbib/boWED5tk2bL1ANlODR26u2N5UqGuPeNttkMs2UyfH9Kb0mG/sxMjSqDdNcKXkN96xmCTWijQ293li7TQpt28FFoR7L2vQ4ruu2AyFeBBVLic8ju5lvakr5/DYMHyQ54De182X8Bi7nVcIWURZJYG87TF5TSZSTn3zVdc9LQJ4v9DzvAVsb2zo8nCa5Wabb5vb3DBQcpMtsuNJy5jOy4UkIba8z3SD66hD2zc1AuwOOjfZm8pjNzYXWAAIs33hwd8NCa/rL0GDSknj57Oks7zrCrRUgu9ZNtaVTU8l6Y1mG+R54VWiXpgS8m1I4892roiDmg63UApp2Nr+/gUJsfaT9DiT/aLHZt63HItcSaheywBbGiXvBhaEO7XNkgYcuqEkwfV+gqHjatdzfY7tzSwlAYjedhtJb8hJg35djrvbCYL/rvWcTXJduZpmf8h1ZSvn60qS4+hGmnPQV269l+D4GbVsQrouS3KMpTo31Mk1Mk1ZZX2cua67KZ1VbOibr59K/dE6yJYyV5/nnyUI4Fs7VnzCG4QX5WZboqdGZJtvJpxQcM913S49dWhzg2RBjvnYGz2yb2yeIOzC0CyZOa7rNvwnIItn/eWIcbLiJuQzLws/qrJ95ilu9DI37u+KWp9T3x29PH6Z/gDD8ti/dyK2u+V357g8fD2cuIWFrZ9r8Z581yPiPe78/w15T4DtxJj5flbkLjpx/cKDO10b97fRpPG9n6IX5p5UqKYhAc2y/BskCBc820nG7zOM6RjlQNZ9HLLuStZ7kKLH0vGEpba9JKRiGxfA6vEESxt+wHGc2FPcdY0XIv9nmX5bmCNpGEwjhpBZ9u2bpMfrlbhe/XKTJW5/x/59HlIey0pChGlMA2cgnRPSnI9apokIy9i2CcbonLfnO+bCwptl37ZLM4a6fhqjkEm16izBsD7z4vbHkuyPYVHXlQzHUdw5mKXcum47VrgEIbFzECQpw7PKet5bXENuljlZWl7XR7mJfiewwCzu3FC+86O0ssowf0KcPV8dbP63LPrO8zSfm3iuCItzJ1NdzHTsJL0GWpxbYQ58x898vTfLNtf1tmXbmwZtOK/luJ8muA55295fj1qSG1q2+7HwOmgbMIljx52bTEfP+svjlBU5AN2iKzDDCw/ucHFtGJkcxrYHgN+lAibF20s6+Yx+v54oKGHwd1Hen/fYviMe8ZvRDRDpNZZkGy8UtF+uN6Hin/JYVtJT76qhUZjWdhOGw9Ehn2y7pHXWIsoxz15Xn8bQ5WCdriu2T+tkOI6KOAe3OzgRcOvJZKfX21BW+eqPSTtBeL/F9ikgG8ftkI48rTBMcePgYs7bW/k6bXTqKSM57keGmx5+3rZPu/27MjlmZgwhAh1ie+Ni1/3xUQDVkckaCa+bSkLXQcVzIOxZTIwSSkJvm8kDi3S9w+Neh6rRfmlMCFSTbeZJ9DRE1WQ/12VC8lQ9AdukTteVJPuhJsdRo849JNOmskr+blBxVtCpINW3zasc8jXRE4dtI4Gy7dBvWXVuUvi0CLBx7NxkOpXHSmzHuQLQHTJZ4x16nTacL2yoohEyyRr2VBj86Ur8ZXrKhZP9YjtmY94aFV57ahT8Ny5A8wVDVYam210Prz0Vh9ipg7mKA8Z3Ca/bryZl1d08yio5z5crClQPuhik+kLsSWBh8Tq5zefJOPBF19Wud307J0GAjRfOTabPz02mwxLvNAGov5sXHtzRw4Z0vpHeFr5GSJk3LPXM5bmEPdLoL/M6tSdj/1G5jCGT+7xdYkP9SMYLbOxNBTmWqwg3Dlqw7bYq6p125IWPhNcnpHxcKjlo0deV5Yw3Rct+CvVIxps3TmKMdqiwrFJSVuU25IYvUC3z5uuky3Uwvc1lbO6bgYXF6fQ2nyd1taK2P8NIJUSAjYBzk+kmQ4oAnXfcyLrw4E5pk2ygPFIhHpYQnnlBWa6Pxknj/3IJYclNCUiyPLJq+tuyh+UpbH/L8CrLJewXffNlqQ3jBUrDpYxt5rkpDdM2bDuv529ZDXuvUU/4GGIuaCn6uvJ2XtcV303dokM5r9zKMgyV6XpSdkjKTRwL+hjTdYmSy6rXiiir5DwflXDD2rtZWNaTLlm/w5SbZO0Br9tjVwrOZ8re5o0h2z/vY76RT8FVjQAboc5NPmVIEaC7jnucXnhwh7F+W07Cs6UCAocDqZgVFjJKg3AgIXzeFfptafzlcQPH9PvLDhLjvi9z+KHDftkvVwoIZSdyQyRtj7K4334kM86XruBt5v22F8d0QQ1T0/WikG0rYYo+T18rMID0jrvOTWSVhuyPIgLhI98NmFzrJ75Qro7l1gty/MVd78ouw0z7wXS+mP6+7Hpo3L7P3CZuU1kl52AR9Ucl22cp5wA+67FoEle/OMijN7OuT+t6dQH13iMZBi6vbR63LbSyexzH1W2tz2vfMZ/1/G38U3BVclzX7e6vh5Vn/cu6Qrd5MvOwE/Nns2XhR5X578KFLHOj/+7ku4PLClufU98dvTx+mf4Aw/LYv3citrvld+e4PHw9nLiFha2fa/GefNcj4j3u/P8NeU+AzXty/6xtV6l1hgzpHsdxFmXW8/UMs+DriuBOFZUyx3GGMsP+1cBCOwdSqd7Ku+EnM5nfDiyoYBIvx3GWJORYmFtUyGQ9juMMZL8MQ77TxpE0LLey3gyRYzxqVv/ajKXtOM6ynIdpt5nnrmy7nTJ6UzmOM61628rx7ZUFYetia0/Kgx1C6/TknBtl3B8T374opW4i56BXbl0MvMHMK7c2CyhTl6Ucmy8bKplUNOt57ziObmO+E1gwGyKm1InNYrZt7tfHnMuqnSLqLrZyqj/u+epghRzDMXWxPekhn+WzFyUkD7tmv13EBODye4YZ6r2FbXPHcfTnXgssqN95neopS1/dNuw3RtHtjA2C62wIsGHlWf/yklwcL8UHYQTYccvjlxFgxyPAjpbLZ+mL+OiVBzv0uoZXER9ILzr9bzFiq+zLv3GdhiSQiuXAt+6Lc40qr5fVVP6Ni274yTqt+7blVlWVWGk4b0jDR0nFfqPo8Q59+2VJ/kXtl33ffsk7/FmUm/IDCaYmEjLVsuyThpe3zbwGdt/3lgNfz7Kpt+2qOB9l265Lo67ybSvHubftBvLysq8R6+91vz933HETN2e+/bHsO5b9+8M7lp/Plc2V7gvfObgsx5KaOwf3ZJ0LK7dC1skrw731Gcu5Vvq2yuO8992AXpRtuVVhubEs29YrM3bk+lhYHcGirFJz18fallVz9Ufvtyz5bgT5y92xrw5ZSvgux9q6nMNex4Vczp25+sWi77ws9HocUWevfJt34bz23bzx12297e6ds2O5AcuY4jkgwEYiz/qXN5RybkT/DQF23PL4ZQTY8Qiwo2X+LN34Gr7yYIdeZgAAAAAAoFYIsJHYs/43luVuZcgjQgTYccvjlxFgxyPAjpbps26+8mCHiRoBAAAAAEAtMYkjEjs3+Y036/stth7QWMcTSBBeAwAAAACAOqMHNjJ51v/GQHpjy1g/9MCOWx6/jB7Y8eiBHS3xZ+mbTxuvPNhhjE8AAAAAAFBrBNjI7Fn/G97kHTcIsOOXxy8jwI5HgB3N+rMOZKLG2ky2BwAAAAAAEIcAG7mZjY3tHI+NHX5UxYVsBNizDzAsj/17AuwwBNgv3kOvawAAAAAA0DgE2Mjds/43N9xZj+yF058dF7IRYM8+wLA89u8JsMMQYHu9ru/S6xoAAAAAADQOkzgid+cmv9aTwi0rpSZsXaBSN/W5SHgNAAAAAACaih7YKNTT/jeHSqnN2SSPcb1E6YE9+wDD8ti/pwd2mI72wNY3j9ZfeXB3GngrAAAAAABAgxBgo3BP+9+USR6dG9HfFQjg4pcRYIcgwA7TsQD7SILrrcBbAAAAAAAAGogAG6V52v/WklJKB2v94HfGBXUhywiwQxBgh+lQgC2TNN5lkkYAAAAAANAaBNgo3dP+t3zDinjigrqQZQTYIQiww3QgwJ4o5ehJGvcDSwAAAAAAABqOABuVedr/1sZsaBG1EB/UhSwjwA5BgB2mxQH2gVJq9MqDv2eCRgAAAAAA0FoE2KjU0/639PjYG0o570SvR0iIR4AdggA7TAsD7IPZUCF/zzjXAAAAAACg9QiwUQtP+99emgXZ6lpwfUJCPALsEATYYVoUYB/J0Dubrzz4e8a5BgAAAAAAnUCAjVp52v/2QIJs30SPIUEfAXYIAuwwLQiwCa4BAAAAAEBnEWCjlk4H2SFBHwF2CALsMA0OsI+UcgiuAQAAAABApxFgo9ZmQbYz1yObADscAXaYBgbYvh7X/0BwDQAAAAAAOo0AG43wtP+d00OLEGCHIMAO06AAm+AaAAAAAABgDgE2GuVFkO16PbIDISABdqS4v7VYNwLsbJ8RHWAfyM2ZHYJrAAAAAACA0wiw0UhPe8dB9kgp59r8+hNgR4n7W4t1I8DO9hnBAHuilNp65cE/bAXeCwAAAAAAgFmCQoCNJnva++6S9F4dKqUWFAF2jLi/tVg3Auxsn3GyItvu8TAh/zgNvAcAAAAAAACnEGCjFZ72vruolFrXvbJdpS7OflNIiHhK3HIC7CAC7AyfcaBcpXtab37lwT8yTAgAAAAAAIAlAmy0zmHvuyMZXqQf/9sCIWPmZQTYM+Hr0ckA+64eJuQrH//jTuAtAAAAAAAAMCLARmsd9l5fll7ZL4YXOS0uiKQHdhABtuVnHCjlbElwvR9YCgAAAAAAAGsE2Gi9w97rixJi6zD70snvjQsiCbCDCLBjlh8ppXZmofU/jQNLAQAAAAAAkAoBNjpFemV7Q4yE9Mr2hIaUxmUE2DPh69HKAFsPEbLzlY//aSvwNgAAAAAAAGRGgI3OOux9byhh9tXgNogLMaOXEWDPhK9HawLsu9LbWgfXTMgIAAAAAABQIAJsdN5h73veECPDkzA7LsSMXkaAPRO+Ho0OsH2h9f8itAYAAAAAACgJATbgcxJmO8PwntkqKuA8RoA9E74ejQqwj3yB9U7gLQAAAAAAACgFATYQ4bD3RkjPbBUbghJgz4SvR+0D7L1ZaO3o0HoaWAoAAAAAAIDSEWADlg57b0iY7QyUUhfD/ooAeyZ8PWoXYB8opcbS03r8lY//N0ODAAAAAAAA1AwBNpDCYW9lWSk1kH8vemcTYM+Er0flAfaBUs5YQmsdWO8H3gwAAAAAAIBaIcAGcnDYWzkOs93jQNvpR39ieMj6AgF2jMTL9ZAgY1ep6Syw/mcCawAAAAAAgIYhwAYK8KS36vXO9npqL8y+JRCynkaAHSN2ue5drYPq47D65Y//eRx4BwAAAAAAABqHABsowZPe6tIsyHaWJdQO76VNgB3jxfI9Car3ZTiQ6csf/wvjVwMAAAAAALQQATZQkSe9tSUJs0/+uU7o5JAn4kLe1gXYOqh+LiH1vu5h/fLH/zIN/BkAAAAAAABaiwAbqJknaz0dZnvh9pLv/y+EhLw+jQywvZB6qpTjhdXPX/74/xBUAwAAAAAAgAAbaJIna30dZC/6gm0lY2zr03nRVepS9M8pNcA+kCE+lPzvviwfS4A9ffnjf2XYDwAAAAAAAMQiwAZa6vO1weD0L3O88DtCogB73xdQe8unX/7o54TSAAAAAAAAyA0BNgAAAAAAAACglv6M3QIAAAAAAAAAqCMCbAAAAAAAAABALRFgAwAAAAAAAABqiQAbAAAAAAAAAFBLBNgAAAAAAAAAgFoiwAYAAAAAAAAA1BIBNgAAAAAAAACglgiwAQAAAAAAAAC1RIANAAAAAAAAAKglAmwAAAAAAAAAQC0RYAMAAAAAAAAAaokAGwAAAAAAAABQSwTYAAAAAAAAAIBaIsAGAAAAAAAAANQSATYAAAAAAAAAoJYIsAEAAAAAAAAAtUSADQAAAAAAAACoJQJsAAAAAAAAAEAtEWADAAAAAAAAAGqJABsAAAAAAAAAUEsE2AAAAAAAAACAWiLABgAAAAAAAADUEgE2AAAAAAAAAKCWCLABAAAAAAAAALVEgA0AAAAAAAAAqCUCbAAAAAAAAABALRFgAwAAAAAAAADqRyn1/wFiIjZP+BEgyQAAAABJRU5ErkJggg==';

		if (!worksheet['!images']) {
			worksheet['!images'] = [];
		}

		// Sheet module types are stupid.
		// @ts-ignore
		worksheet['!images'].push({
			'!pos': {
				x: 0, y: 0, w: 144, h: 46.5,
			},
			'!datatype': 'base64',
			'!data': imdata,
		});
	}

	public static elementListSheet(elementStructure: ElementStructure, project: ProjectEntity): XLSX.WorkSheet {
		const sheetCells = DataExportUtils.addHeaderRows(elementStructure, project, TableTitle.ElementList.toUpperCase());

		// We use a different set of headers for Excel
		sheetCells.push(DataExportUtils.elementListSheetHeaders[0].map(x => x.title));
		sheetCells.push(DataExportUtils.elementListSheetHeaders[1].map(x => x.title));

		mapReverse(elementStructure.levels, (level: Level) => {
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					const cell = elementStructure.cells[column.id][level.id];
					if (!cell.merged && !cell.deleted) {
						sheetCells.push(Object.values(this.generateElementsListCellData(cell, columnType, column, level, elementStructure)));
					}
				});
			});
		});
		let sheet = XLSX.utils.aoa_to_sheet(sheetCells);
		sheet['!freeze'] = 'F7'; // set up floating columns/rows

		DataExportUtils.addHeaderImage(sheet);
		sheet = this.formatExcelSheets(sheet, DataExportUtils.elementListHeaders, 2);

		// Apply merges for header rows at top
		const merge: any[] = sheet['!merges'] || [];
		DataExportUtils.elementListSheetHeaders[0].forEach((header, index) => {
			if (header.doubleHeight) {
				merge.push({ s: { r: 4, c: index }, e: { r: 5, c: index } });
			} else if (header.cellWidth && header.cellWidth > 1) {
				merge.push({ s: { r: 4, c: index }, e: { r: 4, c: index + (header.cellWidth - 1) } });
			}
		});
		sheet['!merges'] = merge;

		// merge header rows
		DataExportUtils.mergeColumnsPerRow(sheet, 4, 0, 2, 2);
		// merge the sheet Title cell
		DataExportUtils.mergeColumnsPerRow(sheet, 1, 3, 0, 1);

		// Top header row is already given styles by formatExcelSheets, but we've added an extra row, so we need to override them
		if (sheet['!ref']) {
			let range = XLSX.utils.decode_range(sheet['!ref']);
			range.s.r = 4; range.e.r = 5;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
				alignment: {
					vertical: 'top',
					horizontal: 'center',
				},
				top: { style: 'thin' }, // thin black border
				right: { style: 'thin' },
				bottom: { style: 'thin' },
				left: { style: 'thin' },
				incol: { style: 'thin' },
				inrow: { style: 'thin' },
			});

			range = XLSX.utils.decode_range(sheet['!ref']);
			const wsCols = [];
			for (let rowNum = 4; rowNum <= range.e.r; ++rowNum) {
				for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
					if (colNum === 0) wsCols.push({ width: 50 });
					else wsCols.push({ width: 18 });
					const cell_address = { c: colNum, r: rowNum };
					const cell_ref = XLSX.utils.encode_cell(cell_address);
					if (sheet[cell_ref]) {
						// decimal places
						const elementListThreeDecimalPlaces = [10, 11];
						if (elementListThreeDecimalPlaces.indexOf(colNum) !== -1) {
							sheet[cell_ref].z = '#,##0.000';
						}
					}
				}
			}
		}

		// Print settings
		if (!sheet['!print']) {
			sheet['!print'] = {};
		}
		sheet['!print'].props = {
			orientation: 'landscape',
		};

		return sheet;
	}

	public static scheduleOfRatesSheet(elementStructure: ElementStructure, project: ProjectEntity): XLSX.WorkSheet {
		const sheetCells = DataExportUtils.addHeaderRows(elementStructure, project, TableTitle.ScheduleOfRates.toUpperCase(), 2);

		// We use a different set of headers for Excel
		sheetCells.push(DataExportUtils.scheduleOfRatesSheetHeaders[0].map(x => x.title));
		sheetCells.push(DataExportUtils.scheduleOfRatesSheetHeaders[1].map(x => x.title));
		mapReverse(elementStructure.levels, (level: Level) => {
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					const cell = elementStructure.cells[column.id][level.id];
					if (!cell.merged && !cell.deleted) {
						sheetCells.push(Object.values(this.generateScheduleOfRatesCellData(cell, columnType, column, level, elementStructure)));
					}
				});
			});
		});
		let sheet = XLSX.utils.aoa_to_sheet(sheetCells);
		sheet['!freeze'] = 'F7'; // set up floating columns/rows

		// Add default formatting
		sheet = this.formatExcelSheets(sheet, DataExportUtils.scheduleOfRatesHeaders, 3);

		// Apply merges for header rows at top
		const merge: any[] = sheet['!merges'] || [];
		DataExportUtils.scheduleOfRatesSheetHeaders[0].forEach((header, index) => {
			if (header.doubleHeight) {
				merge.push({ s: { r: 4, c: index }, e: { r: 5, c: index } });
			} else if (header.cellWidth && header.cellWidth > 1) {
				merge.push({ s: { r: 4, c: index }, e: { r: 4, c: index + (header.cellWidth - 1) } });
			}
		});
		sheet['!merges'] = merge;

		// merge header cells
		DataExportUtils.mergeColumnsPerRow(sheet, 4, 0, 2, 2);
		// merge sheet title
		DataExportUtils.mergeColumnsPerRow(sheet, 1, 3, 0, 1);

		// Top header row is already given styles by formatExcelSheets, but we've added an extra row, so we need to override them
		if (sheet['!ref']) {
			let range = XLSX.utils.decode_range(sheet['!ref']);
			range.s.r = 4; range.e.r = 5;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
				alignment: {
					vertical: 'top',
					horizontal: 'center',
				},
				top: { style: 'thin' }, // thin black border
				right: { style: 'thin' },
				bottom: { style: 'thin' },
				left: { style: 'thin' },
				incol: { style: 'thin' },
				inrow: { style: 'thin' },
			});

			// bold project info
			range.s.r = 0; range.e.r = 3;
			range.s.c = 2; range.e.c = 2;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
			});

			range = XLSX.utils.decode_range(sheet['!ref']);
			const wsCols = [];
			for (let rowNum = 4; rowNum <= range.e.r; ++rowNum) {
				for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
					if (rowNum === 4) {
						if (colNum === 0) wsCols.push({ width: 18 });
						else if (colNum === 9) wsCols.push({ width: 25 });
						// The following formats the cells with QTY as their title
						else if (colNum === 11 || colNum === 15 || colNum === 18 || colNum === 22 || colNum === 25
							|| colNum === 29 || colNum === 33 || colNum === 36 || colNum === 40) wsCols.push({ width: 10 });
						else if (colNum === 44) wsCols.push({ width: 25 });
						else if (colNum <= range.e.c) wsCols.push({ width: 18 });
					}

					const cell_address = { c: colNum, r: rowNum };
					const cell_ref = XLSX.utils.encode_cell(cell_address);
					if (sheet[cell_ref]) {
						// currency columns
						const scheduleOfRatesCurrencyColumns = [1, 10, 14, 17, 20, 24, 28, 32, 35, 39, 42, 43];
						if (scheduleOfRatesCurrencyColumns.indexOf(colNum) !== -1) {
							sheet[cell_ref].z = '[$$-C09]#,##0.00;[RED]-[$$-C09]#,##0.00';
						}

						// decimal places
						const elementListOneDecimalPlace = [41, 42];
						if (elementListOneDecimalPlace.indexOf(colNum) !== -1) {
							sheet[cell_ref].z = '#,##0.0';
						}

						const elementListTwoDecimalPlace = [5, 6];
						if (elementListTwoDecimalPlace.indexOf(colNum) !== -1) {
							sheet[cell_ref].z = '#,##0.00';
						}
					}
				}
			}
			sheet['!cols'] = wsCols;
		}

		DataExportUtils.addHeaderImage(sheet);
		return sheet;
	}

	public static tempWorksSheet(elementStructure: ElementStructure, project: ProjectEntity): XLSX.WorkSheet {
		const sheetCells = DataExportUtils.addHeaderRows(elementStructure, project, TableTitle.TemporaryWorks.toUpperCase(), 2);

		// We use a different set of headers for Excel
		sheetCells.push(DataExportUtils.tempWorksSheetHeaders[0].map(x => x.title));
		sheetCells.push(DataExportUtils.tempWorksSheetHeaders[1].map(x => x.title));

		mapReverse(elementStructure.levels, (level: Level) => {
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					const cell = elementStructure.cells[column.id][level.id];
					if (!cell.merged && !cell.deleted) {
						sheetCells.push(Object.values(this.generateTempWorksCellData(cell, columnType, column, level)));
					}
				});
			});
		});

		let sheet = XLSX.utils.aoa_to_sheet(sheetCells);
		sheet['!freeze'] = 'D7'; // set up floating columns/rows

		// Apply merges for header rows at top
		const merge: any[] = sheet['!merges'] || [];
		DataExportUtils.tempWorksSheetHeaders[0].forEach((header, index) => {
			if (header.doubleHeight) {
				merge.push({ s: { r: 4, c: index }, e: { r: 5, c: index } });
			} else if (header.cellWidth && header.cellWidth > 1) {
				merge.push({ s: { r: 4, c: index }, e: { r: 4, c: index + (header.cellWidth - 1) } });
			}
		});
		sheet['!merges'] = merge;

		// merge header cells
		DataExportUtils.mergeColumnsPerRow(sheet, 4, 0, 2, 4);
		DataExportUtils.mergeColumnsPerRow(sheet, 3, 1, 7, 1);

		// merge the sheet Title cell
		DataExportUtils.mergeColumnsPerRow(sheet, 1, 3, 0, 1);

		DataExportUtils.addHeaderImage(sheet);
		sheet = this.formatExcelSheets(sheet, DataExportUtils.tempWorksHeaders, 3);

		// Top header row is already given styles by formatExcelSheets, but we've added an extra row, so we need to override them
		if (sheet['!ref']) {
			const range = XLSX.utils.decode_range(sheet['!ref']);
			range.s.r = 4; range.e.r = 5;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
				alignment: {
					vertical: 'top',
					horizontal: 'center',
				},
				top: { style: 'thin' }, // thin black border
				right: { style: 'thin' },
				bottom: { style: 'thin' },
				left: { style: 'thin' },
				incol: { style: 'thin' },
				inrow: { style: 'thin' },
			});

			// bold project info
			range.s.r = 0; range.e.r = 3;
			range.s.c = 2; range.e.c = 10;
			XLSX.utils.sheet_set_range_style(sheet, range, {
				bold: true,
			});
		}
		return sheet;
	}

	public static shuttersSheet(elementStructure: ElementStructure, project: ProjectEntity): XLSX.WorkSheet {
		const sheetCells = DataExportUtils.addHeaderRows(elementStructure, project, TableTitle.Shutters.toUpperCase());

		const shutterHeaders = DataExportUtils.shutterHeaders.slice();
		elementStructure.levels.slice().reverse().forEach(level => {
			shutterHeaders.push({ id: level.id, title: level.code, columnWidth: DataExportUtils.shuttersPerLevelColumnWidth });
		});

		sheetCells.push(shutterHeaders.map(x => x.title));

		const shuttersNeededPerLevel = this.shuttersNeededPerLevel(elementStructure);

		if (elementStructure.shutters) {
			elementStructure.shutters.forEach(shutter => {
				sheetCells.push(Object.values(this.generateShutterData(shutter, elementStructure, shuttersNeededPerLevel)));
			});
		}

		const sheet = XLSX.utils.aoa_to_sheet(sheetCells);
		sheet['!freeze'] = 'I6'; // set up floating columns/rows
		DataExportUtils.mergeColumnsPerRow(sheet, 4, 0, 2, 4);

		DataExportUtils.addHeaderImage(sheet);
		return this.formatShuttersSheet(sheet, shutterHeaders);
	}

	public static costSummarySheet(elementStructure: ElementStructure, project: ProjectEntity): XLSX.WorkSheet {
		const sheetCells = DataExportUtils.addHeaderRows(elementStructure, project, TableTitle.CostSummary.toUpperCase());

		const aptusbarParts = ElementStructureUtils.getAptusBarParts(elementStructure);
		const aptusItemParts = ElementStructureUtils.getAptusItemParts(elementStructure);
		const aptusShutters = ElementStructureUtils.getShuttersTotal(elementStructure);

		// Start with just the shutters in our totals, and add the other parts when we loop through them below
		let totalCost = aptusShutters.shutterTotal + aptusShutters.siteTemplateTotal;
		let totalQuantity = aptusShutters.shutterCount + aptusShutters.siteTemplateCount;

		// // Add additional parts to total cost
		// elementStructure.additionalParts && elementStructure.additionalParts.forEach(part => {
		// totalCost += ElementStructureUtils.getPartCombinedPrice(part) * part.quantity;
		// totalQuantity += part.quantity;
		// });

		if (elementStructure.additionalParts) {
			elementStructure.additionalParts.forEach(part => {
				totalCost += ElementStructureUtils.getPartCombinedPrice(part) * part.quantity;
				totalQuantity += part.quantity;
			});
		}

		if (elementStructure.additionalParts) {
			const additionalExtrasHeaders = ['Additional Extras', 'Length', 'Qty', 'Rate', 'Total'];
			this.CostSummaryHeaders.push(additionalExtrasHeaders);
			sheetCells.push(Object.values(additionalExtrasHeaders));
			elementStructure.additionalParts.forEach(part => {
				const combinedPrice = ElementStructureUtils.getPartCombinedPrice(part);
				sheetCells.push(Object.values([
					part.partName,
					part.isBar ? part.length.toFixed(0) : 'N/A',
					part.quantity,
					combinedPrice,
					(combinedPrice * (part.quantity ? part.quantity : 0)),
				]));
			});
			sheetCells.push(Object.values(''));
		}

		ElementStructureUtils.barPartsList.forEach(barType => {
			const barParts = aptusbarParts[barType.name];
			let total = 0.0;
			if (Object.entries(barParts).length) {
				const barPartsHeaders = [barType.description, 'Ave Length', 'Qty', 'Ave Rate', 'Total'];
				this.CostSummaryHeaders.push(barPartsHeaders);
				sheetCells.push(Object.values(barPartsHeaders));
				Object.entries(barParts).forEach(([partName, summary]) => {
					total += summary.totalCost;
					totalCost += summary.totalCost;
					totalQuantity += summary.qty;
					sheetCells.push(Object.values(this.generateCostSummaryDataForBarParts(partName, summary)));
				});
				sheetCells.push(Object.values([
					'SUB-TOTAL',
					'',
					'',
					'',
					total,
				]));
				sheetCells.push(Object.values(''));
			}
		});

		ElementStructureUtils.itemPartsList.forEach(itemType => {
			const itemParts = aptusItemParts[itemType.name];
			let total = 0.0;
			if (Object.entries(itemParts).length) {
				const itemPartsHeaders = [itemType.description, 'Unit', 'Qty', 'Rate', 'Total'];
				this.CostSummaryHeaders.push(itemPartsHeaders);
				sheetCells.push(Object.values(itemPartsHeaders));
				Object.entries(itemParts).forEach(([partName, summary]) => {
					total += summary.totalCost;
					totalCost += summary.totalCost;
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					totalQuantity += summary.qty;
					sheetCells.push(Object.values(this.generateCostSummaryDataForItemParts(partName, summary)));
				});
				sheetCells.push(Object.values([
					'SUB-TOTAL',
					'',
					'',
					'',
					total,
				]));
				sheetCells.push(Object.values(''));
			}
		});

		const shutterPartsHeaders = ['Shutters & Site Templates', 'Unit', 'Qty', 'Ave Rate', 'Total'];
		this.CostSummaryHeaders.push(shutterPartsHeaders);
		sheetCells.push(Object.values(shutterPartsHeaders));
		sheetCells.push(Object.values(this.generateCostSummaryDataForShutters(aptusShutters)));
		sheetCells.push(Object.values(this.generateCostSummaryDataForSiteTemplates(aptusShutters)));
		sheetCells.push(Object.values([
			'SUB-TOTAL',
			'',
			'',
			'',
			aptusShutters.shutterTotal + aptusShutters.siteTemplateTotal,
		]));
		sheetCells.push(Object.values(''));

		sheetCells.push(Object.values([
			'TOTAL',
			'',
			'',
			'',
			totalCost]));

		const sheet = XLSX.utils.aoa_to_sheet(sheetCells);
		const startingRow = 0;
		DataExportUtils.mergeColumnsPerRow(sheet, 4, startingRow, 2, 2);
		DataExportUtils.addHeaderImage(sheet);
		return this.formatCostSummaryExcelSheet(sheet);
	}

	private static mergeColumnsPerRow(sheet: WorkSheet, numRows: number, startingRow: number, startingColumn: number, merges: number) {
		// Apply merges for header rows at top
		const merge: any[] = sheet['!merges'] || [];
		for (let i = 0; i < numRows; i++) {
			merge.push({ s: { r: startingRow + i, c: startingColumn }, e: { r: startingRow + i, c: startingColumn + merges } });
		}
		sheet['!merges'] = merge;
	}

	private static shuttersNeededPerLevel(elementStructure: ElementStructure) {
		const shuttersNeededPerLevel = {};
		elementStructure.levels.slice().reverse().forEach(level => {
			// Go through each cell on this level, and find the shutters needed
			const shuttersNeededThisLevel = {};
			elementStructure.columnTypes.forEach(columnType => {
				columnType.columns.forEach(column => {
					// Grab the cell, but ignore merged, deleted, or nonaptus cells
					const cell = elementStructure.cells[column.id][level.id];
					if (!cell.merged && !cell.deleted && cell.aptusDesignConfiguration !== 'nonaptus') {
						// Get the shutter for this cell
						const shutter = ElementStructureUtils.shutterTypeStringFromCell(cell);
						if (shutter) {
							// We have a shutter name. We add it to our level, or increment the existing value
							if (shutter in shuttersNeededThisLevel) {
								shuttersNeededThisLevel[shutter]++;
							} else {
								shuttersNeededThisLevel[shutter] = 1;
							}
						}
					}
				});
			});

			// Add this level's shutters to the overall object
			shuttersNeededPerLevel[level.id] = shuttersNeededThisLevel;
		});

		return shuttersNeededPerLevel;
	}

	private static formatExcelSheets(ws: WorkSheet, headers?: dataExportHeader[], emptyColumnsBeforeHeaderData = 1) {
		if (!ws['!ref']) {
			return ws;
		}

		const range = XLSX.utils.decode_range(ws['!ref']);
		for (let rowNum = 4; rowNum <= range.e.r; ++rowNum) {
			for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
				const cell_address = { c: colNum, r: rowNum };
				const cell_ref = XLSX.utils.encode_cell(cell_address);

				// We can only style cells if they exist
				if (!ws[cell_ref]) {
					ws[cell_ref] = {
						v: '',
					};
				}

				if (!ws[cell_ref].s) {
					ws[cell_ref].s = {};
				}
				ws[cell_ref].s.alignment = {
					vertical: 'center',
					horizontal: 'center',
					wrapText: true,
				};
				ws[cell_ref].s.top = { style: 'thin', color: { rgb: 0x000000 } }; // thin black border
				ws[cell_ref].s.right = { style: 'thin', color: { rgb: 0x000000 } };
				ws[cell_ref].s.bottom = { style: 'thin', color: { rgb: 0x000000 } };
				ws[cell_ref].s.left = { style: 'thin', color: { rgb: 0x000000 } };
			}
		}

		// Apply widths to columns
		const wsCols = [];
		for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
			// Find which header we're in
			const currentHeader = headers && headers[colNum];

			if (currentHeader && currentHeader.columnWidth) {
				wsCols.push({ width: currentHeader.columnWidth });
			} else {
				wsCols.push({ width: 18 });
			}
		}
		ws['!cols'] = wsCols;

		// Apply styles to column headers
		range.s.r = 4; range.e.r = 4;
		XLSX.utils.sheet_set_range_style(ws, range, {
			bold: true,
			alignment: {
				vertical: 'top',
			},
		});

		// apply header styles
		ws = this.formatHeaderRows(ws, emptyColumnsBeforeHeaderData);

		// print settings
		if (!ws['!print']) {
			ws['!print'] = {};
		}

		// eslint-disable-next-line no-useless-concat
		ws['!print'].footer = ('&C' + 'PAGE &P OF &N') + ('&R' + '&T &D');

		return ws;
	}

	private static formatHeaderRows(ws: WorkSheet, emptyColumnsBeforeHeaderData = 1) {
		// Style project info cells
		for (let rowNum = 0; rowNum < 4; ++rowNum) {
			const cell_address = { c: emptyColumnsBeforeHeaderData, r: rowNum };
			const cell_ref = XLSX.utils.encode_cell(cell_address);
			if (ws[cell_ref]) {
				if (!ws[cell_ref].s) {
					ws[cell_ref].s = {};
				}

				ws[cell_ref].s.alignment = {
					horizontal: 'left',
					wrapText: true,
				};
				ws[cell_ref].s.bold = true;
			}
		}

		// Style sheet title cell
		const cell_address = { c: 0, r: 3 };
		const cell_ref = XLSX.utils.encode_cell(cell_address);
		if (ws[cell_ref]) {
			if (!ws[cell_ref].s) {
				ws[cell_ref].s = {};
			}

			ws[cell_ref].s.alignment = {
				wrapText: true,
				horizontal: 'left',
			};
			ws[cell_ref].s.bold = true;
		}

		// // Merge cells that image covers
		// // if we have space, we merge the first two columns for the image. If we don't, we leave it
		// let merge = ws["!merges"] ? ws["!merges"] : [];
		// for(let rowNum = 0; rowNum < 4; ++rowNum) {
		// merge.push({ s: { r: rowNum, c: emptyColumnsBeforeHeaderData }, e: { r: rowNum, c: emptyColumnsBeforeHeaderData + 2 } });
		// }
		// merge.push({ s: { r: 0, c: 0 }, e: { r: 2, c: emptyColumnsBeforeHeaderData > 1 ? 1 : 0 } });
		//
		// // Merge first two columns for sheet title, but only if we have space
		// if(emptyColumnsBeforeHeaderData > 1) {
		// merge.push({ s: { r: 3, c: 0 }, e: { r: 3, c: 1 } });
		// }
		// ws["!merges"] = merge;

		return ws;
	}

	private static formatElementsTable(ws: WorkSheet) {
		if (!ws['!ref']) {
			return ws;
		}

		const transitionColours = {
			grey: { hex: '#E1E1E1', fontColour: '#000000' },
			default: { hex: 'transparent', fontColour: '#000000' },
			lightblue: { hex: '#96DDD1', fontColour: '#000000' },
			lightgreen: { hex: '#E2F79F', fontColour: '#000000' },
			darkgreen: { hex: '#6FA922', fontColour: '#000000' },
			pink: { hex: '#E36DA8', fontColour: '#000000' },
			purple: { hex: '#734592', fontColour: '#FFFFFF' },
			black: { hex: '#000000', fontColour: '#FFFFFF' },
		};
		const range = XLSX.utils.decode_range(ws['!ref']);
		const wsCols = [];
		for (let rowNum = range.s.r; rowNum <= range.e.r; ++rowNum) {
			for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
				if (colNum === 0) {
					wsCols.push({ width: 25 });
				} else {
					wsCols.push({ width: 21 });
				}

				const cell_address = { c: colNum, r: rowNum };
				const cell_ref = XLSX.utils.encode_cell(cell_address);
				if (ws[cell_ref]) {
					const cellValue = ws[cell_ref].v.toString();

					// Skip past the first four header rows
					if (rowNum > 3) {
						// Apply borders to all cells
						ws[cell_ref].s = {
							top: { style: 'thin', color: { rgb: 0x000000 } }, // thin black border
							right: { style: 'thin', color: { rgb: 0x000000 } },
							bottom: { style: 'thin', color: { rgb: 0x000000 } },
							left: { style: 'thin', color: { rgb: 0x000000 } },
						};

						if (cellValue.indexOf('|NONAPTUSCOLOUR|') > -1) {
							// this is a non aptus cell
							// cell content
							ws[cell_ref].v = cellValue.substring(0, cellValue.lastIndexOf('|NONAPTUSCOLOUR|'));

							// get level Height (in case of merged cells)
							const height = Number(cellValue.split('|LEVELHEIGHT|').pop());

							// get colour
							const colour = cellValue.split('|NONAPTUSCOLOUR|').pop().split('|LEVELHEIGHT|')[0];

							// Calculate 'real' cell_ref
							const color_row = rowNum - 2 * (height - 1); // top cell index of the merged cell
							const color_cell_address = { c: colNum, r: color_row };
							const color_cell_ref = XLSX.utils.encode_cell(color_cell_address);

							// Set nonaptus colour, Default to grey.
							if (colour) {
								ws[color_cell_ref].s.fgColor = {
									rgb: transitionColours[colour].hex,
								};
								ws[color_cell_ref].s.color = {
									rgb: transitionColours[colour].fontColour,
								};
							} else {
								ws[color_cell_ref].s.fgColor = {
									rgb: transitionColours.grey.hex,
								};
								ws[color_cell_ref].s.color = {
									rgb: transitionColours.grey.fontColour,
								};
							}
						} else {
							// normal Aptus / custom cell
							ws[cell_ref].v = ws[cell_ref].v.toString().replace(/\t+/g, '');
						}

						if (cellValue.indexOf('|TRANSITION|') > -1) {
							// This is a transition
							ws[cell_ref].v = cellValue.substring(0, cellValue.lastIndexOf('|TRANSITION|'));
							const colour = cellValue.split('|TRANSITION|').pop();

							// Set colour for transition, but only if we have a colour to set
							if (colour && colour !== 'default') {
								ws[cell_ref].s.fgColor = {
									rgb: transitionColours[colour].hex,
								};
								ws[cell_ref].s.color = {
									rgb: transitionColours[colour].fontColour,
								};
							}
						} else {
							// This is an Aptus cell
							ws[cell_ref].v = ws[cell_ref].v.toString().replace(/\t+/g, '');
						}
					}
				}
			}
		}
		ws['!cols'] = wsCols;

		// Handle merging level cells (Which much each be double height, to cover transitions on cells)
		const merge = ws['!merges'] || [];
		for (let rowNum = range.s.r + 5; rowNum <= (range.e.r + 1); rowNum += 2) {
			merge.push({ s: { r: rowNum, c: 0 }, e: { r: rowNum + 1, c: 0 } });
		}

		// Handle merged cells
		for (let colNum = range.s.c + 1; colNum <= range.e.c; ++colNum) {
			let currentMerge = false;
			let currentMergeTopRow = 0;
			for (let rowNum = range.s.r; rowNum <= range.e.r; ++rowNum) {
				const cell_address = { c: colNum, r: rowNum };
				const cell_ref = XLSX.utils.encode_cell(cell_address);
				if (ws[cell_ref]) {
					const cellValue = ws[cell_ref].v.toString();
					if (cellValue === 'merge over this cell') {
						if (!currentMerge) {
							currentMergeTopRow = rowNum;
						}
						currentMerge = true;
					} else {
						if (currentMerge) {
							merge.push({ s: { r: currentMergeTopRow, c: colNum }, e: { r: rowNum, c: colNum } });

							// A merged cell has the content of its top cell, so we set that here
							const top_cell_ref = XLSX.utils.encode_cell({ c: colNum, r: currentMergeTopRow });
							ws[top_cell_ref].v = cellValue;
						}
						currentMerge = false;
					}
				} else {
					currentMerge = false;
				}
			}
		}
		ws['!merges'] = merge;

		// Set general styles
		const tableRange = JSON.parse(JSON.stringify(range)); // clone range so we don't lose the original
		tableRange.s.r = 4;
		XLSX.utils.sheet_set_range_style(ws, tableRange, {
			alignment: {
				vertical: 'center',
				horizontal: 'center',
				wrapText: true,
			},
		});

		const firstRowRange = JSON.parse(JSON.stringify(range)); // clone range so we don't lose the original
		firstRowRange.s.r = 4; firstRowRange.e.r = 4;
		XLSX.utils.sheet_set_range_style(ws, firstRowRange, {
			bold: true,
			name: 'calibri',
			sz: 12,
		});

		const firstColumnRange = JSON.parse(JSON.stringify(range)); // clone range so we don't lose the original
		firstColumnRange.s.c = 0; firstColumnRange.e.c = 0; // We skip past the Aptus header rows
		XLSX.utils.sheet_set_range_style(ws, firstColumnRange, {
			bold: true,
			name: 'calibri',
			sz: 12,
		});

		// format header rows
		ws = this.formatHeaderRows(ws);

		ws['!freeze'] = 'B6'; // set up floating columns/rows

		// Setup print settings
		if (!ws['!print']) {
			ws['!print'] = {};
		}
		ws['!print'].props = {
			orientation: 'landscape',
		};
		// eslint-disable-next-line no-useless-concat
		ws['!print'].footer = ('&C' + 'PAGE &P OF &N') + ('&R' + '&T &D');

		return ws;
	}

	private static formatCostSummaryExcelSheet(ws: WorkSheet) {
		if (!ws['!ref']) {
			return ws;
		}

		const range = XLSX.utils.decode_range(ws['!ref']);
		const wsCols = [];
		for (let rowNum = 4; rowNum <= range.e.r; ++rowNum) {
			for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
				if (colNum === 0) wsCols.push({ width: 50 });
				else wsCols.push({ width: 18 });
				const cell_address = { c: colNum, r: rowNum };
				const cell_ref = XLSX.utils.encode_cell(cell_address);
				if (ws[cell_ref]) {
					ws[cell_ref].s = {
						alignment: {
							vertical: 'center',
							horizontal: 'center',
							wrapText: true,
						},
						top: { style: 'thin' },
						bottom: { style: 'thin' },
						left: { style: 'thin' },
						right: { style: 'thin' },
					};

					if (this.CostSummaryHeaders.some(cell => cell.includes(ws[cell_ref].v.toString()))) {
						ws[cell_ref].s.fgColor = {
							rgb: '#F6F6F6',
						};
						ws[cell_ref].s.bold = true;
					}

					if (colNum === 4 || colNum === 0) {
						const firstColofRow = XLSX.utils.encode_cell({ c: 0, r: rowNum });
						if (ws[firstColofRow].v.toString() === 'SUB-TOTAL' || ws[firstColofRow].v.toString() === 'TOTAL' || (ws[firstColofRow].v.toString() === 'Top and Bottom Shutters (estimate)' && colNum === 4)) {
							ws[cell_ref].s.bold = true;
						}
					}

					if (colNum === 4 || colNum === 3) {
						ws[cell_ref].z = '[$$-C09]#,##0.00;[RED]-[$$-C09]#,##0.00';
					}

					if (colNum === 0) {
						ws[cell_ref].s.alignment.horizontal = 'left';
					}
				}
			}
		}
		ws['!cols'] = wsCols;

		DataExportUtils.formatHeaderRows(ws, 2);

		// Merge totals row at end of sheet
		DataExportUtils.mergeColumnsPerRow(ws, 1, range.e.r, 0, 3);

		// print settings
		if (!ws['!print']) {
			ws['!print'] = {};
		}
		// eslint-disable-next-line no-useless-concat
		ws['!print'].footer = ('&C' + 'PAGE &P OF &N') + ('&R' + '&T &D');

		return ws;
	}

	private static formatShuttersSheet(ws: WorkSheet, headers: dataExportHeader[]) {
		// Apply generic styles first
		ws = this.formatExcelSheets(ws, DataExportUtils.shutterHeaders, 2);

		// Add some extra styles to make shutter level columns smaller
		if (!ws['!ref']) {
			return ws;
		}

		const range = XLSX.utils.decode_range(ws['!ref']);
		const wsCols = [];
		for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
			wsCols.push({ width: headers[colNum].columnWidth || 6 });
		}
		ws['!cols'] = wsCols;

		// left-justify first column
		for (let rowNum = 5; rowNum <= range.e.r; ++rowNum) {
			const cell_address = { c: 0, r: rowNum };
			const cell_ref = XLSX.utils.encode_cell(cell_address);

			// We can only style cells if they exist
			if (!ws[cell_ref]) {
				ws[cell_ref] = {
					v: '',
				};
			}

			// Create object if they don't already exist
			ws[cell_ref].s = ws[cell_ref].s || {};
			ws[cell_ref].s.alignment = ws[cell_ref].s.alignment || {};

			ws[cell_ref].s.alignment.horizontal = 'left';
		}

		// add currency formatting
		for (let rowNum = 5; rowNum <= range.e.r; ++rowNum) {
			for (let colNum = range.s.c; colNum <= range.e.c; ++colNum) {
				const cell_address = { c: colNum, r: rowNum };
				const cell_ref = XLSX.utils.encode_cell(cell_address);

				if (colNum === 2 || colNum === 3 || colNum === 6 || colNum === 7) {
					ws[cell_ref].z = '[$$-C09]#,##0.00;[RED]-[$$-C09]#,##0.00';
				}
			}
		}

		return ws;
	}
}
